<template>
<div class="filters-container mb-3" ref="filterContainer">

    <div id="dataTableFilterConfig" class="filter-section-main" v-bind:class="{ hideblueline: isHideBlue }">
        <p class="color-red" v-if="isSetStartDate==false">Start Date filter is required.</p>
        <p class="color-red" v-if="isSetEndDate==false">End Date filter is required.</p>
            <div class="form-row">
              <template v-for="(column, index) in columnFilterArr">
                <template v-if="column.field != 'action' ">
                  <div class="col-md-9" :key="index">
                    <div class="form-row col-12 p-0">
                      <div class="form-group col-xl-4 col-lg-4" :id="'columnDiv'+index">
                        <v-select v-model="column.columnId" :searchable="false" :disabled="column.isColumnDisable"
                                  :noDrop="column.isColumnDisable" class="close-remove" :id="'selColumnField'+index"
                                  placeholder="Select Column"
                                  label="label"
                                  :options="parentColumns" @change="columnChanged($event, index)"
                                  @input="columnchange($event,index)">
                        </v-select>
                      </div>
                      <div class="form-group" :id="'conditionDiv'+index" style="width: 25%">
                        <v-select ref="filterSelectCondition" v-model="column.filterType" class="close-remove"
                                  :id="'selFilterType'+index" placeholder="Select Filter Type."
                                  label="text"
                                  :options="column.filterTypeArr" :searchable="false"
                                  @change="typecolumnchange($event,index)"
                                  :disabled="column.disableAll ? true : false"
                        >
                                        <span
                                          v-if="column.filterTypeArr == undefined || column.filterTypeArr == '' ? true : false"
                                          slot="no-options" @click="$refs.filterSelectCondition.open = false">
                                            Select Column First
                                        </span>
                        </v-select>
                      </div>
                      <div class="form-group filter-input-field col-lg-4 no-translate" :id="'filterInput'+index">
                        <input
                          v-if="column.disableAll ? true : false"
                          @keydown="checkIsIntegerField($event, column)"
                          :id="'vehicle_specs_locked_in' + index"
                          class="form-control"
                          type="text"
                          disabled
                          v-model="column.filterValue"
                        />
                        <input
                          v-else
                          @keydown="checkIsIntegerField($event, column)"
                          :id="'value_filter' + index"
                          class="form-control"
                          type="text"
                          v-model="column.filterValue"
                        />
                      </div>
                      <div class="form-group" :class="column.multiple ? 'col-xl-5 col-lg-5' : 'col-lg-4'"
                           :id="'filterOption'+index">
                        <div class='d-flex'>
                          <v-select class="no-translate" @search:blur="checkSearchedOption(index)"
                                    :ref="'selectOptionRef' + index"
                                    :style="column.multiple ? 'width:80%;' : 'width:100%;' "
                                    v-model="column.filterOptionValue" name="selectTimeZone"
                                    placeholder="Select Filter Value"
                                    label="text"
                                    :options="column.filterOption"
                                    @change="optionValueChanged($event, index)" :multiple='column.multiple'
                                    :closeOnSelect="!column.multiple"
                                    :disabled="column.disableAll ? true : false"
                          >
                          </v-select>
                          <div v-if="column.multiple" class="d-flex align-items-center form-check ml-1">
                            <input class="form-check-input mt-0"
                                   @change="selectAllMultipleSelectOptions($event, column.filterOption, index)"
                                   type="checkbox" value="" :id="'multipleOptionCheckbox_'+index"
                                   :disabled="column.disableAll ? true : false"
                            >
                            <label class="form-check-label" :for="'multipleOptionCheckbox_'+index"
                                   style="white-space: nowrap;margin-top: 1px;">
                              Select All
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 form-group date-picker-filter no-translate" :id="'filterDate'+index">
                        <date-picker onkeydown="return false" autocomplete="off" placeholder="MM/DD/YYYY"
                                     :id="'date_value_filter'+index" :name="'date_value_filter'+index"
                                     v-model="column.filterDateValue" :config="optionsDate"
                                     aria-describedby="basic-addon2"
                                     :disabled="column.disableAll ? true : false"></date-picker>
                      </div>
                      <div class="col-lg-4 form-group date-picker-filter no-translate" :id="'filterDateRange'+index">
                        <v-md-date-range-picker onkeydown="return false" :id="'date_range'+index"
                                                autocomplete="off" @change="handleChange($event,index,'auto')"
                                                show-year-select :presets="presets"
                                                :disabled="column.disableAll ? true : false"></v-md-date-range-picker>
                      </div>
                      <div :id="'duration'+index" class="col-lg-4 hide no-translate">
                        <template>
                          <div>
                            <div v-for="(dval,dkey) in durationArr" v-bind:key="dkey"
                                 class="filter-input-field d-inline-block" :id="'startDate'+index+dval"
                                 style="width: 48%;margin-right: 5px;position:relative;">
                              <!-- <input :id="'start_date_filter'+index" v-model="column.filterValue"  class="btn btn-default"  autocomplete="off"  v-on:click="onStartDateChange(index)" readonly> -->
                              <span :id="'start_date_filter'+index" class="btn btn-tertiary w-100" autocomplete="off"
                                    v-on:click="onStartDateChange(index+dval)">
                                                  &nbsp; <template
                                v-if="column.filterValue!=null &&  column.filterValue.length > 0">
                                                  {{ column.filterValue[dkey] }}
                                                  </template>
                                                  <template
                                                    v-if="startEndDateValueLabel[index+dval]!==null && (index+dval) in startEndDateValueLabel ">
                                                  ({{ startEndDateValueLabel[index + dval] }})
                                                  </template>
                                              </span>
                              <div :id="'startDateData'+index+dval" class="hide">
                                                  <span
                                                    class="card-body startdate bootstrap-datetimepicker-widget dropdown-menu usetwentyfour bottom"
                                                    style="top: 35px; bottom: auto; left: 15px; right: auto;">
                                                    <button type="button" class="close" data-dismiss="modal"
                                                            v-on:click="onStartDateChange(index+dval)">&times;</button>
                                                      <table aria-describedby="table"
                                                             class="table table-sm table-borderless">
                                                        <tbody>
                                                          <tr>
                                                              <td>
                                                                  <button type="button"
                                                                          class="btn btn-tertiary startbtndays startcatbtn"
                                                                          :id="'startbtndays'+index+dval"
                                                                          v-on:click="onSelecteStartDate('days',index,dval)">Days</button>
                                                                  <button type="button"
                                                                          class="btn btn-tertiary startbtnweeks startcatbtn"
                                                                          :id="'startbtnweeks'+index+dval"
                                                                          v-on:click="onSelecteStartDate('weeks',index,dval)">Weeks</button>
                                                                  <button type="button"
                                                                          class="btn btn-tertiary startbtnmonths startcatbtn"
                                                                          :id="'startbtnmonths'+index+dval"
                                                                          v-on:click="onSelecteStartDate('months',index,dval)">Months</button>
                                                                  <button type="button"
                                                                          class="btn btn-tertiary startbtnyears startcatbtn"
                                                                          :id="'startbtnyears'+index+dval"
                                                                          v-on:click="onSelecteStartDate('years',index,dval)">Years</button>
                                                              </td>
                                                          </tr>
                                                          <tr :id="'startdateCountlbl'+index+dval" class="startdatelbl">
                                                              <td><label
                                                                class="pull-left">Beginning Date : </label></td>
                                                          </tr>
                                                          <tr>
                                                              <td :id="'startdateCountstart'+index+dval" class="">
                                                                  <button type="button"
                                                                          class="btn btn-tertiary waves-effect pull-left"
                                                                          v-on:click="onAddRemoveBeginingStartDate('remove',index,dval)"> <i
                                                                    class="fp-left-arrow"
                                                                    style="font-size:15px;"></i></button>
                                                                  <label> {{ startDateCount[index + dval] }} </label>
                                                                  <button type="button"
                                                                          class="btn btn-tertiary waves-effect pull-right"
                                                                          v-on:click="onAddRemoveBeginingStartDate('add',index,dval)"> <i
                                                                    class="fp-right-arrow" style="font-size:15px;"></i></button>
                                                              </td>
                                                          </tr>
                                                          <tr :id="'startdateCountendlbl'+index+dval"
                                                              class="startdatelbl">
                                                              <td><label class="pull-left">End Date : </label></td>
                                                          </tr>
                                                          <tr>
                                                              <td :id="'startdateCountend'+index+dval" class="">
                                                                  <button type="button"
                                                                          class="btn btn-tertiary waves-effect pull-left"
                                                                          v-on:click="onAddRemoveEndStartDate('remove',index,dval)"><i
                                                                    class="fp-left-arrow" style="font-size:15px;"> </i></button>
                                                                  <label> {{ startDateCountEnd[index + dval] }} </label>
                                                                  <button type="button"
                                                                          class="btn btn-tertiary waves-effect pull-right"
                                                                          v-on:click="onAddRemoveEndStartDate('add',index,dval)"> <i
                                                                    class="fp-right-arrow" style="font-size:15px;"> </i></button>
                                                              </td>
                                                          </tr>
                                                          <tr>
                                                              <td style="border-top:1px solid #ddd"><strong
                                                                class="font-bold">{{ startdateLabel[index + dval] }}</strong></td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                  </span>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div :id="'month_period'+index" class="col-lg-4 hide no-translate">
                        <template>
                                        <span :id="'period_filter'+index" class="btn btn-tertiary w-100"
                                              autocomplete="off" v-on:click="onDateChange(index)">
                                            <template v-if="column.filterValue!=null &&  column.filterValue.length > 0">
                                                {{ column.filterValue }}
                                            </template>
                                            <template v-else>
                                                {{ number }}
                                            </template>
                                        </span>
                          <div :id="'start_DateData'+index" class="hide">

                                            <span
                                              class="card-body startdate bootstrap-datetimepicker-widget dropdown-menu usetwentyfour bottom"
                                              style="top: 35px; bottom: auto; left: 15px; right: auto;">
                                            <button type="button" class="close" data-dismiss="modal"
                                                    v-on:click="onDateChange(index)">&times;</button>
                                                <table aria-describedby="table" border="0" cellpadding="0"
                                                       cellspacing="0" class="">
                                                    <tbody>
                                                        <tr :id="'startdateCountlbl'+index" class="startdatelbl">
                                                            <td colspan="2"><label
                                                              class="pull-left">Beginning Date : </label></td>
                                                        </tr>
                                                        <tr>
                                                            <td :id="'startdateCount'+index" class="">
                                                                <button type="button" class="btn btn-tertiary pull-left"
                                                                        v-on:click="addNumber('remove',index)"> <i
                                                                  class="fp-left-arrow"
                                                                  style="font-size:24px;"></i></button>
                                                                <label style="font-size:14px;"><template
                                                                  v-if="column.filterValue!=null &&  column.filterValue.length > 0">
                                                                    {{ column.filterValue }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ number }}
                                                                </template> </label>
                                                                <button type="button"
                                                                        class="btn btn-tertiary pull-right"
                                                                        v-on:click="addNumber('add',index)"> <i
                                                                  class="fp-right-arrow"
                                                                  style="font-size:24px;"></i> </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </span>
                          </div>
                        </template>
                      </div>
                      <div class="col-lg-4 filter-input-field hide no-translate" :id="'startDate'+index">
                        <!-- <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 filter-input-field hide " :id="'startDate'+index"> -->
                        <!-- <input :id="'start_date_filter'+index" v-model="column.filterValue"  class="btn btn-default"  autocomplete="off"  v-on:click="onStartDateChange(index)" readonly> -->
                        <span :id="'start_date_filter'+index" class="btn btn-tertiary w-100" autocomplete="off"
                              v-on:click="onStartDateChange(index)"> &nbsp; {{ column.filterValue }}
                                        <template
                                          v-if="startEndDateValueLabel.length > 0 && index in startEndDateValueLabel && startEndDateValueLabel[index]!=''">
                                        ({{ startEndDateValueLabel[index] }})
                                        </template>
                                    </span>
                        <div :id="'startDateData'+index" class="hide">
                                        <span
                                          class="card-body startdate bootstrap-datetimepicker-widget dropdown-menu usetwentyfour bottom"
                                          style="top: 35px; bottom: auto; left: 15px; right: auto;">
                                          <button type="button" class="close" data-dismiss="modal"
                                                  v-on:click="onStartDateChange(index)">&times;</button>
                                            <table aria-describedby="table" border="0" cellpadding="0" cellspacing="0"
                                                   class="">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <button type="button"
                                                                    class="btn btn-tertiary startbtndays startcatbtn"
                                                                    v-on:click="onSelecteStartDate('days',index)">Days</button>
                                                            <button type="button"
                                                                    class="btn btn-tertiary startbtnweeks startcatbtn"
                                                                    v-on:click="onSelecteStartDate('weeks',index)">Weeks</button>
                                                            <button type="button"
                                                                    class="btn btn-tertiary startbtnmonths startcatbtn"
                                                                    v-on:click="onSelecteStartDate('months',index)">Months</button>
                                                            <button type="button"
                                                                    class="btn btn-tertiary startbtnyears startcatbtn"
                                                                    v-on:click="onSelecteStartDate('years',index)">Years</button>
                                                            <button type="button" :id="'startcalander'+index"
                                                                    class="btn btn-tertiary startcalanderbtn"
                                                                    v-on:click="showhideCalander('startdate',index)"><i
                                                              class="fp-calendar"></i></button>
                                                        </td>
                                                    </tr>
                                                    <tr :id="'startdateCountlbl'+index" class="startdatelbl">
                                                        <td colspan="2"><label
                                                          class="pull-left">Beginning Date : </label></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2" :id="'startdateCountstart'+index" class="">
                                                            <button type="button" class="btn btn-tertiary pull-left"
                                                                    v-on:click="onAddRemoveBeginingStartDate('remove',index)"> <i
                                                              class="fp-left-arrow"
                                                              style="font-size:24px;"></i></button>
                                                            <label
                                                              style="font-size:14px;"> {{ startDateCount[index] }} </label>
                                                            <button type="button" class="btn btn-tertiary pull-right"
                                                                    v-on:click="onAddRemoveBeginingStartDate('add',index)"> <i
                                                              class="fp-right-arrow"
                                                              style="font-size:24px;"></i> </button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2" :id="'filterstartDate'+index" class="hide"
                                                            style="position:relative">
                                                            <date-picker autocomplete="off" class=""
                                                                         placeholder="MM/DD/YYYY"
                                                                         v-model="startdatePickerValue[index]"
                                                                         :key="index"
                                                                         @input="startDateValueChange(index)"
                                                                         :config="optionsDate"
                                                                         aria-describedby="basic-addon2"
                                                                         :disabled="column.disableAll ? true : false"
                                                            ></date-picker>
                                                        </td>
                                                    </tr>
                                                    <tr :id="'startdateCountendlbl'+index" class="startdatelbl">
                                                        <td colspan="2"><label
                                                          class="pull-left">End Date : </label></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2" :id="'startdateCountend'+index" class="">
                                                            <button type="button" class="btn btn-tertiary pull-left"
                                                                    v-on:click="onAddRemoveEndStartDate('remove',index)"> <i
                                                              class="fp-left-arrow"
                                                              style="font-size:24px;"></i> </button>
                                                            <label
                                                              style="font-size:14px;"> {{ startDateCountEnd[index] }} </label>
                                                            <button type="button" class="btn btn-tertiary pull-right"
                                                                    v-on:click="onAddRemoveEndStartDate('add',index)"> <i
                                                              class="fp-right-arrow"
                                                              style="font-size:24px;"></i> </button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2" style="border-top:1px solid #ddd"><strong
                                                          class="font-bold">{{ startdateLabel[index] }}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </span>
                        </div>
                      </div>
                      <div v-show="removeLineButtonVisibility && !(column.disableAll ? true : false)">
                        <template
                          v-if="moduleName!='rentalUtilizationEquipment' && moduleName != 'SubDaysInPeriodReport' && moduleName != 'rentalActivityWithRatesReport' && moduleName != 'inventoryReport' && moduleName != 'reservationReport'  && moduleName != 'contractEquipmentUtilization' && moduleName != 'weeklyRentalReport' && moduleName != 'debtNoteRollForward' && moduleName != 'rentalActivityReport'">
                          <div class="add-remove-filter-btn">
                            <template v-if="columnFilterArr.length != 1">
                              <template
                                v-if="column.columnId == null || (column.columnId!=null && (column.columnId.fpMandatory == undefined || (column.columnId.fpMandatory != undefined && column.columnId.fpMandatory === false)))">
                                <a href="javascript:void(0)" v-on:click="removeLine($event,index)"> <i
                                  class="fp-close"></i> </a>
                              </template>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <div class="add-remove-filter-btn">
                            <template
                              v-if="columnFilterArr.length != 1 && (column.columnId == null || (column.columnId!=null && column.columnId.field != 'start_date' && column.columnId.field != 'end_date' && column.columnId.field != 'as_at_date' && column.columnId.field != 'as_of_year' && column.columnId.field != 'as_of_period'))">
                              <a href="javascript:void(0)" v-on:click="removeLine($event,index)"> <i
                                class="fp-close"></i> </a>
                            </template>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div :key="'cl'+index"></div>
                </template>
              </template>

                <div class="col-lg-3 text-right">
                    <button id="search_button" type="submit" value="Search" class="btn btn-primary" v-on:click.prevent="onColumnFilter('load')" >
                        <i class="fp-search"> </i>Search
                    </button>
                    <button v-if="tempFilterId === 0" type="submit" class="btn btn-tertiary" v-on:click.prevent="onColumnFilter('cancel')" >
                        <i class="fp-refresh"> </i>Reset
                    </button>
                    <div class="data-table text-left pull-right">
                        <div class="column-icon-btn pull-right" v-if="moduleName!='fuelPriceAssetList' && moduleName!='fuelPriceCustomerList' && moduleName!='telematicListAssetView'">
                            <a href="javascript:void(0)" @click="openNav" > <i class="fp-controls"></i> </a>
                        </div>
                        <div class="internal-page-btn">

                            <div id="ColumnList" class="common-column-list">
                                <div class="column-top-section">
                                <!-- <h3> Configure Column </h3> -->
                                <!-- <a href="javascript:void(0)" class="closebtn" @click="closeNav">×</a> -->
                                </div>
                                <div class="checkbox">
                                    <h3> Configure Column </h3>
                                    <draggable v-model="columnConfigArr" group="people" @start="drag=true" @end="drag=false" @change="dragRow">
                                        <template v-for="(prColumns, indConfig) in columnConfigArr" >
                                            <!--todo: if the !prColumns.hidden condition is removed, the column configuration will not be removed.-->
                                          <template v-if="prColumns.field != 'action' && prColumns.field != 'id'">
                                          <div :class="'checkbox-custome-fl '+indConfig" :key="'ck-'+indConfig">

                                                    <label class="custome-checkbox">{{prColumns.label}}
                                                    <input type="checkbox" :checked="!prColumns.hidden" v-on:change="showListColumn($event,indConfig)">
                                                    <span class="checkmark"></span>
                                                    </label>
                                                    <img class="drag-icon" src="/static/images/dragicon.png" alt="drag">

                                                </div>
                                            </template>
                                        </template>
                                    </draggable>
                                    <div class="mt-3">
                                        <button type="button" v-if="!fromSchedule" id="saveColumnConfigBtn" @click="storeColumnConfig" class="btn btn-primary" >
                                            <i class="fp-save"> </i>  Save
                                        </button>
                                        <button type="button" id="cancelColumnConfigBtn" @click="cancelColumnConfig" class="btn btn-tertiary" >
                                            <i class="fp-close"> </i>  Close
                                        </button>
                                        <button v-if="isColumnConfig" type="button" id="defaultConfigBtn" @click="setDefault" class="btn btn-secondary" >
                                            <i class="fp-rotate"> </i> Set Default
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-8">
                    <a v-show="addFilterButtonVisibility" class="btn btn-primary" href="javascript:void(0)" v-on:click="addLine()"> <i class="fp-add"></i>Add Filter </a>
                </div>
                <div class="col-lg-4 text-right" v-if="tempFilterId === 0">
                    <button v-if="!filterSearchFlag && moduleName != 'fuelPriceCustomerList' && moduleName != 'fuelPriceAssetList'" type="submit" class="btn btn-tertiary" v-on:click="enableFilterSearch()">
                        <i class="fp-filter"></i>Filter
                    </button>
                    <div class="form-row" v-if="filterSearchFlag ">
                        <div class="pull-right col-md-10 offset-md-2">
                            <div class="dropdown pull-right filter-dropdown">
                                <button v-on:click="performAction('private')" class="btn btn-primary pull-left" type="button" aria-haspopup="true" aria-expanded="false" style="border-top-right-radius: 0;border-bottom-right-radius: 0;">
                                    Store
                                </button>
                                <!-- <button type="button" v-on:click="performAction('store_private')" class="btn btn-primary">Store</button>
                                <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                                <span class="caret"></span>
                                </button> -->
                                <button class="btn btn-primary dropdown-toggle pull-left" id="dropdownMenuButton" data-toggle="dropdown" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><span class="caret"></span></button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="performAction('private')">Store Private</a>
                                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="performAction('public')">Store Shared</a>
                                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="performAction('default')">Set As Default</a>
                                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="performAction('remove')">Remove</a>
                                </div>
                            </div>
                            <v-select v-model="searchFilter" name="search_filter"
                                label="text" :filterable="false" :taggable="true" :options="filterOption"
                                placeholder="Select Search Filter" class="custom-ci-auto-search pull-right w-75 mr-2">
                                <template slot="no-options">
                                    Search Filter Name...
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.text }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.text }}
                                    </div>
                                </template>
                            </v-select>
                        </div>

                    </div>

                    <span class="field-error" style="margin-left:15px;" v-if="isDuplicateColumn">Please remove duplicate column with same value from filters.</span>
                    <span class="field-error" style="margin-left:15px;">{{filterMaxError}}</span>
                </div>
            </div>

            <div class="form-row" v-if="moduleName != 'fuelPriceCustomerList' && moduleName != 'fuelPriceAssetList'">
                <div class="col-md-8">
                    <div class="alert alert-success alert-dismissible mt-3 mb-0" role="alert" v-show="selectAllDiv">
                        <button type="button" class="close" @click="selectAllDiv = false" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        All records of this page have been selected. For selecting {{allRecords}} records <a href="javascript:void(0)" @click="selectAllRecords" class="color-blue underline">Click Here</a> | <a @click="cancelSelectAll" href="javascript:void(0)" class="color-blue underline">Cancel</a>
                    </div>
                    <div class="alert alert-success alert-dismissible mt-3 mb-0" role="alert" v-show="clearSelection">
                        <button type="button" class="close" @click="clearSelection = false" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        {{allRecords}} records have been selected. For clear selection <a href="javascript:void(0)" @click="clearSelectAll" class="color-blue underline">Click Here</a>
                    </div>
                    <div class="alert alert-success alert-dismissible mt-3 mb-0" role="alert" v-show="selectionAllClear && !selectAllDiv">
                        <button type="button" class="close" @click="selectionAllClear = false" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        All Selected rows cleared
                    </div>
                </div>
            </div>
    </div>
</div>
</template>

<script>

    import Vue from 'vue';
    import VMdDateRangePicker from "v-md-date-range-picker";
    Vue.use(VMdDateRangePicker);
    import {contractMixins} from '../mixins/contractMixins';
    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from "../mixins/dataTableMixins";
    import EventBus from './event-bus';
    import moment from 'moment';
    import draggable from 'vuedraggable';
    var contex;

    export default {
        name: "dataTableFilterConfig",
        mixins:[contractMixins,commonMixins,dataTableMixins],
        props: {
            moduleName: {
                type: String,
                required: false,
                default:undefined
            },
            fromDashboard:{
                type: String,
                required: false,
                default:undefined
            },
            allowSameFilter:{
                type: String,
                required: false,
                default:undefined
            },
            fromSchedule:{
                type: String,
                required: false,
                default:undefined
            },
            routeSelId:{
                type: Number,
                required: false,
                default:undefined
            },
            addFilterButtonVisibility:{
                type: Boolean,
                required: false,
                default: true
            },
            removeLineButtonVisibility:{
                type: Boolean,
                required: false,
                default: true
            },
            tempFilterId:{
              type: Number,
              required: false,
              default:0
            },
        },
        components: {
            draggable,
        },
        data: () => ({
            isHideBlue: false,
            parentFilters:[],
            parentColumns:[],
            columnConfigArr:[],
            columnList:false,
            columnArr:[],
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            isColumnConfig:false,
            filterOption:[],
            rangedate:"",
            presets: [ {
                        label: 'Last 7 Days',
                        range: [
                            moment().subtract(6, 'day'),
                            moment()
                            ]
                        },
                        {
                        label: 'Last 30 Days',
                        range: [
                            moment().subtract(29, 'day'),
                            moment()
                            ]
                        },
                        {
                        label: 'This Month',
                        range: [
                            moment().startOf('month'),
                            moment().endOf('month')
                            ]
                        },
                        {
                        label: 'Last Month',
                        range: [
                            moment().subtract(1, 'month').startOf('month'),
                            moment().subtract(1, 'month').endOf('month')
                            ]
                        },

                    ],
            date: null,
            flag:'input',
            filterTypeArr:[],
            optionArr:[{ value: '=', text: 'is'}, { value: '!=', text: 'is not'}],
            isArr:[{ value: '=', text: 'is'}],
            // textArr:['das':'contains'/*,'doesnt contains','starts with','ends with','is null','is not null'*/],
            textArr : [{ value: 'like', text: 'contains'},{ value: 'not like', text: 'does not contain'}],
            reportTextArr : [{ value: 'like', text: 'contains'},{ value: 'not like', text: 'does not contain'},{ value: 'IS NULL', text: 'is null'},{ value: 'IS NOT NULL', text: 'is not null'}],
            numberArr:[{ value: '=', text: 'is'}, { value: '!=', text: 'is not'}],
            dateArr: [{ value: '=', text: 'is'}, { value: 'IS NULL', text: 'is null'}, { value: '<', text: 'before'}, { value: '>', text: 'after'},{ value: 'between', text: 'between'}],
            integerArr:[{value:'<',text:'less than'},{value:'>',text:'greater than'},{value:'=',text:'is equal'},{value:'!=',text:'is not equal'},{value:'<=',text:'less than equal'},{value:'>=',text:'greater than equal'}],
            assetAvailabilityArr: [{ value: 'between', text: 'between'}],
            number :0,
            showBtwDate: false,
            disableDateFilter: false,
            locationArr:[],
            insLocationArr:[],
            warehouseArr:[],
            vehicleTypeArr:[],
            permitTypeArr:[],
            moduleArr:[],
            activityModuleArr:[],
            activityTypeArr:[],
            unitReadingsSectionArr:[],
            sectionArr:[],
            addedByArr:[],
            reservationStatusArr:[],
            priorityArr:[],
            assetPoolArr:[],
            workOrderStatusArr:[],
            customerResponseStatusArr:[],
            customerResponseTypeArr:[],
            assetFeatureCategoryArr:[],
            businessTypeArr:[],
            selectedFilter: '',
            forFilter: '',
            locFlag:false,
            requestArr : [],
            ownershipArr:[],
            locLabel:'',
            removedListColumn:[],
            isTypeChange:true,
            emailReportTypeArr:[
                                {text:'Past Due Notices',value:'past_due_notice_email'},
                                {text:'Courtesy Notices',value:'courtesy_notice_email'},
                                {text:'ACH Notices',value:'ach_notice_email'},
                                {text:'Odometer Reading',value:'odometer_reading'},
                                {text:'Customer Estimate',value:'customer_estimate'},
                                {text:'Vendor Estimate',value:'vendor_estimate'},
                                {text:'New Customer Register',value:'new_customer_register'},
                                {text:'Notify Customer Register',value:'notify_customer_register'},
                                {text:'Permit Invoice',value:'permit_invoice'},
                                {text:'FHUT Invoice',value:'hvut_invoice'},
                                {text:'Lease Invoice',value:'lease_invoice'},
                                {text:'Work Order Invoice',value:'work_order_invoice'},
                                {text:'Customer Statement',value:'customer_statement'},
                                {text:'Customer Refund',value:'customer_refund'},
                                {text:'Vendor Purchase Order',value:'vendor_purchase_order'},
                                {text:'Insurance Policy Expiration',value:'insurance_policy_expiration'},
                                {text:'Vendor Remittance',value:'vendor_remittance'},
                                {text:'Credit Detail Request',value:'credit_detail_request_email'},
                                {text:'Fuel Bill',value:'fuel_bill'},
                                {text:'Manual Charge',value:'manual_charge'},
                                {text:'Ach Detail Request',value:'ach_detail_request_email'},
                                {text:'Vendor Email',value:'vendor_email'},
                                {text:'Rental Invoice',value:'rental_invoice'},
                                {text:'Vendor Invoice',value:'vendor_invoice'}],

            noteTypesArr:[
                                {text:'Credit Note',value:'credit_note'},
                                {text:'Debit Note',value:'debit_note'},
            ],
            notesStatusArr:[
                                {text:'Draft',value:'draft'},
                                {text:'Pending Approval',value:'pending_approval'},
                                {text:'Approved',value:'approved'},
                                {text:'Closed',value:'closed'},
                                {text:'Void',value:'void'},
            ],
            billStatusArr:[
                                {text:'Entered',value:'entered'},
                                {text:'Verified',value:'verified'},
                                {text:'Approved',value:'approved'},
                                // {text:'Disapproved',value:'disapproved'},
                                {text:'Paid',value:'paid'},
                                {text:'Void',value:'void'},
                                {text:'Confirmed',value:'confirmed'},
                                {text:'In Progress',value:'in progress'},
                                {text:'Closed',value:'closed'},
            ],
            journalModulesArr:[
                                {text:'Asset',value:'asset'},
                                {text:'Work Order',value:'work order'},
                                {text:'Asset Permit',value:'asset permit'},
                                {text:'FHUT Schedule',value:'hvut_schedule'},
                                {text:'Invoice',value:'invoice'},
                                {text:'Vendor Invoice',value:'vendor invoice'}
            ],
            journalStatusArr:[
                                {text:'Draft',value:'draft'},
                                {text:'Posted',value:'posted'},
            ],
            checkStatusArr:[
                                {text:'Active',value:'active'},
                                {text:'Void',value:'void'},
                                {text:'In Progress',value:'in progress'},
                                {text:'Print',value:'print'},
                                {text:'Cancel',value:'cancel'},
            ],
            transportRequestLocArr: [
                                {value: "CITY OF INDUSTRY",text: "CITY OF INDUSTRY"},
                                {value: "Rancho Dominguez",text: "Rancho Dominguez"},
                                {value: "FONTANA",text: "FONTANA"},
                                {value: "SAN DIEGO",text: "SAN DIEGO"},
                                {value: "TOLLESON",text: "TOLLESON"},
                                {value: "CHANDLER",text: "CHANDLER"},
                                {value: "TUCSON",text: "TUCSON"},
                                {value: "Customer",text: "Customer"}
            ],
            getBackArr: [
                                {value: "lyft",text: "Lyft"},
                                {value: "truck_back",text: "Truck back"}
            ],
            vendorPaymentStatusArr:[
                                {text:'Pending',value:'pending'},
                                {text:'Void',value:'void'},
                                {text:'Confirmed',value:'confirmed'},
                                {text:'Printed',value:'printed'},
                                {text:'Closed',value:'closed'},
            ],
            checkTypesArr: [
                                {value: "ach",text: "ACH"},
                                {value: "check",text: "Check"},
                                {value: "comcheck",text: "Comcheck"}
            ],
            pricingTypeArr: [
                                {value: "system_override",text: "System Override"},
                                {value: "customer_override",text: "Customer Override"},
                                {value: "customer_class_override",text: "Customer Class Override"},
                                {value: "customer_contract_override",text: "Customer/Contract Override"},
                                {value: "unit_override",text: "Unit Override"},
                                {value: "location_override",text: "Location Override"}
            ],
            priceTypeArr: [
                                {value: "sales_price",text: "Sales Price"},
                                {value: "amount_over_cost",text: "Amount Over Cost"},
                                {value: "percent_over_cost",text: "% Over Cost"},
            ],
            policyTypesArr:[
                                {text:'Physical',value:'physical'},
                                {text:'Liability',value:'liability'},
                                {text:'Both',value:'both'}
            ],
            permitOwnerArr:[
                                {value:'Company',text:'Company'},
                                {value:'Customer',text:'Customer'},
            ],
            batchStatusArr:[
                                {value:'in_progress',text:'In Progress'},
                                {value:'completed',text:'Completed'},
                                {value:'error',text:'Error'},
            ],
            policyStatusArr:[
                                {value:'active',text:'Active'},
                                {value:'expired',text:'Expired'},
                                {value:'pending',text:'Pending'}
            ],
            laborPricingTypeArr: [
                                {value: "customer_override",text: "Customer Override"},
                                {value: "customer_class_override",text: "Customer Class Override"},
                                {value: "customer_contract_override",text: "Customer/Contract Override"},
                                // {value: "unit_override",text: "Unit Override"},
                                {value: "location_override",text: "Location Override"}
            ],
            noteCategoryArr:[
                                {value:'receivable',text:'Receivable'},
                                {value:'payable',text:'Payable'},
                                {value:'general ledger',text:'General Ledger'},
                                {value:'other',text:'Other'},
            ],
            contactTypeArr:[
                                {value:'I',text:'I - Invoices(all)'},
                                {value:'IF',text:'IF - Invoices-Fuel (all)'},
                                {value:'IFB',text:'IFB - Invoices-Fuel Bill'},
                                {value:'IFH',text:'IFH - Invoices-Fuel HVUT'},
                                {value:'IFP',text:'IFP - Invoices-Fuel Permit'},
                                {value:'IFT',text:'IFT - Invoices-Fuel Tax'},
                                {value:'IND',text:'IND - Invoices-Disposal'},
                                {value:'INM',text:'INM - Invoices-Manual Charge'},
                                {value:'INR',text:'INR - Invoices-Contract'},
                                {value:'INS',text:'INS - Fax-Insurance'},
                                {value:'INV',text:'INV - Invoices-Shop'},
                                {value:'ISW',text:'ISW - Fax-Invoices-SWD'},
                                {value:'MLS',text:'MLS - Mileage Readings'},
                                {value:'PM',text:'PM - PM'},
                                {value:'STM',text:'STM - Statements'},
                                {value:'invoices',text:'invoices - Invoice'},
                                {value:'cpi_rate_increase_mail',text:'cpi_rate_increase_mail - CPI Rate Increase Notification'},
                                {value:'maintenance_mail',text:'maintenance_mail - Maintenance'},

            ],
            selectAllDiv:false,
            allRecords:0,
            clearSelection:false,
            contractTypeArr:[],
            checkListActionArr:[],
            accountTypesArr:[],
            invoiceTypesArr:[],
            hvutCategoriesArr:[],
            financialPeriodsArr:[],
            vehicleManufacturerArr:[],
            vehicleModelArr:[],
            columnFilterArr:[{
                filterType:null,
                filterValue: null,
                filterDateValue: null,
                columnId: null,
                isColumnDisable:false
            }],
            selectionAllClear:false,
            filterMaxError:'',
            isDuplicateColumn:false,
            readingFoundArr:[
                                {text:'Yes',value:'yes'},
                                {text:'No',value:'no'},
            ],
            customerClassArr:[],
            componentArr:[],
            searchFilter:'',
            onsearchFilterFlag:false,
            customRangeArr :[],
            filterSearchFlag:false,
            glSrcCodesArr:[],
            scheduleTypeArr:[],
            startDateVal:[],
            startDateCount:[],
            startdateLabel:[],
            startdateCategory:[],
            startdatePickerValue:[],
            startDateCountEnd:[],
            isSetStartDate:true,
            isSetEndDate:true,
            etkDateFilter:false,
            loginUserLocation:[],
            startEndDateValueLabel:[],
            durationArr:['startduration','endduration'],
            durationRange:[],
            costCodeArr:[],
            assetWarrantyStatusArr:[{value:'yes',text:'Yes'},{value:'no',text:'No'}],
            vendorTaxableArr:[{value:'yes',text:'Yes (Y)'},{value:'no',text:'No (N)'}],
            programCategoryArr:[{text:'INSPEC | Inspection',value:'i'},
            {text:'MAINT | Maintenance',value:'m'},
            {text:'SAFETY | Recalls',value:'s'},
            {text:'All',value:'all'}],
            paymentOptionsArr:[],
            appTypeArr:[{text:'INV',value:'inv'},{text:'MISC',value:'misc'},{text:'O/A',value:'on_account'}],
            storeSearchEnable:false,
            costTypesArr:[],
            rateTypesArr:[],
            notificationTypesArr:[],
            customDateArr:[{value:'=',text: 'is'},{value:'!=',text: 'is not'},{ value: '<', text: 'before'},{ value: '<=', text: 'before / is'},
            { value: '>', text: 'after'},{ value: '>=', text: 'after / is'},{ value: 'between', text: 'between'},{ value: 'not between', text: 'not between'},
            {value: 'IS NULL',text: 'is null'},{value: 'IS NOT NULL',text: 'is not null'},{value: 'duration',text: 'duration'}],
            billableCodeArr:[],
            componentCategoryArr:[],
            evCustomerOrderTypeArr: [
              {value:"Custom",text:"Custom"},
              {value:"In Stock",text:"In Stock"},
              // {value:"Only Extended Warranty",text:"Only Extended Warranty"},
            ],
            evBatterySizeArr:[
              {value: "M",text: "M"},
              {value: "L",text: "L"},
            ],
            evPtoArr:[
              {value: "Yes, General",text: "Yes, General"},
              {value: "No",text: "No"},
              {value: "Yes, Reefer",text: "Yes, Reefer"},
            ],
            evExtendedWarrantyArr:[
              {value: "Yes",text: "Yes"},
              {value: "No",text: "No"},
            ],
            widthCheckTimes: 0,
            originalColumnClasses: {},
            divWidth: 0,
            vehicleOptionCodesArr: [],
        }),
        beforeMount: function() {
            contex = this;
        },
        watch:{

            searchFilter:function(val){
                var self = this;
                  //load filters on select any filter key
                  self.$parent.loading=true;
                  $.ajax({
                      url: process.env.ROOT_API + "/fetch-filters-by-search",
                      type: "GET",
                      headers: this.ajxHeaders,
                      data:{
                          search:val,
                      },
                      dataType: "json",
                      success: function (data) {
                          self.$parent.loading = false;
                          if (data.status == "success") {
                              self.columnFilterArr = [];
                              var contentArr = data.content;
                              if (contentArr && contentArr.length > 0){
                                  // for(var i = 0; i < contentArr.length; i++){
                                      var i = 0;
                                      contentArr.forEach(contentArr => {

                                      self.isTypeChange = false
                                      self.onsearchFilterFlag = true;

                                            $("#filterInput"+i).addClass('hide');
                                            $("#filterOption"+i).addClass('hide');
                                            $("#filterDate"+i).addClass('hide');
                                            $("#filterDateRange"+i).addClass('hide');
                                            $("#duration"+i).addClass('hide');
                                            $("#month_period"+i).addClass('hide');

                                            if ( contentArr.columnId.fpFieldType == 'option') {
                                                self.columnFilterArr.push({
                                                    filterType:contentArr.filterType,
                                                    columnId: contentArr.columnId,
                                                    isColumnDisable:contentArr.isColumnDisable,
                                                    filterTypeArr:contentArr.filterTypeArr,
                                                    filterOptionValue:contentArr.filterOptionValue,
                                                    filterOption:contentArr.filterOption,
                                                    multiple: contentArr.multiple != undefined ? contentArr.multiple : false,
                                                });
                                                var l = i;
                                                setTimeout(function(){
                                                    $("#filterOption"+l).removeClass('hide');
                                                    $("#filterInput"+l).addClass('hide');
                                                    $("#filterDate"+l).addClass('hide');
                                                    $("#filterDateRange"+l).addClass('hide');
                                                    $("#duration"+l).addClass('hide');
                                                    $("#month_period"+l).addClass('hide');
                                                },100);

                                      }

                                      if(contentArr.columnId.fpFieldType == 'text'){
                                          // alert('ehe.,o');
                                          self.columnFilterArr.push({
                                              filterType:contentArr.filterType,
                                              filterValue: contentArr.filterValue,
                                              columnId: contentArr.columnId,
                                              isColumnDisable:contentArr.isColumnDisable,
                                              filterTypeArr:contentArr.filterTypeArr,
                                          });
                                          var k = i;


                                          if((self.columnFilterArr[i].columnId.field=='start_date' || self.columnFilterArr[i].columnId.field=='end_date') && (self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == 'fuelTicketList' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == 'rentalActivityWithRatesReport' || self.moduleName == 'depreciationReviewReport' || self.moduleName == 'reservationReport' || self.moduleName == 'contractEquipmentUtilization' || self.moduleName == 'weeklyRentalReport' || self.moduleName == 'debtNoteRollForward' || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'rentalActivityReport' || self.moduleName == 'equipmentaccountingrecords')){

                                                    self.calculateStateEndDateValue(k,self.columnFilterArr[i].filterValue);
                                                    setTimeout(function(){
                                                        $("#filterInput"+k).addClass('hide');
                                                        $("#filterOption"+k).addClass('hide');
                                                        $("#filterDate"+k).addClass('hide');
                                                        $("#filterDateRange"+k).addClass('hide');
                                                        $("#startDate"+k).removeClass('hide');
                                                        $("#duration"+k).addClass('hide');
                                                        $("#month_period"+k).addClass('hide');
                                                        },100);
                                                }else{

                                                    setTimeout(function(){
                                                        $("#filterInput"+k).removeClass('hide');
                                                        $("#filterOption"+k).addClass('hide');
                                                        $("#filterDate"+k).addClass('hide');
                                                        $("#filterDateRange"+k).addClass('hide');
                                                        $("#startDate"+k).addClass('hide');
                                                        $("#duration"+k).addClass('hide');
                                                        $("#month_period"+k).addClass('hide');
                                                    },100);
                                                }

                                      }
                                      if(contentArr.columnId.fpFieldType == 'date'){
                                          if (contentArr.filterType.value == 'duration'){
                                              self.columnFilterArr.push({
                                                  filterType:contentArr.filterType,
                                                  filterValue: contentArr.filterValue,
                                                  columnId: contentArr.columnId,
                                                  isColumnDisable:contentArr.isColumnDisable,
                                                  filterTypeArr:contentArr.filterTypeArr,
                                                  });

                                              var d = i;

                                                    self.calculateStateEndDateValue(d+"startduration",contentArr.filterValue[0]);
                                                    self.calculateStateEndDateValue(d+"endduration",contentArr.filterValue[1]);
                                                    self.durationRange[d]=contentArr.filterValue;
                                                    setTimeout(function(){
                                                        $("#filterOption"+d).addClass('hide');
                                                        $("#filterInput"+d).addClass('hide');
                                                        $("#filterDate"+d).addClass('hide');
                                                        $("#filterDateRange"+d).addClass('hide');
                                                        $("#duration"+d).removeClass('hide');
                                                        $("#month_period"+d).addClass('hide');
                                                    },100);
                                                }else{
                                                    self.columnFilterArr.push({
                                                        filterType:contentArr.filterType,
                                                        filterDateValue: (contentArr.filterDateValue != null && contentArr.filterDateValue != undefined ? contentArr.filterDateValue : null),
                                                        columnId: contentArr.columnId,
                                                        isColumnDisable:contentArr.isColumnDisable,
                                                        filterTypeArr:contentArr.filterTypeArr,
                                                        filterDateRangeValue:null
                                                    });

                                              var selectedDateArr = '';
                                              if (contentArr.filterType.value == 'between'){
                                                  var s= 0;
                                                  if(contentArr.filterDateRangeValue != null && contentArr.filterDateRangeValue.length > 0){

                                                        contentArr.filterDateRangeValue.forEach(filterDateRangeValue => {

                                                        // for( var s=0; s<contentArr.filterDateRangeValue.length; s++ ) {

                                                            if (s == 0 ){

                                                                selectedDateArr = filterDateRangeValue;
                                                                // $("#date-range"+i).attr('startDate',contentArr[i].filterDateRangeValue[j]);

                                                            }else{

                                                                selectedDateArr += ' - '+filterDateRangeValue;

                                                            }
                                                            s++;
                                                        });
                                                    }

                                                  self.handleChange(selectedDateArr,i,'custom');
                                              }

                                              var m = i;

                                                    setTimeout(function(){
                                                        $("#filterOption"+m).addClass('hide');
                                                        $("#filterInput"+m).addClass('hide');
                                                        $("#duration"+m).addClass('hide');
                                                        $("#month_period"+m).addClass('hide');
                                                        if (contentArr.filterType.value == 'between'){

                                                      $("#filterDateRange"+m).removeClass('hide');
                                                      $("#filterDate"+m).addClass('hide');
                                                      $("#date_range"+m+" .text-field__filled").val(selectedDateArr);
                                                  }else{
                                                      $("#filterDateRange"+m).addClass('hide');
                                                      $("#filterDate"+m).removeClass('hide');
                                                  }

                                                    },100);
                                                }
                                            }
                                            if(contentArr.columnId.fpFieldType == 'number'){
                                                // this.flag[index] = 'input';
                                                self.columnFilterArr.push({
                                                    filterType:contentArr.filterType,
                                                    filterValue: contentArr.filterValue,
                                                    columnId: contentArr.columnId,
                                                    isColumnDisable:contentArr.isColumnDisable,
                                                    filterTypeArr:contentArr.filterTypeArr,
                                                });
                                                var j = i;
                                                setTimeout(function(){
                                                    $("#filterOption"+j).addClass('hide');
                                                    $("#filterInput"+j).removeClass('hide');
                                                    $("#filterDate"+j).addClass('hide');
                                                    $("#filterDateRange"+j).addClass('hide');
                                                    $("#duration"+j).addClass('hide');
                                                    $("#month_period"+j).addClass('hide');
                                                },100);

                                      }
                                      if(contentArr.columnId.fpFieldType == 'integer'){

                                                self.columnFilterArr.push({
                                                    filterType:contentArr.filterType,
                                                    filterValue: contentArr.filterValue,
                                                    columnId: contentArr.columnId,
                                                    isColumnDisable:contentArr.isColumnDisable,
                                                    filterTypeArr:contentArr.filterTypeArr,
                                                });
                                                    var a = i;
                                                setTimeout(function(){
                                                    $("#filterOption"+a).addClass('hide');
                                                    $("#filterInput"+a).removeClass('hide');
                                                    $("#filterDate"+a).addClass('hide');
                                                    $("#filterDateRange"+a).addClass('hide');
                                                    $("#duration"+a).addClass('hide');
                                                    $("#month_period"+a).addClass('hide');
                                                },100);
                                            }
                                            //year and period filter
                                            if(contentArr.columnId.fpFieldType == 'year' || contentArr.columnId.fpFieldType == 'period'){

                                          contex.columnFilterArr.push({
                                              filterType:contentArr.filterType,
                                              filterValue: contentArr.filterValue,
                                              columnId: contentArr.columnId,
                                              isColumnDisable:contentArr.isColumnDisable,
                                              filterTypeArr:contentArr.filterTypeArr,
                                          });
                                          var n = i;

                                                setTimeout(function(){
                                                    $("#filterInput"+n).removeClass('hide');
                                                    $("#filterOption"+n).addClass('hide');
                                                    $("#filterDate"+n).addClass('hide');
                                                    $("#filterDateRange"+n).addClass('hide');
                                                    $("#startDate"+n).addClass('hide');
                                                    $("#duration"+n).addClass('hide');
                                                    $("#month_period"+n).addClass('hide');
                                                },100);
                                            }
                                            //aging date filter
                                            if(contentArr.columnId.fpFieldType == 'aging_date'){

                                          contex.columnFilterArr.push({
                                              filterType:contentArr.filterType,
                                              filterDateValue: (contentArr.filterDateValue != null && contentArr.filterDateValue != undefined ? contentArr.filterDateValue : null),
                                              columnId: contentArr.columnId,
                                              isColumnDisable:contentArr.isColumnDisable,
                                              filterTypeArr:contentArr.filterTypeArr,
                                              filterDateRangeValue:null,
                                          });
                                          var p = i;

                                                setTimeout(function(){
                                                    $("#filterInput"+p).addClass('hide');
                                                    $("#filterOption"+p).addClass('hide');
                                                    $("#filterDate"+p).removeClass('hide');
                                                    $("#filterDateRange"+p).addClass('hide');
                                                    $("#startDate"+p).addClass('hide');
                                                    $("#duration"+p).addClass('hide');
                                                    $("#month_period"+p).addClass('hide');
                                                },100);

                                      }
                                      //custom date filter type
                                      if (contentArr.columnId.fpFieldType == 'custom_date') {
                                          self.columnFilterArr.push({
                                              filterType:contentArr.filterType,
                                              filterDateValue: (contentArr.filterDateValue != undefined && contentArr.filterDateValue != null ? contentArr.filterDateValue : null),
                                              columnId: contentArr.columnId,
                                              isColumnDisable:contentArr.isColumnDisable,
                                              filterTypeArr:contentArr.filterTypeArr,
                                              filterDateRangeValue:null,
                                              filterValue: (contentArr.filterValue != undefined && contentArr.filterValue != null ? contentArr.filterValue : null),
                                          });
                                          var selectedDateArr = '';
                                          if (contentArr.filterType.value == 'between' || contentArr.filterType.value == 'not between'){
                                              var s= 0;
                                              if(contentArr.filterDateRangeValue != null && contentArr.filterDateRangeValue.length > 0){

                                                    contentArr.filterDateRangeValue.forEach(filterDateRangeValue => {
                                                        if (s == 0 ){
                                                            selectedDateArr = filterDateRangeValue;
                                                            // $("#date-range"+i).attr('startDate',contentArr[i].filterDateRangeValue[j]);
                                                        }else{
                                                            selectedDateArr += ' - '+filterDateRangeValue;
                                                        }
                                                        s++;
                                                    });
                                                }

                                              contex.handleChange(selectedDateArr,i,'custom');
                                              var z = i;

                                                    setTimeout(function(){
                                                        $("#filterOption"+z).addClass('hide');
                                                        $("#filterInput"+z).addClass('hide');
                                                        $("#duration"+z).addClass('hide');
                                                        $("#month_period"+z).addClass('hide');
                                                        $("#filterDateRange"+z).removeClass('hide');
                                                        $("#filterDate"+z).addClass('hide');
                                                        $("#date_range"+z+" .text-field__filled").val(selectedDateArr);
                                                    },100);
                                                }else if (contentArr.filterType.value == 'IS NULL' || contentArr.filterType.value == 'IS NOT NULL') {
                                                    var z = i;
                                                    setTimeout(function(){
                                                        $("#filterOption"+z).addClass('hide');
                                                        $("#filterInput"+z).addClass('hide');
                                                        $("#duration"+z).addClass('hide');
                                                        $("#month_period"+z).addClass('hide');
                                                        $("#filterDateRange"+z).addClass('hide');
                                                        $("#filterDate"+z).removeClass('hide');
                                                        $("#startDate"+z).addClass('hide');
                                                    },100);
                                                }else if (contentArr.filterType.value == 'duration') {
                                                    var a = i;
                                                    self.calculateStateEndDateValue(a+"startduration",contentArr.filterValue[0]);
                                                    self.calculateStateEndDateValue(a+"endduration",contentArr.filterValue[1]);
                                                    self.durationRange[a]=contentArr.filterValue;
                                                    setTimeout(function(){
                                                        $("#filterOption"+a).addClass('hide');
                                                        $("#filterInput"+a).addClass('hide');
                                                        $("#filterDateRange"+a).addClass('hide');
                                                        $("#filterDate"+a).addClass('hide');
                                                        $("#duration"+a).removeClass('hide');
                                                        $("#month_period"+a).addClass('hide');
                                                    },100);
                                                }else{
                                                    var z = i;
                                                    self.calculateStateEndDateValue(z,self.columnFilterArr[i].filterValue);

                                              setTimeout(function(){
                                                  $("#filterInput"+z).addClass('hide');
                                                  $("#filterOption"+z).addClass('hide');
                                                  $("#filterDate"+z).addClass('hide');
                                                  $("#filterDateRange"+z).addClass('hide');
                                                  $("#startDate"+z).removeClass('hide');
                                              },100);
                                          }
                                      }
                                      i++;
                                  });


                          }
                            if (data.sort){
                              self.$parent.serverParams.sort = JSON.parse(data.sort);
                              self.$set(self.$parent, 'userSort', JSON.parse(data.sort));
                          }
                          if (data.columns){
                              var jsonArr = JSON.parse(data.columns);
                              if ( data.columns[0] != undefined ) {

                                  //remove dragable params from array
                                  var i = 0;
                                  var userConfig = JSON.parse(data.columns,(key, value) => {

                                      if ( key == "typeDef" ) {

                                          delete jsonArr[0].typeDef;
                                          i++;
                                          return;
                                      }
                                      return value;
                                  });
                                  // self.userColumns = userConfig;

                                  self.isColumnConfig = true;
                                  self.parentColumns = JSON.parse(data.columns);
                                  self.$set(self.$parent, 'userColumns', userConfig);
                                  self.columnConfigArr = userConfig;

                              } else {
                                  //in case when user not store column configuration
                                  self.$set(self.$parent, 'userColumns', self.$parent.columns);
                                  self.parentColumns = self.columns;
                                  self.isColumnConfig = false;
                              }
                          }
                          //self.$parent.loadFilters('load');
                      }

                  },
                  error: function (jqXHR, exception) {
                      //self.loading = false;
                      self.$parent.loadFilters('load');
                      if (jqXHR.status == 0) {
                          self.errorMsg = "Remote server cannot be reached";
                      } else {
                          //redirect to login page if user not authenticated
                          if (jqXHR.status == 401) {
                              //clear previous data
                              localStorage.removeItem("user_obj");
                              localStorage.removeItem("tkn");
                              //EventBus.$emit("logged-in", true, "", "");
                              self.$router.push("/");
                          }
                          self.error = jqXHR.responseJSON.message;
                      }
                      }
                  });
            },
            'columnFilterArr': {
                handler(newVal) {
                    newVal.forEach((item, index) => {
                        if (item.multiple) {
                            this.$watch(() => item.filterOptionValue, () => {
                                var checkbox = document.getElementById('multipleOptionCheckbox_'+index);
                                if(item.filterOptionValue.length < item.filterOption.length){
                                    if(checkbox){
                                        checkbox.checked = false;
                                    }
                                }else if(item.filterOptionValue.length == item.filterOption.length){
                                    if(checkbox){
                                        checkbox.checked = true;
                                    }
                                }
                            });
                        }
                    });
                },
                deep: true
            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.initializeResizeObserver();

            self.$set(self.$parent, 'userColumns', self.$parent.columns);
            //set columncoinfg array from parent column
            self.columnConfigArr = self.$parent.columns;
            // self.loadStoredListFilters();
            var userJson = null;
            var userObj = localStorage.getItem("user_obj");
            //if user logged in than remove login button and registration button
            if ( userObj != null ) {
                userJson = JSON.parse(userObj);
            }

            setTimeout(function(){
                $("#filterOption0").addClass('hide');
                $("#filterDate0").addClass('hide');
                $("#filterDateRange0").addClass('hide');
            },50);

            if(self.moduleName == 'fuelTicketList'){
                self.dateArr.push({ value: 'duration', text: 'duration'});
            }

            if(self.moduleName == 'telematicListAssetView'){
              self.isHideBlue = true;
            }
            if(!(self.moduleName == "availableAssetList")) {
              self.loadDefaultFiltersOnload(); // loads the default filters
            }
            setTimeout(function(){
                document.getElementById("ColumnList").style.width = "0";

            },500);
            //load default Column Filters
            self.defaultColumnFilters('load');

            if ( userJson && userJson.location_id != null && userJson.location_id  != '' ) {
                //Creating User loaction Array becuse when user role is fueler than we are not showing other locations
                self.loginUserLocation=[{text:userJson.locationName,value:userJson.location_id}];
            }

            //load column values from database like locations, asset types..etc
            if ( self.requestArr.length > 0 ) {
                self.loadFieldData(self.requestArr);
            }

            self.loadDefaultFields();

            //After Adding Input field click on enter to search data
            $(document).keypress(function(e) {
                if (e.keyCode === 13) {
                    self.storeSearchEnable = true;
                    $("#search_button").click();
                    //self.onColumnFilter('load');
                }
            });


            //LoadingDefault Filters which are stored in filterlist using Module name
            self.$parent.module= self.moduleName;

        },

        methods: {
            columnChanged(newValue, index){
                if(newValue == null || newValue == ''){
                    this.columnFilterArr[index].columnId = '';
                    this.columnchange(newValue, index);
                }
            },
            optionValueChanged(newValue, index){
                if(newValue == null || newValue == ''){
                    this.columnFilterArr[index].filterOptionValue = '';
                }
            },
            initializeResizeObserver() {
                var self = this;
                const observer = new ResizeObserver(entries => {
                    for (let entry of entries) {
                        if (entry.target === self.$refs.filterContainer) {
                            self.divWidth = entry.contentRect.width;
                            if(self.divWidth < 892){
                                if(self.widthCheckTimes == 0){
                                    self.adjustFilterCol('less');
                                }
                                self.widthCheckTimes = 1;
                            }else{
                                if(self.widthCheckTimes == 1){
                                    self.adjustFilterCol('more');
                                }
                                self.widthCheckTimes = 0;
                            }
                        }
                    }
                });
                observer.observe(self.$refs.filterContainer);
            },
            adjustFilterCol(text){
                var self = this;
                let filteredElements = [];
                for (let i = 0; i < self.columnFilterArr.length; i++) {
                    let ids = [
                        "filterInput" + i,
                        "filterOption" + i,
                        "filterDate" + i,
                        "filterDateRange" + i,
                        "duration" + i,
                        "month_period" + i,
                        "startDate" + i,
                        "conditionDiv" + i,
                        'columnDiv' + i
                    ];

                    ids.forEach(id => {
                        let element = document.getElementById(id);
                        if (element && !element.classList.contains("hide")) {
                            filteredElements.push(element);
                        }
                    });
                }

                if (text === 'less') {
                    filteredElements.forEach(element => {
                        let classesToRemove = [];
                        element.classList.forEach(className => {
                            if (className.includes("col")) {
                                classesToRemove.push(className);
                            }
                        });
                        // Store the removed classes
                        self.originalColumnClasses[element.id] = classesToRemove;
                        classesToRemove.forEach(className => {
                            element.classList.remove(className);
                        });
                        element.classList.add('col-12');
                    });
                } else if (text === 'more') {
                    filteredElements.forEach(element => {
                        element.classList.remove('col-12');
                        // Reapply the stored classes
                        let classesToReapply = self.originalColumnClasses[element.id];
                        if (classesToReapply) {
                            classesToReapply.forEach(className => {
                                element.classList.add(className);
                            });
                        }
                    });
                }
            },
            loadDefaultFields(){
                var self = this;
                if ( self.moduleName == 'accruedLiabilityReport'
                    || self.moduleName == 'rentalUtilizationEquipment'
                    || self.moduleName == "SubDaysInPeriodReport"
                    || self.moduleName == "rentalActivityWithRatesReport"
                    || self.moduleName == 'depreciationReviewReport'
                    || self.moduleName == 'reservationReport'
                    || self.moduleName == 'SubletInProcessReport'
                    || self.moduleName == 'weeklyRentalReport'
                    || self.moduleName == 'debtNoteRollForward'
                    || self.moduleName == 'contractEquipmentUtilization'
                    || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'debtNoteBalanceDetail' || self.moduleName == 'rentalActivityReport' || self.moduleName == 'equipmentaccountingrecords'){

                self.loadDefaultStartEndDateFilter();

            } else {

                //work entry list default start date filter
                if (self.moduleName != undefined && self.moduleName != null) {

                    //populate default user location wo in list
                    // if ( self.moduleName == "listWorkOrderTable"
                    //         || self.moduleName == "rentalAgreementList"
                    //         || self.moduleName == "rentalAgreementSubList"
                    //         || self.moduleName == "pendingReservationList"
                    //         || self.moduleName == "reservationListCurr"
                    //         || self.moduleName == "reservationListPast"
                    //         || self.moduleName == "availableAssetList"
                    //         || self.moduleName == "aPurchaseOrder"
                    //         || self.moduleName == "vPurchaseOrder" ) {

                    //     self.columnFilterArr = [{
                    //         columnId:null,
                    //         isColumnDisable:false,
                    //         filterValue: null,
                    //         filterDateValue: null,
                    //         filterDateRangeValue: null,
                    //         filterOptionValue: null,
                    //         filterType: null,
                    //         filterOption:[],
                    //         filterDupValue:[{value:"",type:""}]
                    //     }];

                    //     setTimeout(function(){
                    //         $("#filterOption0").removeClass('hide');
                    //         $("#filterInput0").addClass('hide');
                    //         $("#filterDate0").addClass('hide');
                    //         $("#filterDateRange0").addClass('hide');
                    //         $("#startDate0").addClass('hide');
                    //     },200);

                    //     // var locValue = {
                    //     //     value: self.loginUserLocation[0].value,
                    //     //     text: self.loginUserLocation[0].text,
                    //     // };

                    //     self.columnFilterArr[0].columnId = {};
                    //     self.columnFilterArr[0].isColumnDisable = false;
                    //     self.columnFilterArr[0].filterType = {};
                    //     self.columnFilterArr[0].filterOptionValue = locValue;
                    //     if ( self.moduleName == "aPurchaseOrder" || self.moduleName == "vPurchaseOrder" ) {
                    //         self.columnFilterArr[0].columnId.field = 'ordering_location';
                    //     }else{
                    //         self.columnFilterArr[0].columnId.field = 'location';
                    //     }
                    //     if ( self.moduleName == "availableAssetList" ) {
                    //         self.columnFilterArr[0].columnId.label = "Assigned Facility";
                    //     } else if ( self.moduleName == "aPurchaseOrder" || self.moduleName == "vPurchaseOrder" ) {
                    //         self.columnFilterArr[0].columnId.label = 'Ordering Location';
                    //     }else {
                    //         self.columnFilterArr[0].columnId.label = "Location";
                    //     }
                    //     self.columnFilterArr[0].columnId.fpFieldType = 'option';
                    //     self.columnFilterArr[0].filterTypeArr = self.optionArr;
                    //     self.columnFilterArr[0].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                    //     setTimeout(function(){
                    //         self.columnFilterArr[0].filterOption = self.locationArr;
                    //     },4000);
                    //     self.columnFilterArr[0].filterValue = '';
                    //     self.columnFilterArr[0].filterDupValue[0]['value'] = locValue;
                    //     self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                    // }

                    //if ( self.moduleName == "availableAssetList" ) {

                    //     self.columnFilterArr = [{
                    //         columnId:null,
                    //         isColumnDisable:false,
                    //         filterValue: null,
                    //         filterDateValue: null,
                    //         filterDateRangeValue: null,
                    //         filterOptionValue: null,
                    //         filterType: null,
                    //         filterOption:[],
                    //     }];

                    //     setTimeout(function(){
                    //         $("#filterOption0").removeClass('hide');
                    //         $("#filterInput0").addClass('hide');
                    //         $("#filterDate0").addClass('hide');
                    //         $("#filterDateRange0").addClass('hide');
                    //         $("#startDate0").addClass('hide');
                    //     },200);

                    //     var locValue = {
                    //         value: self.loginUserLocation[0].value,
                    //         text: self.loginUserLocation[0].text,
                    //     };

                    //     self.columnFilterArr[0].columnId = {};
                    //     self.columnFilterArr[0].isColumnDisable = false;
                    //     self.columnFilterArr[0].filterType = {};
                    //     self.columnFilterArr[0].filterOptionValue = locValue;
                    //     self.columnFilterArr[0].columnId.field = 'location';
                    //     self.columnFilterArr[0].columnId.label = "Assigned Facility";
                    //     self.columnFilterArr[0].columnId.fpFieldType = 'option';
                    //     self.columnFilterArr[0].filterTypeArr = self.optionArr;
                    //     self.columnFilterArr[0].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                    //     setTimeout(function(){
                    //         self.columnFilterArr[0].filterOption = self.locationArr;
                    //     },4000);
                    //     self.columnFilterArr[0].filterValue = '';

                    // }

                    // if ( self.moduleName == "pendingReservationList" ) {

                    //     self.columnFilterArr = [{
                    //         columnId:null,
                    //         isColumnDisable:false,
                    //         filterValue: null,
                    //         filterDateValue: null,
                    //         filterDateRangeValue: null,
                    //         filterOptionValue: null,
                    //         filterType: null,
                    //         filterOption:[],
                    //     }];

                    //     setTimeout(function(){
                    //         $("#filterOption0").removeClass('hide');
                    //         $("#filterInput0").addClass('hide');
                    //         $("#filterDate0").addClass('hide');
                    //         $("#filterDateRange0").addClass('hide');
                    //         $("#startDate0").addClass('hide');
                    //     },200);

                    //     var locValue = {
                    //         value: self.loginUserLocation[0].value,
                    //         text: self.loginUserLocation[0].text,
                    //     };

                    //     self.columnFilterArr[0].columnId = {};
                    //     self.columnFilterArr[0].isColumnDisable = false;
                    //     self.columnFilterArr[0].filterType = {};
                    //     self.columnFilterArr[0].filterOptionValue = locValue;
                    //     self.columnFilterArr[0].columnId.field = 'location';
                    //     self.columnFilterArr[0].columnId.label = "Location";
                    //     self.columnFilterArr[0].columnId.fpFieldType = 'option';
                    //     self.columnFilterArr[0].filterTypeArr = self.optionArr;
                    //     self.columnFilterArr[0].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                    //     setTimeout(function(){
                    //         self.columnFilterArr[0].filterOption = self.locationArr;
                    //     },4000);
                    //     self.columnFilterArr[0].filterValue = '';

                    // }

                    // if ( self.moduleName == "reservationListCurr" ) {

                    //     self.columnFilterArr = [{
                    //         columnId:null,
                    //         isColumnDisable:false,
                    //         filterValue: null,
                    //         filterDateValue: null,
                    //         filterDateRangeValue: null,
                    //         filterOptionValue: null,
                    //         filterType: null,
                    //         filterOption:[],
                    //     }];

                    //     setTimeout(function(){
                    //         $("#filterOption0").removeClass('hide');
                    //         $("#filterInput0").addClass('hide');
                    //         $("#filterDate0").addClass('hide');
                    //         $("#filterDateRange0").addClass('hide');
                    //         $("#startDate0").addClass('hide');
                    //     },200);

                    //     var locValue = {
                    //         value: self.loginUserLocation[0].value,
                    //         text: self.loginUserLocation[0].text,
                    //     };

                    //     self.columnFilterArr[0].columnId = {};
                    //     self.columnFilterArr[0].isColumnDisable = false;
                    //     self.columnFilterArr[0].filterType = {};
                    //     self.columnFilterArr[0].filterOptionValue = locValue;
                    //     self.columnFilterArr[0].columnId.field = 'location';
                    //     self.columnFilterArr[0].columnId.label = "Location";
                    //     self.columnFilterArr[0].columnId.fpFieldType = 'option';
                    //     self.columnFilterArr[0].filterTypeArr = self.optionArr;
                    //     self.columnFilterArr[0].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                    //     setTimeout(function(){
                    //         self.columnFilterArr[0].filterOption = self.locationArr;
                    //     },4000);
                    //     self.columnFilterArr[0].filterValue = '';

                    // }

                    if (self.moduleName == "workEntryList") {

                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").removeClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');
                        },200);

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        self.columnFilterArr[0].columnId.field = 'start';
                        self.columnFilterArr[0].columnId.label = "Start Time";
                        self.columnFilterArr[0].columnId.fpFieldType = 'date';
                        self.columnFilterArr[0].filterTypeArr = self.dateArr;
                        self.columnFilterArr[0].filterType = {value:self.dateArr[0].value,text:self.dateArr[0].text};
                        self.columnFilterArr[0].filterOption = [];
                        self.etkDateFilter = true;

                    }
                    if (self.moduleName == "leaseContractExpiry" || self.moduleName == "leaseContractExpiryNonTemplate") {

                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        }];
                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").removeClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');
                        },200);

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        self.columnFilterArr[0].columnId.field = 'no_of_month';
                        self.columnFilterArr[0].columnId.label = "Number of month to look ahead";
                        self.columnFilterArr[0].columnId.fpFieldType = 'integer';
                        self.columnFilterArr[0].filterTypeArr = self.isArr;
                        self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].filterValue = '1';
                        self.columnFilterArr[0].filterDupValue[0]['value'] = '1';
                        self.columnFilterArr[0].filterDupValue[0]['type'] = "=";

                        // self.etkDateFilter = true;

                    }

                    if(self.moduleName == "publicationList"){
                        self.populatePublicationFilters(null);
                    }

                    if ( self.moduleName == "costPerMetricByUnitReport") {
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        },{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        },{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        }];
                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").removeClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');
                        },200);

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = true;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        self.columnFilterArr[0].columnId.field = 'start_date';
                        self.columnFilterArr[0].columnId.label = "Reading From";
                        self.columnFilterArr[0].columnId.fpFieldType = 'date';
                        self.columnFilterArr[0].filterTypeArr = [{value:'=',text:'is'}];
                        self.columnFilterArr[0].columnId.fpMandatory = true;
                        self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].filterValue = '';
                        self.columnFilterArr[0].filterDupValue[0]['value'] = '';
                        self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        setTimeout(function(){
                            $("#filterOption1").addClass('hide');
                            $("#filterInput1").addClass('hide');
                            $("#filterDate1").removeClass('hide');
                            $("#filterDateRange1").addClass('hide');
                            $("#startDate1").addClass('hide');


                            self.columnFilterArr[1].columnId = {
                                "label": "End Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "date",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = true;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            self.columnFilterArr[1].columnId.field = 'end_date';
                            self.columnFilterArr[1].columnId.label = "Reading To";
                            self.columnFilterArr[1].columnId.fpFieldType = 'date';
                            self.columnFilterArr[1].filterTypeArr = [{value:'=',text:'is'}];
                            self.columnFilterArr[1].columnId.fpMandatory = true;
                            self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                            self.columnFilterArr[1].filterOption = [];
                            self.columnFilterArr[1].filterValue = '';
                            self.columnFilterArr[1].filterDupValue[0]['value'] = '';
                            self.columnFilterArr[1].filterDupValue[0]['type'] = '=';
                        },400);

                        setTimeout(function(){
                            $("#filterOption2").removeClass('hide');
                            $("#filterInput2").addClass('hide');
                            $("#filterDate2").addClass('hide');
                            $("#filterDateRange2").addClass('hide');
                            $("#startDate2").addClass('hide');

                            var obj = self.sectionArr;
                            var secValue = '';
                            $.each(obj, function (key, uomvalue) {
                                if (uomvalue.code == 'DIST') {
                                    secValue = {
                                        value: uomvalue.value,
                                        text: uomvalue.text,
                                    };
                                }
                            });

                            self.columnFilterArr[2].columnId = {};
                            self.columnFilterArr[2].isColumnDisable = false;
                            self.columnFilterArr[2].filterType = {};
                            self.columnFilterArr[2].filterOptionValue = secValue;
                            self.columnFilterArr[2].columnId.field = 'section';
                            self.columnFilterArr[2].columnId.label = "Metric Type";
                            self.columnFilterArr[2].columnId.fpFieldType = 'option';
                            self.columnFilterArr[2].columnId.fpMandatory = true;
                            self.columnFilterArr[2].filterTypeArr = self.optionArr;
                            self.columnFilterArr[2].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                            self.columnFilterArr[2].filterOption = self.sectionArr;
                            self.columnFilterArr[2].filterValue = '';
                            self.columnFilterArr[2].filterDupValue[0]['value'] = secValue;
                            self.columnFilterArr[2].filterDupValue[0]['type'] = '=';

                        },4000);

                    }
                    if ( self.moduleName == "depreciationNBVReport") {
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                        },{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                        }];

                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").removeClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');


                            self.columnFilterArr[0].columnId = {
                                "label": "Period End Date",
                                "field": "period_end",
                                "filterable": false,
                                "fpFieldType": "custom_date",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            self.columnFilterArr[0].columnId.field = 'period_end';
                            self.columnFilterArr[0].columnId.label = "Period End Date";
                            self.columnFilterArr[0].columnId.fpFieldType = 'custom_date';
                            self.columnFilterArr[0].columnId.fpMandatory = true;
                            self.columnFilterArr[0].filterTypeArr = self.isArr;
                            self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                            self.columnFilterArr[0].filterOption = [];
                            self.columnFilterArr[0].filterValue = '';
                        },200);

                        setTimeout(function(){
                            $("#filterOption1").addClass('hide');
                            $("#filterInput1").removeClass('hide');
                            $("#filterDate1").addClass('hide');
                            $("#filterDateRange1").addClass('hide');
                            $("#startDate1").addClass('hide');

                            self.columnFilterArr[1].columnId = {
                                "label": "Cap Cost As At",
                                "field": "capital_amount",
                                "filterable": false,
                                "fpFieldType": "integer",
                                "fpMandatory":false,
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "Capital Amount",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = false;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOption = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[1].filterType = {value:'!=',text:'is not'};
                            // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                            self.columnFilterArr[1].filterValue = 0;
                            self.columnFilterArr[1].filterTypeArr = self.integerArr;
                            self.columnFilterArr[1].filterOption = [];
                            // self.columnFilterArr[1].isColumnDisable = true;
                            self.columnFilterArr[1].filterDupValue[0]['value'] = 0;
                            self.columnFilterArr[1].filterDupValue[0]['type'] = '!=';
                        },200);
                        // self.etkDateFilter = true;

                    }
                    if (self.moduleName == "assetWarrantyList") {

                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        }];
                        setTimeout(function(){
                            $("#filterOption0").removeClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');

                            self.columnFilterArr[0].columnId = {};
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = { value: '=', text: 'is'};
                            self.columnFilterArr[0].filterOptionValue = {value:'yes',text:'Yes'};
                            self.columnFilterArr[0].columnId.field = 'status';
                            self.columnFilterArr[0].columnId.label = "Warranty Applied";
                            self.columnFilterArr[0].columnId.fpFieldType = 'option';
                            self.columnFilterArr[0].filterTypeArr = self.optionArr;
                            self.columnFilterArr[0].filterOption = self.assetWarrantyStatusArr;
                            self.columnFilterArr[0].filterValue = '';
                        },200);

                    }


                    if (self.moduleName == "customerAgedTrialBalance") {

                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        }];
                        setTimeout(function(){
                            $("#filterOption0").removeClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');

                            self.columnFilterArr[0].columnId = {};
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = { value: '=', text: 'is'};
                            self.columnFilterArr[0].filterOptionValue = 'No';
                            self.columnFilterArr[0].columnId.field = 'summary';
                            self.columnFilterArr[0].columnId.label = "Summarize";
                            self.columnFilterArr[0].columnId.fpFieldType = 'option';
                            self.columnFilterArr[0].columnId.sortable = false;
                            self.columnFilterArr[0].columnId.hidden = true;
                            self.columnFilterArr[0].filterTypeArr = self.isArr;
                            self.columnFilterArr[0].columnId.fpMandatory = true;
                            self.columnFilterArr[0].filterOption = ['Yes','No'];
                            self.columnFilterArr[0].filterValue = '';
                        },200);

                    }

                    if (self.moduleName == "customerAgedTrialBalanceDetail" || self.moduleName == "apTrialBalanceAsAtDetail") {
                        self.defaultYearPeriodFilters('load');
                    }
                    if (self.moduleName == "apVoucherDistribution") {
                        self.incluePaymentInfoFilter('load');
                    }
                    if (self.moduleName == "trialBalanceReport") {
                        self.trialBalanceReportFilters('load');
                    }
                    if (self.moduleName == "equipmentCurrentStatus" && self.fromSchedule == undefined) {

                        setTimeout(function(){
                            $("#filterOption0").removeClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');

                            var obj = self.ownershipArr;
                            var ownVal = '';
                            $.each(obj, function (key, own) {
                                if (own.code == 'O') {
                                    ownVal = {
                                        value: own.value,
                                        text: own.text,
                                    };
                                }
                            });

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = ownVal;
                        self.columnFilterArr[0].columnId.field = 'ownership';
                        self.columnFilterArr[0].columnId.label = "Unit Ownership";
                        self.columnFilterArr[0].columnId.fpFieldType = 'option';
                        self.columnFilterArr[0].filterTypeArr = self.optionArr;
                        self.columnFilterArr[0].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                        self.columnFilterArr[0].filterOption = self.ownershipArr;
                        self.columnFilterArr[0].filterValue = '';

                        },4000);

                    }

                    if (self.moduleName == 'PMUnitForecastList'){
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                            filterDupValue:[{value:"",type:""}]
                        },
                        {
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                            filterDupValue:[{value:"",type:""}]
                        },
                        {
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                            filterDupValue:[{value:"",type:""}]
                        }];

                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").removeClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');
                        },200);

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        self.columnFilterArr[0].columnId.field = 'days_diff';
                        self.columnFilterArr[0].columnId.label = "Forecast Window (Days)";
                        self.columnFilterArr[0].columnId.fpFieldType = 'integer';
                        self.columnFilterArr[0].filterTypeArr = self.integerArr;
                        self.columnFilterArr[0].fpMandatory = true;
                        self.columnFilterArr[0].filterType = {value:self.integerArr[0].value,text:self.integerArr[0].text};
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].filterValue = '90';
                        self.columnFilterArr[0].filterDupValue[0]['value'] = "90";
                        self.columnFilterArr[0].filterDupValue[0]['type'] = "<";

                        // if (self.loginUserLocation[0] && self.loginUserLocation[0].value){
                        //     setTimeout(function(){
                        //         $("#filterOption1").removeClass('hide');
                        //         $("#filterInput1").addClass('hide');
                        //         $("#filterDate1").addClass('hide');
                        //         $("#filterDateRange1").addClass('hide');
                        //         $("#startDate1").addClass('hide');

                        //         var obj = self.locationArr;
                        //         // self.loginUserLocation
                        //         var locValue = '';
                        //         // $.each(obj, function (key, lcValue) {
                        //         //     console.log(lcValue);
                        //         //     if (lcValue.value == self.loginUserLocation[0].value) {
                        //                 locValue = {
                        //                     value: self.loginUserLocation[0].value,
                        //                     text: self.loginUserLocation[0].text,
                        //                 };
                        //         //     }
                        //         // });

                        //         self.columnFilterArr[1].columnId = {};
                        //         self.columnFilterArr[1].isColumnDisable = false;
                        //         self.columnFilterArr[1].filterType = {};
                        //         self.columnFilterArr[1].filterOptionValue = locValue;
                        //         self.columnFilterArr[1].columnId.field = 'location';
                        //         self.columnFilterArr[1].columnId.label = "Facility";
                        //         self.columnFilterArr[1].columnId.fpFieldType = 'option';
                        //         self.columnFilterArr[1].filterTypeArr = self.optionArr;
                        //         self.columnFilterArr[1].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                        //         self.columnFilterArr[1].filterDupValue[0]['value'] = locValue;
                        //         self.columnFilterArr[1].filterDupValue[0]['type'] = "=";

                        //         setTimeout(function(){
                        //             self.columnFilterArr[1].filterOption = self.locationArr;
                        //         },4000);
                        //         self.columnFilterArr[1].filterValue = '';

                        //     },200);


                        // }

                         setTimeout(function(){
                            $("#filterOption2").removeClass('hide');
                            $("#filterInput2").addClass('hide');
                            $("#filterDate2").addClass('hide');
                            $("#filterDateRange2").addClass('hide');
                            $("#startDate2").addClass('hide');

                        },200);
                            self.columnFilterArr[2].columnId = {};
                            self.columnFilterArr[2].isColumnDisable = false;
                            self.columnFilterArr[2].filterType = {};
                            self.columnFilterArr[2].filterOptionValue = {};
                            self.columnFilterArr[2].columnId.field = 'schedule';
                            self.columnFilterArr[2].columnId.label = "Schedule";
                            self.columnFilterArr[2].columnId.fpFieldType = 'option';
                            self.columnFilterArr[2].filterTypeArr = self.isArr;
                            self.columnFilterArr[2].fpMandatory = true;
                            self.columnFilterArr[2].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                            self.columnFilterArr[2].filterOption = ['Yes','No','All'];
                            self.columnFilterArr[2].filterOptionValue = 'All';
                            self.columnFilterArr[2].filterDupValue[0]['value'] = "All";
                            self.columnFilterArr[2].filterDupValue[0]['type'] = "=";


                    }
                    if (self.moduleName == 'inventoryReport'){
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        },
                        {
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        },{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        }];

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = true;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        self.columnFilterArr[0].columnId.field = 'as_at_date';
                        self.columnFilterArr[0].columnId.label = "As At Date";
                        self.columnFilterArr[0].columnId.fpFieldType = 'custom_date';
                        self.columnFilterArr[0].columnId.sortable = false;
                        self.columnFilterArr[0].filterTypeArr = self.isArr;
                        self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].filterValue = '';

                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").removeClass('hide');

                        },200);


                        setTimeout(function(){
                            $("#filterOption1").addClass('hide');
                            $("#filterInput1").removeClass('hide');
                            $("#filterDate1").addClass('hide');
                            $("#filterDateRange1").addClass('hide');
                            $("#startDate1").addClass('hide');

                            self.columnFilterArr[1].columnId = {};
                            self.columnFilterArr[1].isColumnDisable = true;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            self.columnFilterArr[1].columnId.field = 'as_of_year';
                            self.columnFilterArr[1].columnId.label = "As Of Year";
                            self.columnFilterArr[1].columnId.fpFieldType = 'year';
                            self.columnFilterArr[1].columnId.sortable = false;
                            self.columnFilterArr[1].filterTypeArr = self.isArr;
                            self.columnFilterArr[1].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                            self.columnFilterArr[1].filterValue = '';
                        },200);

                        setTimeout(function(){
                            $("#filterOption2").addClass('hide');
                            $("#filterInput2").removeClass('hide');
                            $("#filterDate2").addClass('hide');
                            $("#filterDateRange2").addClass('hide');
                            $("#startDate2").addClass('hide');

                            self.columnFilterArr[2].columnId = {};
                            self.columnFilterArr[2].isColumnDisable = true;
                            self.columnFilterArr[2].filterType = {};
                            self.columnFilterArr[2].filterOptionValue = {};
                            self.columnFilterArr[2].columnId.field = 'as_of_period';
                            self.columnFilterArr[2].columnId.label = "As Of Period";
                            self.columnFilterArr[2].columnId.fpFieldType = 'period';
                            self.columnFilterArr[2].columnId.sortable = false;
                            self.columnFilterArr[2].filterTypeArr = self.isArr;
                            self.columnFilterArr[2].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                            self.columnFilterArr[2].filterValue = '';
                        },200);
                    }


                    if (self.moduleName == 'PMComplianceFacilityList' || self.moduleName == 'PMCompliancePoolList'){
                      self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        }];
                        setTimeout(function(){
                            $("#filterOption0").removeClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');
                        },200);

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = true;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = {text:'All',value:'all'};
                        self.columnFilterArr[0].columnId.field = 'category';
                        self.columnFilterArr[0].columnId.label = "PM Category";
                        self.columnFilterArr[0].columnId.fpFieldType = 'option';
                        self.columnFilterArr[0].filterTypeArr = self.isArr;
                        self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                        self.columnFilterArr[0].filterOption = self.programCategoryArr;
                        self.columnFilterArr[0].filterValue = '';
                        self.columnFilterArr[0].filterDupValue[0]['value'] = {text:'All',value:'all'};
                        self.columnFilterArr[0].filterDupValue[0]['type'] = "=";
                    }

                    if(self.moduleName == "actualMetricVSContractMetric" || self.moduleName == "actualMetricVSContractMetricReport"){


                        setTimeout(function(){
                            $("#filterOption0").removeClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');

                            var obj = self.sectionArr;
                            var secValue = '';
                            $.each(obj, function (key, uomvalue) {
                                if (uomvalue.code == 'DIST') {
                                    secValue = {
                                        value: uomvalue.value,
                                        text: uomvalue.text,
                                    };
                                }
                            });

                            self.columnFilterArr[0].columnId = {};
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOptionValue = secValue;
                            self.columnFilterArr[0].columnId.field = 'section';
                            self.columnFilterArr[0].columnId.label = "Metric Type";
                            self.columnFilterArr[0].columnId.fpFieldType = 'option';
                            self.columnFilterArr[0].filterTypeArr = self.optionArr;
                            self.columnFilterArr[0].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                            self.columnFilterArr[0].filterOption = self.sectionArr;
                            self.columnFilterArr[0].filterValue = '';

                        },4000);
                    }

                    if(self.moduleName == "laborManagementReport" ){

                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            // filterDupValue:[{value:"",type:""}]
                        },{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            // filterDupValue:[{value:"",type:""}]
                        },
                        {
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            // filterDupValue:[{value:"",type:""}]
                        }];
                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").removeClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');
                        },200);

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = true;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        self.columnFilterArr[0].columnId.field = 'start_date';
                        self.columnFilterArr[0].columnId.label = "From Date";
                        self.columnFilterArr[0].columnId.fpFieldType = 'date';
                        self.columnFilterArr[0].columnId.fpMandatory = true;
                        self.columnFilterArr[0].filterTypeArr = self.isArr;
                        self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].filterValue = '';
                        // self.columnFilterArr[0].filterDupValue[0]['value'] = {};
                        // self.columnFilterArr[0].filterDupValue[0]['type'] = "=";

                        setTimeout(function(){
                            $("#filterOption1").addClass('hide');
                            $("#filterInput1").addClass('hide');
                            $("#filterDate1").removeClass('hide');
                            $("#filterDateRange1").addClass('hide');
                            $("#startDate1").addClass('hide');


                            self.columnFilterArr[1].columnId = {
                                "label": "End Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "date",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = true;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            self.columnFilterArr[1].columnId.field = 'end_date';
                            self.columnFilterArr[1].columnId.label = "To Date";
                            self.columnFilterArr[1].columnId.fpFieldType = 'date';
                            self.columnFilterArr[1].columnId.fpMandatory = true;
                            self.columnFilterArr[1].filterTypeArr = self.isArr;
                            self.columnFilterArr[1].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                            self.columnFilterArr[1].filterOption = [];
                            self.columnFilterArr[1].filterValue = '';
                            // self.columnFilterArr[1].filterDupValue[0]['value'] = "";
                            // self.columnFilterArr[1].filterDupValue[0]['type'] = "=";
                        },200);

                        setTimeout(function(){
                            $("#filterOption2").removeClass('hide');
                            $("#filterInput2").addClass('hide');
                            $("#filterDate2").addClass('hide');
                            $("#filterDateRange2").addClass('hide');
                            $("#startDate2").addClass('hide');

                            self.columnFilterArr[2].columnId = {};
                            self.columnFilterArr[2].isColumnDisable = true;
                            self.columnFilterArr[2].filterType = {};
                            self.columnFilterArr[2].filterOptionValue = 'Facility';
                            self.columnFilterArr[2].columnId.field = 'detail_value';
                            self.columnFilterArr[2].columnId.label = "Labor Report Detail Level";
                            self.columnFilterArr[2].columnId.fpFieldType = 'option';
                            self.columnFilterArr[2].filterTypeArr = self.isArr;
                            self.columnFilterArr[2].columnId.fpMandatory = true;
                            self.columnFilterArr[2].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                            self.columnFilterArr[2].filterOption = ['Facility','Employee'];
                            self.columnFilterArr[2].filterValue = '';
                            // self.columnFilterArr[2].filterDupValue[0]['value'] = 'Facility';
                            // self.columnFilterArr[2].filterDupValue[0]['type'] = "=";
                        },400);
                    }


                    if (self.fromDashboard != undefined && self.fromDashboard == 'dashboard' && self.moduleName == 'bankTransferList'){
                        var ind = 0;
                        if (self.columnFilterArr != undefined && self.columnFilterArr.length){
                            ind = self.columnFilterArr.length - 1;
                        }
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        }];
                        setTimeout(function(){
                            $("#filterOption"+ind).removeClass('hide');
                            $("#filterInput"+ind).addClass('hide');
                            $("#filterDate"+ind).addClass('hide');
                            $("#filterDateRange"+ind).addClass('hide');
                            $("#startDate"+ind).addClass('hide');

                            self.columnFilterArr[ind].columnId = {};
                            self.columnFilterArr[ind].isColumnDisable = false;
                            self.columnFilterArr[ind].filterType = { value: '=', text: 'is'};
                            self.columnFilterArr[ind].filterOptionValue = {value:'Pending',text:'Pending'};
                            self.columnFilterArr[ind].columnId.field = 'tag';
                            self.columnFilterArr[ind].columnId.label = "Status";
                            self.columnFilterArr[ind].columnId.fpFieldType = 'option';
                            self.columnFilterArr[ind].filterTypeArr = [{ value: '=', text: 'is'}, { value: '!=', text: 'is not'}];
                            self.columnFilterArr[ind].filterOption = ['Pending','Settled','Partial'];
                            self.columnFilterArr[ind].filterValue = '';
                        },200);
                    }
                    if (self.fromDashboard == undefined && self.moduleName == 'bankTransferList' && (self.routeSelId == '' || self.routeSelId == undefined)){
                        var ind = 0;
                        if (self.columnFilterArr != undefined && self.columnFilterArr.length){
                            ind = self.columnFilterArr.length - 1;
                        }
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        }];
                        setTimeout(function(){
                            $("#filterOption"+ind).removeClass('hide');
                            $("#filterInput"+ind).addClass('hide');
                            $("#filterDate"+ind).addClass('hide');
                            $("#filterDateRange"+ind).addClass('hide');
                            $("#startDate"+ind).addClass('hide');

                            self.columnFilterArr[ind].columnId = {};
                            self.columnFilterArr[ind].isColumnDisable = false;
                            self.columnFilterArr[ind].filterType = { value: '=', text: 'is'};
                            self.columnFilterArr[ind].filterOptionValue = '6880';
                            self.columnFilterArr[ind].columnId.field = 'account_number';
                            self.columnFilterArr[ind].columnId.label = "#Account";
                            self.columnFilterArr[ind].columnId.fpFieldType = 'option';
                            self.columnFilterArr[ind].filterTypeArr = [{ value: '=', text: 'is'}, { value: '!=', text: 'is not'}];
                            self.columnFilterArr[ind].filterOption = ['6880','0930','Other'];
                            self.columnFilterArr[ind].filterValue = '';
                        },200);
                    }

                    if (self.moduleName == 'bankTransferList' && self.routeSelId != '' && self.routeSelId != undefined){
                      self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        }];
                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").removeClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');

                            self.columnFilterArr[0].columnId = {};
                            self.columnFilterArr[0].isColumnDisable = true;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            self.columnFilterArr[0].columnId.field = 'id';
                            self.columnFilterArr[0].columnId.label = "#Sequence";
                            self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[0].filterTypeArr = self.integerArr;
                            self.columnFilterArr[0].filterType = {value:'=',text:'is equal'};
                            self.columnFilterArr[0].filterValue = self.routeSelId;
                            self.columnFilterArr[0].filterDupValue[0]['value'] = self.routeSelId;
                            self.columnFilterArr[0].filterDupValue[0]['type'] = "=";
                        },500);
                    }

                    if (self.fromDashboard != undefined && self.fromDashboard == 'dashboard' && self.moduleName == 'insurancePolicyList'){
                        var ind = 0;
                        if (self.columnFilterArr != undefined && self.columnFilterArr.length){
                            ind = self.columnFilterArr.length - 1;
                        }
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        }];
                        setTimeout(function(){
                            $("#filterOption"+ind).removeClass('hide');
                            $("#filterInput"+ind).addClass('hide');
                            $("#filterDate"+ind).addClass('hide');
                            $("#filterDateRange"+ind).addClass('hide');
                            $("#startDate"+ind).addClass('hide');

                            self.columnFilterArr[ind].columnId = {};
                            self.columnFilterArr[ind].isColumnDisable = false;
                            self.columnFilterArr[ind].filterType = { value: '=', text: 'is'};
                            self.columnFilterArr[ind].filterOptionValue = {value:'pending',text:'Pending'};
                            self.columnFilterArr[ind].columnId.field = 'status';
                            self.columnFilterArr[ind].columnId.label = "Status";
                            self.columnFilterArr[ind].columnId.fpFieldType = 'option';
                            self.columnFilterArr[ind].filterTypeArr = [{ value: '=', text: 'is'}, { value: '!=', text: 'is not'}];
                            self.columnFilterArr[ind].filterOption = self.policyStatusArr;
                            self.columnFilterArr[ind].filterValue = '';
                        },200);
                    }

                    if (self.moduleName == 'warrantyClaimReport'){
                        var ind = 0;

                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                            filterDupValue:[{value:"",type:""}]
                        }];
                        setTimeout(function(){
                            $("#filterOption"+ind).removeClass('hide');
                            $("#filterInput"+ind).addClass('hide');
                            $("#filterDate"+ind).addClass('hide');
                            $("#filterDateRange"+ind).addClass('hide');
                            $("#startDate"+ind).addClass('hide');

                            self.columnFilterArr[ind].columnId = {};
                            self.columnFilterArr[ind].isColumnDisable = false;
                            self.columnFilterArr[ind].filterType = { value: '=', text: 'is'};
                            self.columnFilterArr[ind].filterOptionValue = 'Open';
                            self.columnFilterArr[ind].columnId.field = 'claim_status';
                            self.columnFilterArr[ind].columnId.label = "Claim Status (Open/Closed)";
                            self.columnFilterArr[ind].columnId.fpFieldType = 'option';
                            self.columnFilterArr[ind].filterTypeArr = [{ value: '=', text: 'is'}, { value: '!=', text: 'is not'}];
                            self.columnFilterArr[ind].filterOption = ['Open','Closed'];
                            self.columnFilterArr[ind].filterValue = '';
                            self.columnFilterArr[ind].filterDupValue[0]['value'] = 'Open';
                            self.columnFilterArr[ind].filterDupValue[0]['type'] = '=';
                        },200);
                    }
                    if ( self.moduleName == 'generalLedgerReport' || self.moduleName == "workOrderAccountingTransactions" ) {
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                            filterDupValue:[{value:"",type:""}]
                        }];
                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").removeClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');

                            self.columnFilterArr[0].columnId = {};
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = { value: '=', text: 'is equal'};
                            self.columnFilterArr[0].filterOptionValue = null;
                            self.columnFilterArr[0].columnId.field = 'gl_year';
                            if ( self.moduleName == "workOrderAccountingTransactions" ) {
                                self.columnFilterArr[0].columnId.label = "GL Year";
                            } else {
                                self.columnFilterArr[0].columnId.label = "Year";
                            }
                            self.columnFilterArr[0].columnId.fpFieldType = 'integer';
                            self.columnFilterArr[0].columnId.type = 'number';
                            self.columnFilterArr[0].filterTypeArr = self.integerArr;
                            self.columnFilterArr[0].filterValue = new Date().getFullYear();
                            self.columnFilterArr[0].filterDupValue[0]['value'] = new Date().getFullYear();
                            self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        },200);
                    }
                    //from trial balance report to general ledger list with filter value
                    if (self.fromDashboard != undefined && self.fromDashboard == 'trialbalance'){
                        var ind = 0;
                        if (self.columnFilterArr != undefined && self.columnFilterArr.length){
                            ind = self.columnFilterArr.length - 1;
                        }
                        if (self.$route.query.data != undefined && self.$route.query.data != null) {
                            var urlData = atob(self.$route.query.data);
                            if (urlData != null && urlData != "") {
                                var webloc = window.location.href;
                                var url = new URL(webloc+"?"+urlData);
                                var yearVal = url.searchParams.get("year");
                                var monthVal = url.searchParams.get("month");
                                var codeVal = url.searchParams.get("code");

                                if (yearVal != null && yearVal != "") {
                                    self.columnFilterArr = [{
                                        columnId:null,
                                        isColumnDisable:false,
                                        filterValue: null,
                                        filterDateValue: null,
                                        filterDateRangeValue: null,
                                        filterOptionValue: null,
                                        filterType: null,
                                        filterOption:[],
                                    }];
                                    setTimeout(function(){
                                        $("#filterOption"+ind).addClass('hide');
                                        $("#filterInput"+ind).removeClass('hide');
                                        $("#filterDate"+ind).addClass('hide');
                                        $("#filterDateRange"+ind).addClass('hide');
                                        $("#startDate"+ind).addClass('hide');

                                        self.columnFilterArr[ind].columnId = {};
                                        self.columnFilterArr[ind].isColumnDisable = true;
                                        self.columnFilterArr[ind].filterType = { value: '=', text: 'is equal'};
                                        self.columnFilterArr[ind].filterOptionValue = null;
                                        self.columnFilterArr[ind].columnId.field = 'gl_year';
                                        self.columnFilterArr[ind].columnId.label = "GL Year";
                                        self.columnFilterArr[ind].columnId.fpFieldType = 'integer';
                                        self.columnFilterArr[ind].columnId.type = 'number';
                                        self.columnFilterArr[ind].filterTypeArr = self.integerArr;
                                        self.columnFilterArr[ind].filterValue = yearVal;
                                    },200);
                                }
                                if (monthVal != null && monthVal != "") {
                                    var monthInd = 0;
                                    if (self.columnFilterArr != undefined && self.columnFilterArr.length){
                                        self.columnFilterArr.push({
                                            columnId:null,
                                            isColumnDisable:false,
                                            filterValue: null,
                                            filterDateValue: null,
                                            filterDateRangeValue: null,
                                            filterOptionValue: null,
                                            filterType: null,
                                            filterOption:[],
                                        });
                                        monthInd = self.columnFilterArr.length - 1;
                                        setTimeout(function(){
                                            $("#filterOption"+monthInd).addClass('hide');
                                            $("#filterInput"+monthInd).removeClass('hide');
                                            $("#filterDate"+monthInd).addClass('hide');
                                            $("#filterDateRange"+monthInd).addClass('hide');
                                            $("#startDate"+monthInd).addClass('hide');

                                            self.columnFilterArr[monthInd].columnId = {};
                                            self.columnFilterArr[monthInd].isColumnDisable = true;
                                            self.columnFilterArr[monthInd].filterType = { value: '=', text: 'is equal'};
                                            self.columnFilterArr[monthInd].filterOptionValue = null;
                                            self.columnFilterArr[monthInd].columnId.field = 'gl_period';
                                            self.columnFilterArr[monthInd].columnId.label = "GL Period";
                                            self.columnFilterArr[monthInd].columnId.fpFieldType = 'integer';
                                            self.columnFilterArr[monthInd].columnId.type = 'number';
                                            self.columnFilterArr[monthInd].filterTypeArr = self.integerArr;
                                            self.columnFilterArr[monthInd].filterValue = monthVal;
                                        },200);
                                    }
                                }
                                if (codeVal != null && codeVal != "") {
                                    var codeInd = 0;
                                    if (self.columnFilterArr != undefined && self.columnFilterArr.length){
                                        self.columnFilterArr.push({
                                            columnId:null,
                                            isColumnDisable:false,
                                            filterValue: null,
                                            filterDateValue: null,
                                            filterDateRangeValue: null,
                                            filterOptionValue: null,
                                            filterType: null,
                                            filterOption:[],
                                        });
                                        codeInd = self.columnFilterArr.length - 1;
                                        setTimeout(function(){
                                            $("#filterOption"+codeInd).addClass('hide');
                                            $("#filterInput"+codeInd).removeClass('hide');
                                            $("#filterDate"+codeInd).addClass('hide');
                                            $("#filterDateRange"+codeInd).addClass('hide');
                                            $("#startDate"+codeInd).addClass('hide');

                                            self.columnFilterArr[codeInd].columnId = {};
                                            self.columnFilterArr[codeInd].isColumnDisable = true;
                                            self.columnFilterArr[codeInd].filterType = { value: 'like', text: 'contains'};
                                            self.columnFilterArr[codeInd].filterOptionValue = null;
                                            self.columnFilterArr[codeInd].columnId.field = 'account_code';
                                            self.columnFilterArr[codeInd].columnId.label = "GL Account Code";
                                            self.columnFilterArr[codeInd].columnId.fpFieldType = 'text';
                                            self.columnFilterArr[codeInd].filterTypeArr = self.textArr;
                                            self.columnFilterArr[codeInd].filterOption = [];
                                            self.columnFilterArr[codeInd].filterValue = codeVal;
                                        },200);
                                    }
                                }
                            }
                        }
                    }
                    if (self.moduleName == 'FuelInventoryClearingSummaryReport'){
                        self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        },{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        },{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue:[{value:"",type:""}]
                        }];
                        var filterTypeArrVal=[{value:'=',text:'is'}];
                        //Set Default Begignig of Month date in Start Date
                        self.columnFilterArr[0].columnId = {
                            "label": "Period End Date",
                            "field": "end_date",
                            "filterable": false,
                            "fpFieldType": "text",
                            "fpMandatory":true,
                            "hidden": true,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOption = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[0].filterValue = 'E-1M';
                        self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].isColumnDisable = true;
                        self.columnFilterArr[0].filterDupValue[0]['value'] = 'E-1M';
                        self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                        self.columnFilterArr[1].columnId = {
                            "label": "Nat Acct",
                            "field": "natural_account",
                            "filterable": false,
                            "fpFieldType": "text",
                            "fpMandatory":true,
                            "hidden": false,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };

                        self.columnFilterArr[1].isColumnDisable = false;
                        self.columnFilterArr[1].filterType = {};
                        self.columnFilterArr[1].filterOption = {};
                        self.columnFilterArr[1].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[1].filterType = self.reportTextArr[0];
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[1].filterValue = '1113';
                        self.columnFilterArr[1].filterTypeArr = self.reportTextArr;
                        self.columnFilterArr[1].filterOption = [];
                        self.columnFilterArr[1].isColumnDisable = true;
                        self.columnFilterArr[1].filterDupValue[0]['value'] = '1113';
                        self.columnFilterArr[1].filterDupValue[0]['type'] = 'like';


                        self.columnFilterArr[2].columnId = {
                            "label": "GL Source",
                            "field": "gl_source_code",
                            "filterable": false,
                            "fpFieldType": "text",
                            "fpMandatory":false,
                            "hidden": false,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };

                        self.columnFilterArr[2].isColumnDisable = false;
                        self.columnFilterArr[2].filterType = {};
                        self.columnFilterArr[2].filterOption = {};
                        self.columnFilterArr[2].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[2].filterType = self.reportTextArr[0];
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[2].filterValue = 'T';
                        self.columnFilterArr[2].filterTypeArr = self.reportTextArr;
                        self.columnFilterArr[2].filterOption = [];
                        self.columnFilterArr[2].isColumnDisable = true;
                        self.columnFilterArr[2].filterDupValue[0]['value'] = 'T';
                        self.columnFilterArr[2].filterDupValue[0]['type'] = 'like';

                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").removeClass('hide');

                            $("#filterOption1").addClass('hide');
                            $("#filterInput1").removeClass('hide');
                            $("#filterDate1").addClass('hide');
                            $("#filterDateRange1").addClass('hide');
                            $("#startDate1").addClass('hide');

                            $("#filterOption2").addClass('hide');
                            $("#filterInput2").removeClass('hide');
                            $("#filterDate2").addClass('hide');
                            $("#filterDateRange2").addClass('hide');
                            $("#startDate2").addClass('hide');

                        },500);
                    }
                    if (self.moduleName == 'contractEquipmentAsAt'){
                      self.includeContractEquipmentFilter('load');
                    }
                }
            }
            },
            checkSearchedOption(index){
                const selectComponent = this.$refs['selectOptionRef' + index][0];
                const enteredValue = selectComponent.search;
                const existsInOptions = selectComponent.filteredOptions.some(option => option.text === enteredValue);
                if (!existsInOptions) {
                    this.$nextTick(() => {
                        selectComponent.search = '';
                    });
                }
            },
            selectAllMultipleSelectOptions(event, options, index){
                if (event.target.checked) {
                    this.columnFilterArr[index].filterOptionValue = options;
                } else {
                    this.columnFilterArr[index].filterOptionValue = '';
                }
            },
            addNumber:function(action, index){
                var self = this;
                var filterindex=index;
                if (action === 'add') {
                    self.number += 1;
                    self.columnFilterArr[filterindex].filterValue=self.number;
                } else if (action === 'remove') {
                    self.number -= 1;
                    self.columnFilterArr[filterindex].filterValue=self.number;
                }
            },
          loadDefaultFiltersOnload: function () {
            var self = this;
            self.$parent.loading = true;
            $.ajax({
              url: process.env.ROOT_API + "/fetch-filters-by-default",
              type: "GET",
              headers: this.ajxHeaders,
              data: {
                list_name: self.moduleName,
                filter_id: self.tempFilterId
              },
              dataType: "json",
              success: function (data) {
                self.$parent.loading = false;
                if (data.status == "success") {
                  self.columnFilterArr = [];

                  var contentArr = data.content;
                  if (contentArr && contentArr.length > 0) {
                    // for(var i = 0; i < contentArr.length; i++){
                    var i = 0;
                    contentArr.forEach(contentArr => {
                      if (contentArr.columnId !== null) {

                        self.isTypeChange = false
                        self.onsearchFilterFlag = true;

                        $("#filterInput" + i).addClass('hide');
                        $("#filterOption" + i).addClass('hide');
                        $("#filterDate" + i).addClass('hide');
                        $("#filterDateRange" + i).addClass('hide');
                        $("#duration" + i).addClass('hide');
                        $("#month_period" + i).addClass('hide');


                        if (contentArr.columnId.fpFieldType == 'option') {
                          self.columnFilterArr.push({
                            filterType: contentArr.filterType,
                            columnId: contentArr.columnId,
                            isColumnDisable: contentArr.isColumnDisable,
                            filterTypeArr: contentArr.filterTypeArr,
                            filterOptionValue: contentArr.filterOptionValue,
                            filterOption: contentArr.filterOption,
                            multiple: contentArr.multiple != undefined ? contentArr.multiple : false,
                          });
                          var l = i;
                          setTimeout(function () {
                            $("#filterOption" + l).removeClass('hide');
                            $("#filterInput" + l).addClass('hide');
                            $("#filterDate" + l).addClass('hide');
                            $("#filterDateRange" + l).addClass('hide');
                            $("#duration" + l).addClass('hide');
                            $("#month_period" + l).addClass('hide');
                          }, 100);

                        }

                        if (contentArr.columnId.fpFieldType == 'text') {
                          // alert('ehe.,o');
                          self.columnFilterArr.push({
                            filterType: contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable: contentArr.isColumnDisable,
                            filterTypeArr: contentArr.filterTypeArr,
                          });
                          var k = i;


                          if ((self.columnFilterArr[i].columnId.field == 'start_date' || self.columnFilterArr[i].columnId.field == 'end_date') && (self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == 'fuelTicketList' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == "weeklyRentalReport" || self.moduleName == 'debtNoteRollForward' || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'rentalActivityReport')) {

                            self.calculateStateEndDateValue(k, self.columnFilterArr[i].filterValue);
                            setTimeout(function () {
                              $("#filterInput" + k).addClass('hide');
                              $("#filterOption" + k).addClass('hide');
                              $("#filterDate" + k).addClass('hide');
                              $("#filterDateRange" + k).addClass('hide');
                              $("#startDate" + k).removeClass('hide');
                              $("#duration" + k).addClass('hide');
                              $("#month_period" + k).addClass('hide');
                            }, 100);
                          } else {

                            setTimeout(function () {
                              $("#filterInput" + k).removeClass('hide');
                              $("#filterOption" + k).addClass('hide');
                              $("#filterDate" + k).addClass('hide');
                              $("#filterDateRange" + k).addClass('hide');
                              $("#startDate" + k).addClass('hide');
                              $("#duration" + k).addClass('hide');
                              $("#month_period" + k).addClass('hide');
                            }, 100);
                          }

                        }
                        if (contentArr.columnId.fpFieldType == 'date') {
                          if (contentArr.filterType.value == 'duration') {
                            self.columnFilterArr.push({
                              filterType: contentArr.filterType,
                              filterValue: contentArr.filterValue,
                              columnId: contentArr.columnId,
                              isColumnDisable: contentArr.isColumnDisable,
                              filterTypeArr: contentArr.filterTypeArr,
                            });

                            var d = i;

                            self.calculateStateEndDateValue(d + "startduration", contentArr.filterValue[0]);
                            self.calculateStateEndDateValue(d + "endduration", contentArr.filterValue[1]);
                            self.durationRange[d] = contentArr.filterValue;
                            setTimeout(function () {
                              $("#filterOption" + d).addClass('hide');
                              $("#filterInput" + d).addClass('hide');
                              $("#filterDate" + d).addClass('hide');
                              $("#filterDateRange" + d).addClass('hide');
                              $("#duration" + d).removeClass('hide');
                              $("#month_period" + d).addClass('hide');
                            }, 100);
                          } else {
                            self.columnFilterArr.push({
                              filterType: contentArr.filterType,
                              filterDateValue: (contentArr.filterDateValue != null && contentArr.filterDateValue != undefined ? contentArr.filterDateValue : null),
                              columnId: contentArr.columnId,
                              isColumnDisable: contentArr.isColumnDisable,
                              filterTypeArr: contentArr.filterTypeArr,
                              filterDateRangeValue: null
                            });

                            var selectedDateArr = '';
                            if (contentArr.filterType.value == 'between') {
                              var s = 0;
                              if (contentArr.filterDateRangeValue != null && contentArr.filterDateRangeValue.length > 0) {
                                contentArr.filterDateRangeValue.forEach(filterDateRangeValue => {

                                  // for( var s=0; s<contentArr.filterDateRangeValue.length; s++ ) {

                                  if (s == 0) {

                                    selectedDateArr = filterDateRangeValue;
                                    // $("#date-range"+i).attr('startDate',contentArr[i].filterDateRangeValue[j]);

                                  } else {

                                    selectedDateArr += ' - ' + filterDateRangeValue;

                                  }
                                  s++;
                                });
                              }

                              self.handleChange(selectedDateArr, i, 'custom');
                            }

                            var m = i;

                            setTimeout(function () {
                              $("#filterOption" + m).addClass('hide');
                              $("#filterInput" + m).addClass('hide');
                              $("#duration" + m).addClass('hide');
                              $("#month_period" + m).addClass('hide');
                              if (contentArr.filterType.value == 'between') {

                                $("#filterDateRange" + m).removeClass('hide');
                                $("#filterDate" + m).addClass('hide');
                                $("#date_range" + m + " .text-field__filled").val(selectedDateArr);
                              } else {
                                $("#filterDateRange" + m).addClass('hide');
                                $("#filterDate" + m).removeClass('hide');
                              }

                            }, 100);
                          }
                        }
                        if (contentArr.columnId.fpFieldType == 'number') {
                          // this.flag[index] = 'input';
                          self.columnFilterArr.push({
                            filterType: contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable: contentArr.isColumnDisable,
                            filterTypeArr: contentArr.filterTypeArr,
                          });
                          var j = i;
                          setTimeout(function () {
                            $("#filterOption" + j).addClass('hide');
                            $("#filterInput" + j).removeClass('hide');
                            $("#filterDate" + j).addClass('hide');
                            $("#filterDateRange" + j).addClass('hide');
                            $("#duration" + j).addClass('hide');
                            $("#month_period" + j).addClass('hide');
                          }, 100);

                        }
                        if (contentArr.columnId.fpFieldType == 'integer') {

                          self.columnFilterArr.push({
                            filterType: contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable: contentArr.isColumnDisable,
                            filterTypeArr: contentArr.filterTypeArr,
                          });
                          var a = i;
                          if (contentArr.filterType.value == 'month_period') {
                            var a = i;
                            self.calculateStateEndDateValue(a + "startduration", contentArr.filterValue[0]);
                            self.calculateStateEndDateValue(a + "endduration", contentArr.filterValue[1]);
                            self.durationRange[a] = contentArr.filterValue;
                            setTimeout(function () {
                              $("#filterOption" + a).addClass('hide');
                              $("#filterInput" + a).addClass('hide');
                              $("#startDate" + a).addClass('hide');
                              $("#filterDateRange" + a).addClass('hide');
                              $("#filterDate" + a).addClass('hide');
                              $("#month_period" + a).removeClass('hide');
                            }, 100);
                          } else {
                            setTimeout(function () {
                              $("#filterOption" + a).addClass('hide');
                              $("#filterInput" + a).removeClass('hide');
                              $("#filterDate" + a).addClass('hide');
                              $("#filterDateRange" + a).addClass('hide');
                              $("#month_period" + a).addClass('hide');
                            }, 100);
                          }

                        }
                        if (contentArr.columnId.fpFieldType == 'is') {

                          self.columnFilterArr.push({
                            filterType: contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable: contentArr.isColumnDisable,
                            filterTypeArr: contentArr.filterTypeArr,
                          });
                          var a = i;
                          setTimeout(function () {
                            $("#filterOption" + a).addClass('hide');
                            $("#filterInput" + a).removeClass('hide');
                            $("#filterDate" + a).addClass('hide');
                            $("#filterDateRange" + a).addClass('hide');
                            $("#duration" + a).addClass('hide');
                            $("#month_period" + a).addClass('hide');
                          }, 100);
                        }
                        //year and period filter type
                        if (contentArr.columnId.fpFieldType == 'year' || contentArr.columnId.fpFieldType == 'period') {

                          self.columnFilterArr.push({
                            filterType: contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable: contentArr.isColumnDisable,
                            filterTypeArr: contentArr.filterTypeArr,
                          });
                          var n = i;

                          setTimeout(function () {
                            $("#filterInput" + n).removeClass('hide');
                            $("#filterOption" + n).addClass('hide');
                            $("#filterDate" + n).addClass('hide');
                            $("#filterDateRange" + n).addClass('hide');
                            $("#startDate" + n).addClass('hide');
                            $("#duration" + n).addClass('hide');
                            $("#month_period" + n).addClass('hide');
                          }, 100);
                        }
                        //aging date filter
                        if (contentArr.columnId.fpFieldType == 'aging_date') {

                          contex.columnFilterArr.push({
                            filterType: contentArr.filterType,
                            filterDateValue: (contentArr.filterDateValue != null && contentArr.filterDateValue != undefined ? contentArr.filterDateValue : null),
                            columnId: contentArr.columnId,
                            isColumnDisable: contentArr.isColumnDisable,
                            filterTypeArr: contentArr.filterTypeArr,
                            filterDateRangeValue: null,
                          });
                          var p = i;

                          setTimeout(function () {
                            $("#filterInput" + p).addClass('hide');
                            $("#filterOption" + p).addClass('hide');
                            $("#filterDate" + p).removeClass('hide');
                            $("#filterDateRange" + p).addClass('hide');
                            $("#startDate" + p).addClass('hide');
                            $("#duration" + p).addClass('hide');
                            $("#month_period" + p).addClass('hide');
                          }, 100);

                        }
                        //custom date filter type
                        if (contentArr.columnId.fpFieldType == 'custom_date') {
                          self.columnFilterArr.push({
                            filterType: contentArr.filterType,
                            filterDateValue: (contentArr.filterDateValue != undefined && contentArr.filterDateValue != null ? contentArr.filterDateValue : null),
                            columnId: contentArr.columnId,
                            isColumnDisable: contentArr.isColumnDisable,
                            filterTypeArr: contentArr.filterTypeArr,
                            filterDateRangeValue: null,
                            filterValue: (contentArr.filterValue != undefined && contentArr.filterValue != null ? contentArr.filterValue : null),
                          });
                          var selectedDateArr = '';
                          if (contentArr.filterType.value == 'between' || contentArr.filterType.value == 'not between') {
                            var s = 0;
                            if (contentArr.filterDateRangeValue != null && contentArr.filterDateRangeValue.length > 0) {

                              contentArr.filterDateRangeValue.forEach(filterDateRangeValue => {
                                if (s == 0) {
                                  selectedDateArr = filterDateRangeValue;
                                  // $("#date-range"+i).attr('startDate',contentArr[i].filterDateRangeValue[j]);
                                } else {
                                  selectedDateArr += ' - ' + filterDateRangeValue;
                                }
                                s++;
                              });
                            }

                            contex.handleChange(selectedDateArr, i, 'custom');
                            var z = i;

                            setTimeout(function () {
                              $("#filterOption" + z).addClass('hide');
                              $("#filterInput" + z).addClass('hide');
                              $("#duration" + z).addClass('hide');
                              $("#filterDateRange" + z).removeClass('hide');
                              $("#filterDate" + z).addClass('hide');
                              $("#date_range" + z + " .text-field__filled").val(selectedDateArr);
                              $("#month_period" + z).addClass('hide');
                            }, 100);
                          } else if (contentArr.filterType.value == 'IS NULL' || contentArr.filterType.value == 'IS NOT NULL') {
                            var z = i;
                            setTimeout(function () {
                              $("#filterOption" + z).addClass('hide');
                              $("#filterInput" + z).addClass('hide');
                              $("#duration" + z).addClass('hide');
                              $("#filterDateRange" + z).addClass('hide');
                              $("#filterDate" + z).removeClass('hide');
                              $("#month_period" + z).addClass('hide');
                            }, 100);
                          } else if (contentArr.filterType.value == 'duration') {
                            var a = i;
                            self.calculateStateEndDateValue(a + "startduration", contentArr.filterValue[0]);
                            self.calculateStateEndDateValue(a + "endduration", contentArr.filterValue[1]);
                            self.durationRange[a] = contentArr.filterValue;
                            setTimeout(function () {
                              $("#filterOption" + a).addClass('hide');
                              $("#filterInput" + a).addClass('hide');
                              $("#startDate" + a).addClass('hide');
                              $("#filterDateRange" + a).addClass('hide');
                              $("#filterDate" + a).addClass('hide');
                              $("#duration" + a).removeClass('hide');
                              $("#month_period" + a).addClass('hide');
                            }, 100);
                          } else {
                            var z = i;
                            self.calculateStateEndDateValue(z, self.columnFilterArr[i].filterValue);

                            setTimeout(function () {
                              $("#filterInput" + z).addClass('hide');
                              $("#filterOption" + z).addClass('hide');
                              $("#filterDate" + z).addClass('hide');
                              $("#filterDateRange" + z).addClass('hide');
                              $("#startDate" + z).removeClass('hide');
                              $("#month_period" + a).addClass('hide');
                            }, 100);
                          }
                        }
                        // if(self.tempFilterId > 0){
                        //   self.onColumnFilter('load');
                        // }
                      } else {
                        self.onColumnFilter('cancel');
                      }

                      i++;
                    });
                    if (self.tempFilterId > 0) {
                      self.onColumnFilter('load');
                    }
                  } else {
                    self.onColumnFilter('cancel');
                  }
                  // self.$parent.loadFilters('load');
                }
                if (self.tempFilterId > 0) {
                  for (var index = 0; index < self.columnFilterArr.length; index++) {
                    self.columnFilterArr[index].isColumnDisable = true;
                    self.columnFilterArr[index].disableAll = true;
                  }
                }

              },
              error: function (jqXHR, exception) {
                //self.loading = false;
                self.$parent.loadFilters('load');
                if (jqXHR.status == 0) {
                  self.errorMsg = "Remote server cannot be reached";
                } else {
                  //redirect to login page if user not authenticated
                  if (jqXHR.status == 401) {
                    //clear previous data
                    localStorage.removeItem("user_obj");
                    localStorage.removeItem("tkn");
                    //EventBus.$emit("logged-in", true, "", "");
                    self.$router.push("/");
                  }
                  self.error = jqXHR.responseJSON.message;
                }
              }
            });
          },
            loadDefaultStartEndDateFilter(){
                var self = this;
                if (self.moduleName == 'manualBillingReport'){
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                            self.columnFilterArr[0].columnId = {
                                "label": "Reading From Date",
                                "field": "start_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOption = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                            self.columnFilterArr[0].filterValue = 'B-1M';
                            self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[0].filterDupValue[0]['value'] = 'B-1M';
                            self.columnFilterArr[0].filterDupValue[0]['type'] = '=';
                            self.columnFilterArr[0].filterOption = [];
                            self.columnFilterArr[0].isColumnDisable = true;

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                    //Set Default Begignig of Day date in End Date
                            self.columnFilterArr[1].columnId = {
                                "label": "Reading To Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = false;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOption = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                            self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                            self.columnFilterArr[1].filterValue = 'E-1M';
                            self.columnFilterArr[1].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[1].filterDupValue[0]['value'] = 'E-1M';
                            self.columnFilterArr[1].filterDupValue[0]['type'] = '=';
                            self.columnFilterArr[1].filterOption = [];
                            self.columnFilterArr[1].isColumnDisable = true;

                        self.calculateStateEndDateValue(1,self.columnFilterArr[1].filterValue);

                         self.columnFilterArr[2].columnId = {
                                "label": "Metric Type",
                                "field": "section",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "Section",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[2].isColumnDisable = false;
                            self.columnFilterArr[2].filterType = {};
                            self.columnFilterArr[2].filterOption = {};
                            self.columnFilterArr[2].filterOptionValue = {};
                            // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                            self.columnFilterArr[2].filterType = {value:'like',text:'contains'};
                            // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                            self.columnFilterArr[2].filterValue = 'DIST';
                            self.columnFilterArr[2].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[2].filterDupValue[0]['value'] = 'DIST';
                            self.columnFilterArr[2].filterDupValue[0]['type'] = 'like';
                            self.columnFilterArr[2].filterOption = [];
                            self.columnFilterArr[2].isColumnDisable = true;

                    setTimeout(function(){
                        $("#filterOption0").addClass('hide');
                        $("#filterInput0").addClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").removeClass('hide');

                        $("#filterOption1").addClass('hide');
                        $("#filterInput1").addClass('hide');
                        $("#filterDate1").addClass('hide');
                        $("#filterDateRange1").addClass('hide');
                        $("#startDate1").removeClass('hide');

                        $("#filterOption2").addClass('hide');
                        $("#filterInput2").removeClass('hide');
                        $("#filterDate2").addClass('hide');
                        $("#filterDateRange2").addClass('hide');
                        $("#startDate2").addClass('hide');

                    },500);
                } else if (self.moduleName == 'netBillingMetricReport'){
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                            self.columnFilterArr[0].columnId = {
                                "label": "Reading From Date",
                                "field": "start_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOption = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                            self.columnFilterArr[0].filterValue = 'B-1M';
                            self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[0].filterDupValue[0]['value'] = 'B-1M';
                            self.columnFilterArr[0].filterDupValue[0]['type'] = '=';
                            self.columnFilterArr[0].filterOption = [];
                            self.columnFilterArr[0].isColumnDisable = true;

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                    //Set Default Begignig of Day date in End Date
                            self.columnFilterArr[1].columnId = {
                                "label": "Reading To Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = false;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOption = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                            self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                            self.columnFilterArr[1].filterValue = 'E-1M';
                            self.columnFilterArr[1].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[1].filterDupValue[0]['value'] = 'E-1M';
                            self.columnFilterArr[1].filterDupValue[0]['type'] = '=';
                            self.columnFilterArr[1].filterOption = [];
                            self.columnFilterArr[1].isColumnDisable = true;

                        self.calculateStateEndDateValue(1,self.columnFilterArr[1].filterValue);

                         self.columnFilterArr[2].columnId = {
                                "label": "Metric Type",
                                "field": "section",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "Section",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[2].isColumnDisable = false;
                            self.columnFilterArr[2].filterType = {};
                            self.columnFilterArr[2].filterOption = {};
                            self.columnFilterArr[2].filterOptionValue = {};
                            // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                            self.columnFilterArr[2].filterType = {value:'like',text:'contains'};
                            // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                            self.columnFilterArr[2].filterValue = 'DIST';
                            self.columnFilterArr[2].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[2].filterDupValue[0]['value'] = 'DIST';
                            self.columnFilterArr[2].filterDupValue[0]['type'] = 'like';
                            self.columnFilterArr[2].filterOption = [];
                            self.columnFilterArr[2].isColumnDisable = true;

                    setTimeout(function(){
                        $("#filterOption0").addClass('hide');
                        $("#filterInput0").addClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").removeClass('hide');

                        $("#filterOption1").addClass('hide');
                        $("#filterInput1").addClass('hide');
                        $("#filterDate1").addClass('hide');
                        $("#filterDateRange1").addClass('hide');
                        $("#startDate1").removeClass('hide');

                        $("#filterOption2").addClass('hide');
                        $("#filterInput2").removeClass('hide');
                        $("#filterDate2").addClass('hide');
                        $("#filterDateRange2").addClass('hide');
                        $("#startDate2").addClass('hide');

                    },500);
                }else
                if (self.moduleName == 'reservationReport'){
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                            self.columnFilterArr[0].columnId = {
                                "label": "Reservation From Date",
                                "field": "start_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOption = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                            self.columnFilterArr[0].filterValue = 'B0Q';
                            self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[0].filterOption = [];
                            self.columnFilterArr[0].isColumnDisable = true;
                            self.columnFilterArr[0].filterDupValue[0]['value'] = 'B0Q';
                            self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                    //Set Default Begignig of Day date in End Date
                            self.columnFilterArr[1].columnId = {
                                "label": "Reservation To Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = false;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOption = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                            self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                            self.columnFilterArr[1].filterValue = 'P3M';
                            self.columnFilterArr[1].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[1].filterOption = [];
                            self.columnFilterArr[1].isColumnDisable = true;
                            self.columnFilterArr[1].filterDupValue[0]['value'] = 'P3M';
                            self.columnFilterArr[1].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(1,self.columnFilterArr[1].filterValue);

                    setTimeout(function(){
                        $("#filterOption0").addClass('hide');
                        $("#filterInput0").addClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").removeClass('hide');

                        $("#filterOption1").addClass('hide');
                        $("#filterInput1").addClass('hide');
                        $("#filterDate1").addClass('hide');
                        $("#filterDateRange1").addClass('hide');
                        $("#startDate1").removeClass('hide');

                    },500);
                }else
                if (self.moduleName == 'contractEquipmentUtilization'){
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                            self.columnFilterArr[0].columnId = {
                                "label": "Start Date",
                                "field": "start_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOption = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                            self.columnFilterArr[0].filterValue = 'B0M';
                            self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[0].filterOption = [];
                            self.columnFilterArr[0].isColumnDisable = true;
                            self.columnFilterArr[0].filterDupValue[0]['value'] = 'B0M';
                            self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                    //Set Default Begignig of Day date in End Date
                            self.columnFilterArr[1].columnId = {
                                "label": "End Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = false;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOption = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                            self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                            self.columnFilterArr[1].filterValue = 'E0M';
                            self.columnFilterArr[1].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[1].filterOption = [];
                            self.columnFilterArr[1].isColumnDisable = true;
                            self.columnFilterArr[1].filterDupValue[0]['value'] = 'E0M';
                            self.columnFilterArr[1].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(1,self.columnFilterArr[1].filterValue);

                    setTimeout(function(){
                        $("#filterOption0").addClass('hide');
                        $("#filterInput0").addClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").removeClass('hide');

                        $("#filterOption1").addClass('hide');
                        $("#filterInput1").addClass('hide');
                        $("#filterDate1").addClass('hide');
                        $("#filterDateRange1").addClass('hide');
                        $("#startDate1").removeClass('hide');

                    },500);
                }else
                if (self.moduleName == 'depreciationReviewReport'){
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                        self.columnFilterArr[0].columnId = {
                            "label": "Period End Date",
                            "field": "end_date",
                            "filterable": false,
                            "fpFieldType": "text",
                            "fpMandatory":true,
                            "hidden": true,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOption = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[0].filterValue = 'E-1M';
                        self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].isColumnDisable = true;
                        self.columnFilterArr[0].filterDupValue[0]['value'] = 'E-1M';
                        self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);


                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").removeClass('hide');

                        },500);

                        self.columnFilterArr[1].columnId = {
                            "label": "Cap Cost As At",
                            "field": "capital_amount",
                            "filterable": false,
                            "fpFieldType": "integer",
                            "fpMandatory":false,
                            "hidden": true,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "Capital Amount",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };
                        self.columnFilterArr[1].isColumnDisable = false;
                        self.columnFilterArr[1].filterType = {};
                        self.columnFilterArr[1].filterOption = {};
                        self.columnFilterArr[1].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[1].filterType = {value:'!=',text:'is not'};
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[1].filterValue = 0;
                        self.columnFilterArr[1].filterTypeArr = self.integerArr;
                        self.columnFilterArr[1].filterOption = [];
                        // self.columnFilterArr[1].isColumnDisable = true;
                        self.columnFilterArr[1].filterDupValue[0]['value'] = 0;
                        self.columnFilterArr[1].filterDupValue[0]['type'] = '!=';

                        setTimeout(function(){
                            $("#filterOption1").addClass('hide');
                            $("#filterInput1").removeClass('hide');
                            $("#filterDate1").addClass('hide');
                            $("#filterDateRange1").addClass('hide');
                            $("#startDate1").addClass('hide');

                        },500);
                }else
                if (self.moduleName == 'SubletInProcessReport' || self.moduleName == 'accruedLiabilityReport'){
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                            self.columnFilterArr[0].columnId = {
                                "label": "Period End Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "fpMandatory":true,
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOption = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                            self.columnFilterArr[0].filterValue = 'E-1M';
                            self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[0].filterOption = [];
                            self.columnFilterArr[0].isColumnDisable = true;
                            self.columnFilterArr[0].filterDupValue[0]['value'] = 'E-1M';
                            self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);


                      setTimeout(function(){
                                $("#filterOption0").addClass('hide');
                                $("#filterInput0").addClass('hide');
                                $("#filterDate0").addClass('hide');
                                $("#filterDateRange0").addClass('hide');
                                $("#startDate0").removeClass('hide');

                            },500);
                }else if (self.moduleName == 'FuelInventoryClearingSummaryReport'){
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                        self.columnFilterArr[0].columnId = {
                            "label": "Period End Date",
                            "field": "end_date",
                            "filterable": false,
                            "fpFieldType": "text",
                            "fpMandatory":true,
                            "hidden": true,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOption = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[0].filterValue = 'E-1M';
                        self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].isColumnDisable = true;
                        self.columnFilterArr[0].filterDupValue[0]['value'] = 'E-1M';
                        self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                        self.columnFilterArr[1].columnId = {
                            "label": "Nat Acct",
                            "field": "natural_account",
                            "filterable": false,
                            "fpFieldType": "text",
                            "fpMandatory":true,
                            "hidden": false,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };

                        self.columnFilterArr[1].isColumnDisable = false;
                        self.columnFilterArr[1].filterType = {};
                        self.columnFilterArr[1].filterOption = {};
                        self.columnFilterArr[1].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[1].filterType = self.reportTextArr[0];
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[1].filterValue = '1113';
                        self.columnFilterArr[1].filterTypeArr = self.reportTextArr;
                        self.columnFilterArr[1].filterOption = [];
                        self.columnFilterArr[1].isColumnDisable = true;
                        self.columnFilterArr[1].filterDupValue[0]['value'] = '1113';
                        self.columnFilterArr[1].filterDupValue[0]['type'] = 'like';


                        self.columnFilterArr[2].columnId = {
                            "label": "GL Source",
                            "field": "gl_source_code",
                            "filterable": false,
                            "fpFieldType": "text",
                            "fpMandatory":false,
                            "hidden": false,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };

                        self.columnFilterArr[2].isColumnDisable = false;
                        self.columnFilterArr[2].filterType = {};
                        self.columnFilterArr[2].filterOption = {};
                        self.columnFilterArr[2].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[2].filterType = self.reportTextArr[0];
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[2].filterValue = 'T';
                        self.columnFilterArr[2].filterTypeArr = self.reportTextArr;
                        self.columnFilterArr[2].filterOption = [];
                        self.columnFilterArr[2].isColumnDisable = true;
                        self.columnFilterArr[2].filterDupValue[0]['value'] = 'T';
                        self.columnFilterArr[2].filterDupValue[0]['type'] = 'like';

                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").removeClass('hide');

                            $("#filterOption1").addClass('hide');
                            $("#filterInput1").removeClass('hide');
                            $("#filterDate1").addClass('hide');
                            $("#filterDateRange1").addClass('hide');
                            $("#startDate1").addClass('hide');

                            $("#filterOption2").addClass('hide');
                            $("#filterInput2").removeClass('hide');
                            $("#filterDate2").addClass('hide');
                            $("#filterDateRange2").addClass('hide');
                            $("#startDate2").addClass('hide');

                        },500);
                }else if(self.moduleName == "weeklyRentalReport"){
                  self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                            self.columnFilterArr[0].columnId = {
                                "label": "Start Date",
                                "field": "start_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOption = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                            self.columnFilterArr[0].filterValue = 'B-1W';
                            self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[0].filterOption = [];
                            self.columnFilterArr[0].isColumnDisable = true;
                            self.columnFilterArr[0].filterDupValue[0]['value'] = 'B-1W';
                            self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                    //Set Default Begignig of Day date in End Date
                            self.columnFilterArr[1].columnId = {
                                "label": "End Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = false;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOption = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                            self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                            self.columnFilterArr[1].filterValue = 'E-1W';
                            self.columnFilterArr[1].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[1].filterOption = [];
                            self.columnFilterArr[1].isColumnDisable = true;
                            self.columnFilterArr[1].filterDupValue[0]['value'] = 'E-1W';
                            self.columnFilterArr[1].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(1,self.columnFilterArr[1].filterValue);

                      setTimeout(function(){
                                $("#filterOption0").addClass('hide');
                                $("#filterInput0").addClass('hide');
                                $("#filterDate0").addClass('hide');
                                $("#filterDateRange0").addClass('hide');
                                $("#startDate0").removeClass('hide');

                                $("#filterOption1").addClass('hide');
                                $("#filterInput1").addClass('hide');
                                $("#filterDate1").addClass('hide');
                                $("#filterDateRange1").addClass('hide');
                                $("#startDate1").removeClass('hide');

                            },500);
                }else if(self.moduleName == "debtNoteRollForward"){
                  self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                        self.columnFilterArr[0].columnId = {
                            "label": "Period Start Date",
                            "field": "start_date",
                            "filterable": false,
                            "fpFieldType": "text",
                            "hidden": true,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOption = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                        self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                        // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                        self.columnFilterArr[0].filterValue = 'B-1M';
                        self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].isColumnDisable = true;

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                    //Set Default Begignig of Day date in End Date
                        self.columnFilterArr[1].columnId = {
                            "label": "Period End Date",
                            "field": "end_date",
                            "filterable": false,
                            "fpFieldType": "text",
                            "hidden": true,
                            "filterOptions": {
                            "enabled": false,
                            "placeholder": "MM/DD/YYYY",
                            "filterValue": "",
                            "trigger": "enter"
                            },
                            "typeDef": {}
                        };
                        self.columnFilterArr[1].isColumnDisable = false;
                        self.columnFilterArr[1].filterType = {};
                        self.columnFilterArr[1].filterOption = {};
                        self.columnFilterArr[1].filterOptionValue = {};
                        // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                        self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                        // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                        self.columnFilterArr[1].filterValue = 'E-1M';
                        self.columnFilterArr[1].filterTypeArr = filterTypeArrVal;
                        self.columnFilterArr[1].filterOption = [];
                        self.columnFilterArr[1].isColumnDisable = true;

                        self.calculateStateEndDateValue(1,self.columnFilterArr[1].filterValue);

                        setTimeout(function(){
                            $("#filterOption0").addClass('hide');
                            $("#filterInput0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").removeClass('hide');

                            $("#filterOption1").addClass('hide');
                            $("#filterInput1").addClass('hide');
                            $("#filterDate1").addClass('hide');
                            $("#filterDateRange1").addClass('hide');
                            $("#startDate1").removeClass('hide');

                        },500);
                } else if (self.moduleName == "debtNoteBalanceDetail"){
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = true;
                        self.columnFilterArr[0].filterType = {};
                        self.columnFilterArr[0].filterOptionValue = {};
                        self.columnFilterArr[0].columnId.field = 'as_at_date';
                        self.columnFilterArr[0].columnId.label = "As Of Date";
                        self.columnFilterArr[0].columnId.fpFieldType = 'custom_date';
                        self.columnFilterArr[0].columnId.fpMandatory = true;
                        self.columnFilterArr[0].filterTypeArr = self.isArr;
                        self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                        self.columnFilterArr[0].filterOption = [];
                        self.columnFilterArr[0].filterValue = 'E0D';
                        self.columnFilterArr[0].filterDupValue[0]['value'] = 'E0D';
                        self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        // self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                    setTimeout(function(){

                        $("#filterOption0").addClass('hide');
                        $("#filterInput0").addClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").removeClass('hide');
                    },200);
                }else if(self.moduleName == "equipmentaccountingrecords"){
                  self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterOption:[],
                        filterDupValue:[{value:"",type:""}]
                    }];

                    self.columnFilterArr[0].columnId = {};
                    self.columnFilterArr[0].isColumnDisable = false;
                    self.columnFilterArr[0].filterType = { value: '=', text: 'is equal'};
                    self.columnFilterArr[0].filterOptionValue = null;
                    self.columnFilterArr[0].columnId.field = 'accounting_year';
                    self.columnFilterArr[0].columnId.label = "Accounting Year";
                    self.columnFilterArr[0].columnId.fpFieldType = 'integer';
                    self.columnFilterArr[0].columnId.type = 'number';
                    self.columnFilterArr[0].filterTypeArr = self.integerArr;
                    self.columnFilterArr[0].filterValue = new Date().getFullYear();
                    self.columnFilterArr[0].filterDupValue[0]['value'] = new Date().getFullYear();
                    self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                    setTimeout(function(){
                        $("#filterOption0").addClass('hide');
                        $("#filterInput0").removeClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").addClass('hide');
                    },200);
                }
                else{

                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    },{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterDupValue:[{value:"",type:""}]
                    }];
                    var filterTypeArrVal=[{value:'=',text:'is'}];
                    //Set Default Begignig of Month date in Start Date
                            self.columnFilterArr[0].columnId = {
                                "label": "Start Date",
                                "field": "start_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[0].isColumnDisable = false;
                            self.columnFilterArr[0].filterType = {};
                            self.columnFilterArr[0].filterOption = {};
                            self.columnFilterArr[0].filterOptionValue = {};
                            // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                            self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                            self.columnFilterArr[0].filterValue = 'B0M';
                            self.columnFilterArr[0].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[0].filterOption = [];
                            self.columnFilterArr[0].isColumnDisable = true;
                            self.columnFilterArr[0].filterDupValue[0]['value'] = 'B0M';
                            self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(0,self.columnFilterArr[0].filterValue);

                    //Set Default Begignig of Day date in End Date
                            self.columnFilterArr[1].columnId = {
                                "label": "End Date",
                                "field": "end_date",
                                "filterable": false,
                                "fpFieldType": "text",
                                "hidden": true,
                                "filterOptions": {
                                "enabled": false,
                                "placeholder": "MM/DD/YYYY",
                                "filterValue": "",
                                "trigger": "enter"
                                },
                                "typeDef": {}
                            };
                            self.columnFilterArr[1].isColumnDisable = false;
                            self.columnFilterArr[1].filterType = {};
                            self.columnFilterArr[1].filterOption = {};
                            self.columnFilterArr[1].filterOptionValue = {};
                            // self.columnFilterArr[1].columnId.fpFieldType = 'text';
                            self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                            // self.columnFilterArr[1].columnId = {field:'end_date',label:'End Date'};
                            self.columnFilterArr[1].filterValue = 'E0D';
                            self.columnFilterArr[1].filterTypeArr = filterTypeArrVal;
                            self.columnFilterArr[1].filterOption = [];
                            self.columnFilterArr[1].isColumnDisable = true;
                            self.columnFilterArr[1].filterDupValue[0]['value'] = 'E0D';
                            self.columnFilterArr[1].filterDupValue[0]['type'] = '=';

                        self.calculateStateEndDateValue(1,self.columnFilterArr[1].filterValue);

                      setTimeout(function(){
                                $("#filterOption0").addClass('hide');
                                $("#filterInput0").addClass('hide');
                                $("#filterDate0").addClass('hide');
                                $("#filterDateRange0").addClass('hide');
                                $("#startDate0").removeClass('hide');

                                $("#filterOption1").addClass('hide');
                                $("#filterInput1").addClass('hide');
                                $("#filterDate1").addClass('hide');
                                $("#filterDateRange1").addClass('hide');
                                $("#startDate1").removeClass('hide');

                            },500);
                }
            },
             addNewStartDateData(index){
                var self = this;

                self.startDateVal[index]='';
                self.startDateCount[index]=0;
                self.startdateLabel[index]='';
                self.startdateCategory[index]='';
                self.startdatePickerValue[index]='';
            },
            clearStartDateData(){
                var self = this;
                $('.startcatbtn').removeClass('active');
                $('.startcalanderbtn').removeClass('active');

                self.startDateVal=[];
                self.startDateCount=[];
                self.startdateLabel=[];
                self.startdateCategory=[];
                self.startdatePickerValue=[];
            },
            startDateValueChange:function(index){
                var self = this;

                self.columnFilterArr[index].filterValue= self.startdatePickerValue[index];
            },
            onStartDateChange:function(index){

                if($("#startDateData"+index).hasClass("hide")){
                     $('#startDateData'+index).removeClass('hide');
                }else{
                    $('#startDateData'+index).addClass('hide');
                }

            },
            onDateChange:function(index){
                if($("#start_DateData"+index).hasClass("hide")){
                    $('#start_DateData'+index).removeClass('hide');
                }else{
                    $('#start_DateData'+index).addClass('hide');
                }
            },
            showhideCalander:function(flag,index){
                var self = this;
                if(flag=="startdate"){
                    if($("#filterstartDate"+index).hasClass("hide")){
                        $('#filterstartDate'+index).removeClass('hide');
                        $('#startdateCountstart'+index).addClass('hide');
                         $('#startdateCountend'+index).addClass('hide');
                         $('.startdatelbl').addClass('hide');

                    }
                }
                $('.startcatbtn').removeClass('active').addClass('inactive');
                self.columnFilterArr[index].filterValue= self.startdatePickerValue[index];
                self.startdateLabel[index]="";
                self.startDateVal=[];
                self.startDateCount[index]=0;
                self.startEndDateValueLabel[index]='';
            },
            onSelecteStartDate:function(flag,index,duration=''){
                 var self = this;
                 var filterindex=index;
                 index=index+duration;

                //  $('.btn').removeClass('active').addClass('inactive');

                var end = $('#startbtn'+flag+index).parents('table');
                end.find('.btn').removeClass('active').addClass('inactive');

                //  $('.startbtn'+flag).removeClass('inactive').addClass('active');
                 $('#startbtn'+flag+index).removeClass('inactive').addClass('active');
                 $('.startcalanderbtn').removeClass('active').addClass('inactive');
                 $('#filterstartDate'+index).addClass('hide');
                 $('#startdateCountstart'+index).removeClass('hide');
                 $('#startdateCountend'+index).removeClass('hide');
                 $('.startdatelbl').removeClass('hide');

                 self.columnFilterArr[filterindex].filterValue=null;
                 var tag="Beginning";
                 var tagVal="B";
                 var value='';
                  if(self.startDateCountEnd[index]==undefined && self.startDateCount[index]==undefined ){
                      tag="Beginning";
                      tagVal="B";
                      self.startDateCount[index]=0;
                      value=self.startDateCount[index];
                  }else if(self.startDateCountEnd[index]!=undefined){
                      tag="End";
                      tagVal="E";
                      value=self.startDateCountEnd[index];
                  }
                  else if(self.startDateCount[index]!=undefined){
                      tag="Beginning";
                      tagVal="B"
                      value=self.startDateCount[index];
                  }

                 if(flag=='days'){
                    self.startdateCategory[index]='days';
                    self.startdateLabel[index]=tag+" of Today";
                 }else if(flag=='weeks'){

                    self.startdateCategory[index]='weeks';
                    self.startdateLabel[index]=tag+" of Week";
                 }else if(flag=='months'){

                    self.startdateCategory[index]='months';
                    self.startdateLabel[index]=tag+" of Month";
                 }else if(flag=='years'){

                    self.startdateCategory[index]='years';
                    self.startdateLabel[index]=tag+" of Year";
                 }

                if(flag=='days'){
                    self.startDateVal[index]=tagVal+value+"D";
                }else if(flag=='weeks'){
                    self.startDateVal[index]=tagVal+value+"W";
                }else if(flag=='months'){
                    self.startDateVal[index]=tagVal+value+"M";
                }else if(flag=='years'){
                    self.startDateVal[index]=tagVal+value+"Y";
                }
                // self.onAddRemoveBeginingStartDate('',index);
                // self.onAddRemoveEndStartDate('',index);
                if(filterindex in self.durationRange){
                    if(0 in self.durationRange[filterindex]){

                    }else{
                        self.durationRange[filterindex][0]='';
                    }
                    if(1 in self.durationRange[filterindex]){

                    }else{
                        self.durationRange[filterindex][1]='';
                    }
                }else{
                     self.durationRange[filterindex]=[];
                      self.durationRange[filterindex][0]='';
                      self.durationRange[filterindex][1]='';
                }
                if(duration=='startduration'){
                    self.durationRange[filterindex][0]=self.startDateVal[index];
                     self.columnFilterArr[filterindex].filterValue=self.durationRange[filterindex];
                     self.calculateStateEndDateValue(index,self.durationRange[filterindex][0]);
                }else if(duration=='endduration'){
                    self.durationRange[filterindex][1]=self.startDateVal[index];
                    self.columnFilterArr[filterindex].filterValue=self.durationRange[filterindex];
                    self.calculateStateEndDateValue(index,self.durationRange[filterindex][1]);
                }else{
                    self.columnFilterArr[filterindex].filterValue=self.startDateVal[index];
                    self.calculateStateEndDateValue(index,self.columnFilterArr[filterindex].filterValue);
                }

                // self.columnFilterArr[filterindex].filterValue=self.startDateVal[index];
                // self.calculateStateEndDateValue(index,self.columnFilterArr[filterindex].filterValue);
            },
            calculateStateEndDateValue(index,value){
                var self = this;
                var firstChar=value.charAt(0);
                var lastChar= value.charAt(value.length-1);
                var digitVal=value.substring(1, value.length-1)
                self.startEndDateValueLabel[index]='';
                if(firstChar=='B' || firstChar =='P'){
                    if(lastChar=='Y'){
                        self.startEndDateValueLabel[index]=moment().add('years', digitVal).startOf('year').format("MM/DD/YYYY");
                    }
                    if(lastChar=='M'){
                        self.startEndDateValueLabel[index]=moment().add('months', digitVal).startOf('month').format("MM/DD/YYYY");
                    }
                    if(lastChar=='W'){
                        self.startEndDateValueLabel[index]=moment().add('weeks', digitVal).startOf('week').format("MM/DD/YYYY");
                    }
                    if(lastChar=='D'){
                        self.startEndDateValueLabel[index]=moment().add('days', digitVal).startOf('day').format("MM/DD/YYYY");
                    }
                    if(lastChar=='Q'){
                        self.startEndDateValueLabel[index]=moment().add('quarter', digitVal).startOf('quarter').format("MM/DD/YYYY");
                    }
                }else if(firstChar=='E'){
                    if(lastChar=='Y'){
                        self.startEndDateValueLabel[index]=moment().add('years', digitVal).endOf('year').format("MM/DD/YYYY");
                    }
                    if(lastChar=='M'){
                        self.startEndDateValueLabel[index]=moment().add('months', digitVal).endOf('month').format("MM/DD/YYYY");
                    }
                    if(lastChar=='W'){
                        self.startEndDateValueLabel[index]=moment().add('weeks', digitVal).endOf('week').format("MM/DD/YYYY");
                    }
                    if(lastChar=='D'){
                        self.startEndDateValueLabel[index]=moment().add('days', digitVal).endOf('day').format("MM/DD/YYYY");
                    }
                }else{
                    self.startEndDateValueLabel[index]='';
                }
            },
            onAddRemoveBeginingStartDate:function(flag,index,duration=''){
                var self = this;
                self.startDateCountEnd=[];
                 var filterindex=index;
                 index=index+duration;
                if(self.startdateCategory[index]!=undefined){
                if(self.startDateCount[index]!=undefined  ){
                    if(flag=='add'){
                        self.startDateCount[index]=self.startDateCount[index]+1;
                    }else{
                        self.startDateCount[index]=self.startDateCount[index]-1;
                    }
                }else{
                       self.startDateCount[index]=0;
                }
                    self.columnFilterArr[filterindex].filterValue=null;
                    if(self.startdateCategory[index]!=''){
                        if(self.startDateCount[index] > 0){
                            self.startdateLabel[index]="Beginning of "+Math.abs(self.startDateCount[index])+" "+self.startdateCategory[index]+" From now ";
                        }else if(self.startDateCount[index] < 0){
                            self.startdateLabel[index]="Beginning of "+Math.abs(self.startDateCount[index])+" "+self.startdateCategory[index]+" ago ";
                        }else{
                            self.startdateLabel[index]="Beginning of "+self.startdateCategory[index];
                        }
                    }else{
                        self.startdateLabel[index]="";
                    }
                    if(self.startdateCategory[index]=='days'){
                        self.startDateVal[index]="B"+self.startDateCount[index]+"D";

                    }else if(self.startdateCategory[index]=='weeks'){
                        self.startDateVal[index]="B"+self.startDateCount[index]+"W";
                    }else if(self.startdateCategory[index]=='months'){
                        self.startDateVal[index]="B"+self.startDateCount[index]+"M";
                    }else if(self.startdateCategory[index]=='years'){
                        self.startDateVal[index]="B"+self.startDateCount[index]+"Y";
                    }
                    if(filterindex in self.durationRange){
                    if(0 in self.durationRange[filterindex]){

                    }else{
                        self.durationRange[filterindex][0]='';
                    }
                    if(1 in self.durationRange[filterindex]){

                    }else{
                        self.durationRange[filterindex][1]='';
                    }
                }else{
                     self.durationRange[filterindex]=[];
                      self.durationRange[filterindex][0]='';
                      self.durationRange[filterindex][1]='';
                }
                    if(duration=='startduration'){
                        self.durationRange[filterindex][0]=self.startDateVal[index];
                        self.columnFilterArr[filterindex].filterValue=self.durationRange[filterindex];
                        self.calculateStateEndDateValue(index,self.durationRange[filterindex][0]);
                    }else if(duration=='endduration'){
                        self.durationRange[filterindex][1]=self.startDateVal[index];
                        self.columnFilterArr[filterindex].filterValue=self.durationRange[filterindex];
                        self.calculateStateEndDateValue(index,self.durationRange[filterindex][1]);
                    }else{
                        self.columnFilterArr[filterindex].filterValue=self.startDateVal[index];
                        self.calculateStateEndDateValue(index,self.columnFilterArr[filterindex].filterValue)
                     }
                }
            },
            onAddRemoveEndStartDate:function(flag,index,duration=''){
                var self = this;
                self.startDateCount=[];
                 var filterindex=index;
                 index=index+duration;
                if(self.startdateCategory[index]!=undefined){
                if(self.startDateCountEnd[index]!=undefined ){
                    if(flag=='add'){
                        self.startDateCountEnd[index]=self.startDateCountEnd[index]+1;
                    }else{
                        self.startDateCountEnd[index]=self.startDateCountEnd[index]-1;
                    }
                }else{
                    self.startDateCountEnd[index]=0;
                }
                    self.columnFilterArr[filterindex].filterValue=null;
                    if(self.startdateCategory[index]!=''){
                        if(self.startDateCountEnd[index] > 0){
                            self.startdateLabel[index]="End of "+Math.abs(self.startDateCountEnd[index])+" "+self.startdateCategory[index]+" From now ";
                        }else if(self.startDateCountEnd[index] < 0){
                            self.startdateLabel[index]="End of "+Math.abs(self.startDateCountEnd[index])+" "+self.startdateCategory[index]+" ago ";
                        }else{
                            self.startdateLabel[index]="End of "+self.startdateCategory[index];
                        }
                    }else{
                        self.startdateLabel[index]="";
                    }
                    if(self.startdateCategory[index]=='days'){
                        self.startDateVal[index]="E"+self.startDateCountEnd[index]+"D";

                    }else if(self.startdateCategory[index]=='weeks'){
                        self.startDateVal[index]="E"+self.startDateCountEnd[index]+"W";
                    }else if(self.startdateCategory[index]=='months'){
                        self.startDateVal[index]="E"+self.startDateCountEnd[index]+"M";
                    }else if(self.startdateCategory[index]=='years'){
                        self.startDateVal[index]="E"+self.startDateCountEnd[index]+"Y";
                    }
                    if(filterindex in self.durationRange){
                    if(0 in self.durationRange[filterindex]){

                    }else{
                        self.durationRange[filterindex][0]='';
                    }
                    if(1 in self.durationRange[filterindex]){

                    }else{
                        self.durationRange[filterindex][1]='';
                    }
                    }else{
                        self.durationRange[filterindex]=[];
                        self.durationRange[filterindex][0]='';
                        self.durationRange[filterindex][1]='';
                    }
                    if(duration=='startduration'){
                     self.durationRange[filterindex][0]=self.startDateVal[index];
                     self.columnFilterArr[filterindex].filterValue=self.durationRange[filterindex];
                     self.calculateStateEndDateValue(index,self.durationRange[filterindex][0]);
                    }else if(duration=='endduration'){
                        self.durationRange[filterindex][1]=self.startDateVal[index];
                        self.columnFilterArr[filterindex].filterValue=self.durationRange[filterindex];
                         self.calculateStateEndDateValue(index,self.durationRange[filterindex][1]);
                    }else{
                        self.columnFilterArr[filterindex].filterValue=self.startDateVal[index];
                        self.calculateStateEndDateValue(index,self.columnFilterArr[filterindex].filterValue);
                    }
                }

            },
            enableFilterSearch:function(){
                var self = this;
                self.filterSearchFlag = true;
            },
            //perform list filter action to store filter search key with private or shared
            performAction:function(val){
                var self = this;

                if ( val == 'remove') {
                    self.removeSearchedTag();
                } else {
                    self.storeSearch(val);
                }

            },
            //remove select all message
            cancelSelectAll(event) {
                $(event.target).parent().find("button").click();
            },

            storeSearch:function(flag){

                var self = this;

                var filter = '';
                var filterId = "";
                if ( self.searchFilter && self.searchFilter.value ) {
                    //self.$swal('','Filter Already Added','info');
                    //return;
                    filterId = self.searchFilter.value;
                }
                if(self.moduleName != 'publicationList'){
                    var error = self.checkFilterValidation(flag);
                }
                if (error === true){
                    return;
                }
                var privacy = flag;

                //if default filter is stored than name is not required
                if ( privacy == "default" ) {

                    if (filter == null || filter == ''){
                        filter = "Default filter";
                    }

                }else if(privacy == 'temp') {

                    if (filter == null || filter == ''){
                        filter = "Temp filter";
                    }

                }else {

                    if (self.searchFilter && self.searchFilter.text){
                        filter = self.searchFilter.text;
                    }else{
                        filter = self.searchFilter;
                    }

                    if (filter == null || filter == ''){

                        $("#filterSearchKey .dropdown-toggle").addClass('border-red');
                        return;
                    }else{
                        $("#filterSearchKey .dropdown-toggle").removeClass('border-red');
                    }

                }


                $("#storeFilter").prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/store-filters",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        search:filter,
                        filters:JSON.stringify(self.columnFilterArr),
                        list_name:self.moduleName,
                        privacy:privacy,
                        columns:JSON.stringify(self.$parent.userColumns),
                        sort:JSON.stringify(self.$parent.serverParams.sort),
                        filterId: filterId
                    },
                    dataType: "json",
                    success: function (data) {

                        $("#storeFilter").prop('disabled',false);
                        //self.loading = false;
                        if (data.code == 201) {
                            self.$swal('',data.message,'info');
                        }
                        if (data.code == 200) {

                            //add filter in filter option if not added before
                            var filterId = data.content.id;
                            var filterAdded = 0;
                            for ( var i = 0, l = self.filterOption.length; i < l; i++) {
                                if ( self.filterOption[i].value == filterId ) {
                                    filterAdded = 1;
                                }
                            }

                            if ( filterAdded == 0 && data.content.result.availability != 'temp') {
                                self.filterOption.push({text:filter,value:data.content.id});
                            }

                            self.filterSearchFlag = false;
                            self.searchFilter =  '';
                        }
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        $("#storeFilter").prop('disabled',false);
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            removeSearchedTag: function(){
                var self = this;
                var filter = '';
                if (!self.searchFilter || !self.searchFilter.value){
                    self.$swal('','Please Select Existing Filter Key','info');
                    return;
                }

                $.ajax({
                    url: process.env.ROOT_API + "/remove-filter-key",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        search:self.searchFilter.value,
                    },
                    dataType: "json",
                    success: function (data) {

                        //self.loading = false;
                        self.filterSearchFlag = false;
                        if (data.status == "success") {
                            for ( var i = 0; i < self.filterOption.length; i++ ) {
                                if(self.filterOption[i].value==self.searchFilter.value){
                                    self.filterOption.splice(i, 1);
                                }
                            }
                            self.onColumnFilter('cancel');
                            self.action = '';

                            //  self.filterOption.push({text:filter,value:data.content.id});
                        }
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });


            },
            removeTempFilter: function(){
                var self = this;
                var filter = '';

                $.ajax({
                    url: process.env.ROOT_API + "/remove-temp-filter",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        list_name:self.moduleName,
                    },
                    dataType: "json",
                    success: function (data) {
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });


            },
            removeDefaultFilter: function(){
                var self = this;
                var filter = '';

                $.ajax({
                    url: process.env.ROOT_API + "/remove-default-filter",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        list_name:self.moduleName,
                    },
                    dataType: "json",
                    success: function (data) {

                        //self.loading = false;
                        // self.filterSearchFlag = false;
                        // if (data.status == "success") {
                        //     for ( var i = 0; i < self.filterOption.length; i++ ) {
                        //         if(self.filterOption[i].value==self.searchFilter.value){
                        //             self.filterOption.splice(i, 1);
                        //         }
                        //     }
                        //     // self.onColumnFilter('cancel');
                        //     self.action = '';

                        //     //  self.filterOption.push({text:filter,value:data.content.id});
                        // }
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });


            },

            selectAllRecords(event) {
                this.$parent.serverParams.selectedAll = true;
                this.selectAllDiv = false;
                this.$parent.selectedRowCount = this.allRecords;
                this.clearSelection = true;
                this.selectionAllClear = false;
            },
            clearSelectAll(event) {
                this.$parent.serverParams.selectedAll = false;
                this.$emit('cancelSelection',true);
                this.$parent.selectedRowCount = 0;
                this.clearSelection = false;
            },
            searchCity(city){

                var self = this;

                if( city && city != undefined ) {
                    setTimeout(function(){
                        $("#filterOption0").addClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                    },200);


                    self.columnFilterArr[0].filterType = {value:'like',text:'contains'};
                    self.columnFilterArr[0].columnId = {field:'city',label:'City'};
                    self.columnFilterArr[0].filterValue = city;
                    self.columnFilterArr[0].filterTypeArr = self.textArr;
                    self.columnFilterArr[0].filterOption = [];

                    self.$nextTick(function(){

                        setTimeout(function(){
                            self.$parent.loadFilters('load');
                        },500);

                    });

                }

            },

            handleChange (values , index , flag) {
                this.values = values;
                var selectedDateArr = [];
                if (flag == 'custom'){

                    this.customRangeArr.push({'value':values,'ind':index});

                    if (values.includes('-')){
                        var arr = values.split('-');

                        for( var i=0; i<arr.length; i++ ) {
                        selectedDateArr[i] = arr[i].trim();//space at start and end of date for between filter type

                        }
                    }

                    if  (this.customRangeArr.length){
                        for( var l=0; l<this.customRangeArr.length; l++ ) {

                            $("#date_range"+this.customRangeArr[l].ind+" .text-field__filled").val(this.customRangeArr[l].value);


                        }
                    }
                }else{

                    for( var i=0; i<values.length; i++ ) {
                        selectedDateArr[i] = values[i].format('MM/DD/YYYY');

                    }
                }
                this.columnFilterArr[index].filterDateRangeValue = selectedDateArr;
            },
            onColumnFilter(flag) {

                var self = this;
                //if from schedule report form
                if (self.fromSchedule != undefined && self.fromSchedule == "schedule-report") {
                    if ( flag == 'load' ) {
                        return;
                    }else{
                        self.storeSearchEnable = false;
                        setTimeout(function(){
                            $("#filterInput0").removeClass('hide');
                            $("#filterOption0").addClass('hide');
                            $("#filterDate0").addClass('hide');
                            $("#filterDateRange0").addClass('hide');
                            $("#startDate0").addClass('hide');
                            $("#duration0").addClass('hide');
                        },200);

                        this.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                        }];

                        self.defaultColumnFilters('clear');
                        // self.setDefault();
                        self.startEndDateValueLabel=[];
                        //remove border red from inputs
                        $("#selColumnField0 .dropdown-toggle").removeClass('border-red');
                        $("#selFilterType0 .dropdown-toggle").removeClass('border-red');
                        $("#value_filter0").removeClass('border-red');
                        self.removedListColumn = [];
                        if(self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == 'depreciationReviewReport' || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == 'reservationReport'
                            || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == 'weeklyRentalReport' || self.moduleName == 'debtNoteBalanceDetail' || self.moduleName == 'rentalActivityReport' || self.moduleName == 'contractEquipmentUtilization' || self.moduleName == 'equipmentaccountingrecords'){
                            self.loadDefaultStartEndDateFilter();
                        }else{
                            if(self.moduleName == 'customerAgedTrialBalanceDetail' || self.moduleName == "apTrialBalanceAsAtDetail"){
                                self.defaultYearPeriodFilters("reset");//default filter
                            }else if (self.moduleName == 'actualMetricVSContractMetric' || self.moduleName == "actualMetricVSContractMetricReport"){
                                self.includeAnnualizedMetricLevel('reset');
                            }else if (self.moduleName == 'apVoucherDistribution'){
                                self.incluePaymentInfoFilter("reset");
                            }else if (self.moduleName == 'depreciationNBVReport'){
                                self.includeDepAsAtLevel('reset');
                            }else if(self.moduleName == 'inventoryReport'){
                                self.inventoryFilterLoad('reset');
                            }else if (self.moduleName == 'laborManagementReport'){
                                self.includeDetailLevel('reset');
                            }else if (self.moduleName == 'PMComplianceFacilityList' || self.moduleName == 'PMCompliancePoolList'){
                                self.includePMCategoryFilter('reset');
                            }else if (self.moduleName == 'PMUnitForecastList'){
                                self.includeForecastDaysFilter('reset');
                            }else if (self.moduleName == 'rentalActivityReport'){
                                // self.rentalActivityReportFilter('reset');
                            }else if (self.moduleName == 'warrantyClaimReport'){
                                self.warrantyClaimReportFilter('reset');
                            }else if (self.moduleName == "customerAgedTrialBalance"){
                                self.agedSummaryFilter('reset');
                            }else if (self.moduleName == 'bankTransferList'){
                                self.includeBankAccountFilter('reset');
                            }else if (self.moduleName == 'contractEquipmentAsAt'){
                                self.includeContractEquipmentFilter('reset');
                            }
                            //Clear StartDate and End Date related Data
                            self.clearStartDateData();
                            self.isSetStartDate=true;
                            self.isSetEndDate=true;
                        }
                        //hide all alerts
                        self.selectAllDiv = false;
                        self.clearSelection = false;
                        self.selectionAllClear = false;
                        self.isDuplicateColumn = false;
                        self.filterMaxError = '';
                        self.searchFilter = '';
                        // self.filterOption = [];
                        self.filterSearchFlag = false;

                        return;
                    }
                }

                if ( flag == 'load' ) {
                    //storeSearchEnable variable as true when flag is load
                    self.storeSearchEnable = false;
                    var error = false;
                    if(self.moduleName != 'publicationList'){
                        error = self.checkFilterValidation();
                        if ( !error ) {
                            if(self.moduleName == 'fuelTicketList'){
                                error = self.checkStartDateEndateValidation();
                            }
                        }
                    }

                    if ( !error ) {


                        self.performAction('temp'); //this calls the function to store the temp filter in db.


                        self.filterMaxError = '';
                        if(self.moduleName == 'fuelPriceCustomerList'){
                            this.$parent.loadFilters('fuelPriceCustomerList');
                        }else if(self.moduleName == 'fuelPriceAssetList'){
                            this.$parent.loadFilters('fuelPriceAssetList');
                        }else if(self.moduleName == 'cardRateCustomerList'){
                            this.$parent.loadFilters('cardRateCustomerList');
                        }else if(self.moduleName == 'statementCustomerList'){
                            this.$parent.loadFilters('statementCustomerList');
                        }else if (self.moduleName == 'CPIProofViewList'){
                            this.$parent.loadFilters('CPIProofViewList');
                        }
                        // else if(self.moduleName == 'ownedEquipment'){
                        //     this.$parent.loadFilters('ownedEquipment');
                        // }
                        // else if(self.moduleName == 'ownedEquipment' || self.moduleName == 'listVendorPayment' || self.moduleName == 'billList' || self.moduleName == 'vendorList' || self.moduleName == 'equipmentCurrentStatus' || self.moduleName == 'equipmentPoolTransfer' || self.moduleName == 'contractCustomerReport' || self.moduleName == 'depreciationReviewReport' || self.moduleName == 'depreciationNBVReport' || self.moduleName == 'disposalInvoiceListing' || self.moduleName == 'insurancePolicyReport' || self.moduleName == 'assetFeatureList'){
                        else if(self.allowSameFilter != undefined && self.allowSameFilter == 'allow'){
                            this.$parent.loadFilters('adjust');
                        }
                        // else if(self.moduleName == 'billList'){
                        //     this.$parent.loadFilters('billList');
                        // }else if(self.moduleName == 'vendorList'){
                        //     this.$parent.loadFilters('vendorList');
                        // }else if(self.moduleName == 'equipmentCurrentStatus'){
                        //     this.$parent.loadFilters('equipmentCurrentStatus');
                        // }
                        else if(self.moduleName == 'publicationList'){
                            this.populatePublicationFilters(null);
                        }
                        else{
                            this.$parent.loadFilters('filter');
                        }
                    }

                    self.searchFilter = '';
                    self.filterSearchFlag = false;

                }
                else {
                    self.storeSearchEnable = false;
                    setTimeout(function(){
                        $("#filterInput0").removeClass('hide');
                        $("#filterOption0").addClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").addClass('hide');
                        $("#duration0").addClass('hide');
                        $("#value_filter0").attr('disabled',false);
                    },200);

                    this.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                    }];

                    self.defaultColumnFilters('clear');
                    self.startEndDateValueLabel=[];
                    //this.$parent.loadList([]);
                    // self.setDefault();
                    self.loadStoredListFilters();

                    if(self.moduleName == 'accruedLiabilityReport' || self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == "depreciationReviewReport" || self.moduleName == 'reservationReport' || self.moduleName == 'contractEquipmentUtilization' || self.moduleName == 'SubletInProcessReport' || self.moduleName == 'weeklyRentalReport' || self.moduleName == 'debtNoteRollForward' || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'debtNoteBalanceDetail' || self.moduleName == 'rentalActivityReport' || self.moduleName == 'equipmentaccountingrecords' || self.moduleName == 'FuelInventoryClearingSummaryReport'){
                        self.loadDefaultStartEndDateFilter();
                        self.$parent.loadFilters('');
                    }else{
                           if(self.moduleName == 'fuelPriceCustomerList'){
                            this.$parent.loadFilters('fuelPriceCustomerList');
                        }else if(self.moduleName == 'fuelPriceAssetList'){
                            this.$parent.loadFilters('fuelPriceAssetList');
                        }else if(self.moduleName == 'cardRateCustomerList'){
                            this.$parent.loadFilters('cardRateCustomerList');
                        }else if(self.moduleName == 'statementCustomerList'){
                            this.$parent.loadFilters('statementCustomerList');
                        }else if(self.moduleName == 'assetWarrantyList'){
                            self.assetWarrantyFilter("Yes");//default filter yes
                        }else if(self.moduleName == 'customerAgedTrialBalanceDetail' || self.moduleName == "apTrialBalanceAsAtDetail"){
                            self.defaultYearPeriodFilters("reset");//default filter
                        }else if (self.moduleName == 'apVoucherDistribution'){
                            self.incluePaymentInfoFilter("reset");
                        }else if (self.moduleName == 'leaseContractExpiry' || self.moduleName == "leaseContractExpiryNonTemplate"){
                            self.includeNumberOfMonthFilter('reset');
                        }else if (self.moduleName == 'PMUnitForecastList'){
                            self.includeForecastDaysFilter('reset');
                        }else if (self.moduleName == 'PMComplianceFacilityList' || self.moduleName == 'PMCompliancePoolList'){
                            self.includePMCategoryFilter('reset');
                        }else if (self.moduleName == 'laborManagementReport'){
                            self.includeDetailLevel('reset');
                        }else if (self.moduleName == 'depreciationNBVReport'){
                            self.includeDepAsAtLevel('reset');
                        }else if (self.moduleName == 'actualMetricVSContractMetric' || self.moduleName == "actualMetricVSContractMetricReport"){
                            self.includeAnnualizedMetricLevel('reset');
                        }else if (self.moduleName == "trialBalanceReport") {
                            self.trialBalanceReportFilters('reset');
                        }else if(self.moduleName == 'inventoryReport'){
                            self.inventoryFilterLoad('reset');
                        }else if (self.moduleName == 'rentalActivityReport'){
                            // self.rentalActivityReportFilter('reset');
                        }else if (self.moduleName == 'warrantyClaimReport'){
                            self.warrantyClaimReportFilter('reset');
                        }else if(self.moduleName == 'costPerMetricByUnitReport'){
                            self.costperMetricReportFilter('reset');
                        }else if (self.moduleName == "customerAgedTrialBalance"){
                            self.agedSummaryFilter('reset');
                        }else if (self.moduleName == 'bankTransferList'){
                            self.includeBankAccountFilter('reset');
                        }else if (self.moduleName == 'contractEquipmentAsAt'){
                            self.includeContractEquipmentFilter('reset');
                        }
                        else{
                             this.$parent.loadFilters('clear');
                        }

                      //Clear StartDate and End Date related Data
                      self.clearStartDateData();
                      self.isSetStartDate=true;
                      self.isSetEndDate=true;
                    }

                    //remove border red from inputs
                    $("#selColumnField0 .dropdown-toggle").removeClass('border-red');
                    $("#selFilterType0 .dropdown-toggle").removeClass('border-red');
                    $("#value_filter0").removeClass('border-red');
                    self.removedListColumn = [];
                    //hide all alerts
                    self.selectAllDiv = false;
                    self.clearSelection = false;
                    self.selectionAllClear = false;
                    self.isDuplicateColumn = false;
                    self.filterMaxError = '';
                    self.searchFilter = '';
                    // self.filterOption = [];
                    self.filterSearchFlag = false;

                    self.removeTempFilter();
                    if(self.moduleName == "publicationList"){
                        self.populatePublicationFilters(flag);
                    }
                }

                if(flag == 'cancel'){
                    if(self.columnFilterArr.length > 0){
                        for(var i = 0;i<self.columnFilterArr.length;i++){
                            var checkbox = document.getElementById('multipleOptionCheckbox_'+i);
                            if(checkbox){
                                checkbox.checked = false;
                            }
                        }
                    }
                    $(".text-field__filled").val("");
                }
            },
            includeBankAccountFilter(flag){
                var self = this;

                if (self.moduleName == 'bankTransferList'){
                    var ind = 0;
                    if (self.columnFilterArr != undefined && self.columnFilterArr.length){
                        ind = self.columnFilterArr.length - 1;
                    }
                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterOption:[],
                        filterDupValue:[{value:"",type:""}]
                    }];
                    setTimeout(function(){
                        $("#filterOption"+ind).removeClass('hide');
                        $("#filterInput"+ind).addClass('hide');
                        $("#filterDate"+ind).addClass('hide');
                        $("#filterDateRange"+ind).addClass('hide');
                        $("#startDate"+ind).addClass('hide');
                        $("#month_period"+ind).addClass('hide');

                        self.columnFilterArr[ind].columnId = {};
                        self.columnFilterArr[ind].isColumnDisable = false;
                        self.columnFilterArr[ind].filterType = { value: '=', text: 'is'};
                        self.columnFilterArr[ind].filterOptionValue = '6880';
                        self.columnFilterArr[ind].columnId.field = 'account_number';
                        self.columnFilterArr[ind].columnId.label = "#Account";
                        self.columnFilterArr[ind].columnId.fpFieldType = 'option';
                        self.columnFilterArr[ind].filterTypeArr = [{ value: '=', text: 'is'}, { value: '!=', text: 'is not'}];
                        self.columnFilterArr[ind].filterOption = ['6880','0930','Other'];
                        self.columnFilterArr[ind].filterValue = '';
                        self.columnFilterArr[0].filterDupValue[0]['value'] = '6880';
                        self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                        if (flag == "reset") {
                            self.onColumnFilter('load');
                        }
                    },200);
                }
            },
            agedSummaryFilter(flag){
                var self = this;

                // if (self.moduleName == "customerAgedTrialBalance") {

                    self.columnFilterArr = [{
                        columnId:null,
                        isColumnDisable:false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        filterOption:[],
                    }];
                    setTimeout(function(){
                        $("#filterOption0").removeClass('hide');
                        $("#filterInput0").addClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").addClass('hide');

                        self.columnFilterArr[0].columnId = {};
                        self.columnFilterArr[0].isColumnDisable = false;
                        self.columnFilterArr[0].filterType = { value: '=', text: 'is'};
                        self.columnFilterArr[0].filterOptionValue = 'No';
                        self.columnFilterArr[0].columnId.field = 'summary';
                        self.columnFilterArr[0].columnId.label = "Summarize";
                        self.columnFilterArr[0].columnId.fpFieldType = 'option';
                        self.columnFilterArr[0].columnId.sortable = false;
                        self.columnFilterArr[0].columnId.hidden = true;
                        self.columnFilterArr[0].filterTypeArr = self.isArr;
                        self.columnFilterArr[0].columnId.fpMandatory = true;
                        self.columnFilterArr[0].filterOption = ['Yes','No'];
                        self.columnFilterArr[0].filterValue = '';

                        if (flag == "reset") {
                            self.onColumnFilter('load');
                        }
                    },200);


                // }
            },

            checkFilterValidation: function(flag = "") {

                var self = this;
                var error = false;
                var InventoryArr = [];
                var columnArr = [];
                self.isDuplicateColumn = false;
                 if(self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == 'weeklyRentalReport' || self.moduleName == 'debtNoteRollForward' || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'rentalActivityReport') {
                    self.isSetStartDate=false;
                    self.isSetEndDate=false;
                 }
                var dupCheckArr = [];
                for (var i=0; i<self.columnFilterArr.length; i++) {

                    var columnType = "";
                    if ( self.columnFilterArr[i].columnId != null ) {

                        if ( columnArr.indexOf( self.columnFilterArr[i].columnId.field) !== -1 ) {
                            // self.isDuplicateColumn = true;
                            // error = true;
                        } else {
                            columnArr.push(self.columnFilterArr[i].columnId.field);
                        }
                        if(self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == "weeklyRentalReport" || self.moduleName == 'debtNoteRollForward' || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'rentalActivityReport'){
                                if(self.columnFilterArr[i].columnId.field=='start_date'){
                                    self.isSetStartDate=true;
                                }
                                if(self.columnFilterArr[i].columnId.field=='end_date'){
                                    self.isSetEndDate=true;
                                }

                        }

                    }
                    if(self.columnFilterArr[i].columnId == null){
                        self.forFilter = '';
                    }else{
                        self.forFilter = self.columnFilterArr[i].columnId.label;
                    }

                    if ( ( self.columnFilterArr[i].columnId == null || self.columnFilterArr[i].columnId == '' || !self.columnFilterArr[i].columnId ) ) {

                        $("#selColumnField"+i+" .dropdown-toggle").addClass('border-red');
                        error = true;

                    } else {
                        //check field type
                        columnType = self.columnFilterArr[i].columnId.fpFieldType;
                        $("#selColumnField"+i+" .dropdown-toggle").removeClass('border-red');
                    }

                    if((self.columnFilterArr[i].filterType == null || self.columnFilterArr[i].filterType == '' || !self.columnFilterArr[i].filterType )) {
                        $("#selFilterType"+i+" .dropdown-toggle").addClass('border-red');
                        error = true;
                    }else{
                        $("#selFilterType"+i+" .dropdown-toggle").removeClass('border-red');
                    }
                    if( columnType == "date" || columnType == "custom_asset_availability" ){

                        if (self.columnFilterArr[i].filterType != null ) {

                            if(self.columnFilterArr[i].filterType.value == 'between'){

                                if((self.columnFilterArr[i].filterDateRangeValue == null || self.columnFilterArr[i].filterDateRangeValue == '' || !self.columnFilterArr[i].filterDateRangeValue)){
                                    $("#filterDateRange"+i+" .text-field").addClass('border-red');
                                    error = true;
                                }else{
                                    $("#filterDateRange"+i+" .text-field").removeClass('border-red');
                                }

                            }else if(self.columnFilterArr[i].filterType.value == 'duration'){

                                if((self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == '' || !self.columnFilterArr[i].filterValue)){
                                   var start =  $("#startDate"+i+"startduration").children('span');
                                     start.addClass( "btn-duration-border-red" )
                                   var end =  $("#startDate"+i+"endduration").children('span');
                                     end.addClass( "btn-duration-border-red" )
                                    error = true;
                                }else{
                                     if(self.columnFilterArr[i].filterValue[0]=='' || self.columnFilterArr[i].filterValue[0]==null){
                                        var start =  $("#startDate"+i+"startduration").children('span');
                                        start.addClass( "btn-duration-border-red" )
                                        error = true;
                                   }else if(self.columnFilterArr[i].filterValue[1]=='' || self.columnFilterArr[i].filterValue[1]==null) {
                                        var end =  $("#startDate"+i+"endduration").children('span');
                                        end.addClass( "btn-duration-border-red" )
                                        error = true;
                                   }else{
                                        var start =  $("#startDate"+i+"startduration").children('span');
                                        start.removeClass( "btn-duration-border-red" )
                                        var end =  $("#startDate"+i+"endduration").children('span');
                                        end.removeClass( "btn-duration-border-red" )

                                   }
                                }


                            } else if(self.columnFilterArr[i].filterType.value != 'IS NULL'){

                                if((self.columnFilterArr[i].filterDateValue == null || self.columnFilterArr[i].filterDateValue == '' || !self.columnFilterArr[i].filterDateValue)){
                                    $("#date_value_filter"+i).addClass('border-red');
                                    error = true;
                                }else{
                                    $("#date_value_filter"+i).removeClass('border-red');
                                }

                            }

                        } else {

                                //if try to store default filter than validation for value is not required
                                if ( flag != "default" ) {

                                    if((self.columnFilterArr[i].filterDateValue == null || self.columnFilterArr[i].filterDateValue == '' || !self.columnFilterArr[i].filterDateValue)){
                                        $("#date_value_filter"+i).addClass('border-red');
                                        error = true;
                                    }else{
                                        $("#date_value_filter"+i).removeClass('border-red');
                                    }
                                }

                        }

                    }
                    //custom date filter type
                    if( columnType == "custom_date"){
                        if (self.columnFilterArr[i].filterType != null ) {
                            if(self.columnFilterArr[i].filterType.value == 'between' || self.columnFilterArr[i].filterType.value == 'not between'){
                                if((self.columnFilterArr[i].filterDateRangeValue == null || self.columnFilterArr[i].filterDateRangeValue == '' || !self.columnFilterArr[i].filterDateRangeValue)){
                                    $("#filterDateRange"+i+" .text-field").addClass('border-red');
                                    error = true;
                                }else{
                                    $("#filterDateRange"+i+" .text-field").removeClass('border-red');
                                }
                            }else if(self.columnFilterArr[i].filterType.value == 'duration') {
                                if((self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == '' || !self.columnFilterArr[i].filterValue)){
                                   var start =  $("#startDate"+i+"startduration").children('span');
                                     start.addClass( "btn-duration-border-red" )
                                   var end =  $("#startDate"+i+"endduration").children('span');
                                     end.addClass( "btn-duration-border-red" )
                                    error = true;
                                }else{
                                     if(self.columnFilterArr[i].filterValue[0]=='' || self.columnFilterArr[i].filterValue[0]==null){
                                        var start =  $("#startDate"+i+"startduration").children('span');
                                        start.addClass( "btn-duration-border-red" )
                                        error = true;
                                   }else if(self.columnFilterArr[i].filterValue[1]=='' || self.columnFilterArr[i].filterValue[1]==null) {
                                        var end =  $("#startDate"+i+"endduration").children('span');
                                        end.addClass( "btn-duration-border-red" )
                                        error = true;
                                   }else{
                                        var start =  $("#startDate"+i+"startduration").children('span');
                                        start.removeClass( "btn-duration-border-red" )
                                        var end =  $("#startDate"+i+"endduration").children('span');
                                        end.removeClass( "btn-duration-border-red" )

                                   }
                                }
                            }else if(self.columnFilterArr[i].filterType.value != 'IS NULL' && self.columnFilterArr[i].filterType.value != 'IS NOT NULL') {
                                if((self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == '' || !self.columnFilterArr[i].filterValue)){
                                    $("#start_date_filter"+i).addClass('border-red');
                                    error = true;
                                }else{
                                    $("#start_date_filter"+i).removeClass('border-red');
                                }
                            }
                        }else{
                            //if try to store default filter than validation for value is not required
                            if ( flag != "default" ) {

                                if((self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == '' || !self.columnFilterArr[i].filterValue)){
                                    $("#start_date_filter"+i).addClass('border-red');
                                    error = true;
                                }else{
                                    $("#start_date_filter"+i).removeClass('border-red');
                                }
                            }
                        }
                    }
                    if( (columnType == "text" && (self.columnFilterArr[i].columnId.field == "start_date" || self.columnFilterArr[i].columnId.field == "end_date" ) && (self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == 'fuelTicketList' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == "weeklyRentalReport" || self.moduleName == 'debtNoteRollForward' || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'rentalActivityReport')) && (self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == '' || !self.columnFilterArr[i].filterValue) ){
                        //if try to store default filter than validation for value is not required
                        if ( flag != "default" ) {
                            $("#start_date_filter"+i).addClass('btn-border-red');
                            error = true;
                        }

                    }else{
                        $("#start_date_filter"+i).removeClass('btn-border-red');
                    }
                    if( columnType == "integer" ){
                        if (self.columnFilterArr[i].filterType != null ) {
                            if(self.columnFilterArr[i].filterType.value == 'month_period'){
                                if((self.columnFilterArr[i].filterValue != null || self.columnFilterArr[i].filterValue != '')){
                                    $("#period_filter"+i).removeClass('border-red');
                                }else{
                                    $("#period_filter"+i).addClass('border-red');
                                    error = true;
                                }
                            }
                        }else{
                            if ( flag != "default" ) {
                                if((self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == '' || !self.columnFilterArr[i].filterValue)){
                                    $("#period_filter"+i).removeClass('border-red');
                                    error = true;
                                }else{
                                    $("#period_filter"+i).addClass('border-red');
                                }
                            }
                        }
                    }
                    if ( (columnType == "text" || columnType == "" || columnType == "number" || columnType == "integer" || columnType == "year" || columnType == "period" ) && ((self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == '' || !self.columnFilterArr[i].filterValue) ) ) {
                        //if try to store default filter than validation for value is not required
                        if ( flag != "default" && self.moduleName !== "contractList") {
                          //if filterType isNull or isNotNull is selected, then remove validation set for filterValue
                          if(self.columnFilterArr[i].filterType.value == 'IS NULL' || self.columnFilterArr[i].filterType.value == 'IS NOT NULL') {
                             $("#value_filter"+i).removeClass('border-red');
                          }else{
                             $("#value_filter"+i).addClass('border-red');
                            error = true;
                            if (self.moduleName == 'inventoryReport'){
                                if (self.columnFilterArr[i].columnId.field == "as_of_year" || self.columnFilterArr[i].columnId.field == "as_of_period"){
                                    InventoryArr.push({value:self.columnFilterArr[i].filterValue,index:i,field:self.columnFilterArr[i].columnId.field});
                                }
                            }
                          }
                        }
                    }else{
                        $("#value_filter"+i).removeClass('border-red');
                        //check year or period value
                        if (columnType == "year" || columnType == "period") {
                            var checkYearPeriod = self.checkYearPeriodValue(self.columnFilterArr[i].filterValue,columnType);
                            if (!checkYearPeriod) {
                                $("#value_filter"+i).addClass('border-red');
                                error = true;
                            }else{
                                $("#value_filter"+i).removeClass('border-red');
                            }
                            if (self.moduleName == 'inventoryReport'){
                                if (self.columnFilterArr[i].columnId.field == "as_of_year" || self.columnFilterArr[i].columnId.field == "as_of_period"){
                                    InventoryArr.push({value:self.columnFilterArr[i].filterValue,index:i,field:self.columnFilterArr[i].columnId.field});
                                }
                            }
                        }
                    }
                    if ( (columnType == 'option') && (self.columnFilterArr[i].filterOptionValue == null || self.columnFilterArr[i].filterOptionValue == '' || !self.columnFilterArr[i].filterOptionValue || self.columnFilterArr[i].filterOptionValue.value == "") ) {
                        $("#filterOption"+i+" .dropdown-toggle").addClass('border-red');
                        error = true;
                    }else{
                        $("#filterOption"+i+" .dropdown-toggle").removeClass('border-red');
                    }
                    if (columnType == "aging_date") {
                        if((self.columnFilterArr[i].filterDateValue == null || self.columnFilterArr[i].filterDateValue == '' || !self.columnFilterArr[i].filterDateValue)){
                            //if try to store default filter than validation for value is not required
                            if ( flag != "default" ) {
                                $("#date_value_filter"+i).addClass('border-red');
                                error = true;
                            }
                        }else{
                            $("#date_value_filter"+i).removeClass('border-red');
                        }
                    }
                    if( columnType == "date" ){
                        if (self.columnFilterArr[i].filterType != null ) {
                            if(self.columnFilterArr[i].filterType.value == 'between'){
                                if (dupCheckArr && dupCheckArr.length > 0){
                                    for(var j=0;j<dupCheckArr.length;j++){
                                        if (dupCheckArr[j].text == self.columnFilterArr[i].columnId.field && dupCheckArr[j].value == self.columnFilterArr[i].filterDateRangeValue){
                                            error = true;
                                            self.isDuplicateColumn = true;
                                        }
                                    }
                                }
                                dupCheckArr.push({text:self.columnFilterArr[i].columnId.field,value:self.columnFilterArr[i].filterDateRangeValue,type:'range'});
                            }else{
                                if (dupCheckArr && dupCheckArr.length > 0){
                                    for(var j=0;j<dupCheckArr.length;j++){
                                        if (dupCheckArr[j].text == self.columnFilterArr[i].columnId.field && dupCheckArr[j].value == self.columnFilterArr[i].filterDateValue){
                                            error = true;
                                            self.isDuplicateColumn = true;
                                        }
                                    }
                                }
                                dupCheckArr.push({text:self.columnFilterArr[i].columnId.field,value:self.columnFilterArr[i].filterDateValue,type:'date'});
                            }
                        }

                        if (self.moduleName == 'inventoryReport'){
                            if (self.columnFilterArr[i].columnId.field == "as_at_date"){
                                InventoryArr.push({value:self.columnFilterArr[i].filterDateValue,index:i,field:self.columnFilterArr[i].columnId.field});
                            }
                        }
                    }
                    //custom date filter type
                    if( columnType == "custom_date"){
                        if (self.columnFilterArr[i].filterType != null ) {
                            if(self.columnFilterArr[i].filterType.value == 'between' || self.columnFilterArr[i].filterType.value == 'not between'){
                                if (dupCheckArr && dupCheckArr.length > 0){
                                    for(var j=0;j<dupCheckArr.length;j++){
                                        if (dupCheckArr[j].text == self.columnFilterArr[i].columnId.field && dupCheckArr[j].value == self.columnFilterArr[i].filterDateRangeValue){
                                            error = true;
                                            self.isDuplicateColumn = true;
                                        }
                                    }
                                }
                                dupCheckArr.push({text:self.columnFilterArr[i].columnId.field,value:self.columnFilterArr[i].filterDateRangeValue,type:'range'});
                            }else if (self.columnFilterArr[i].filterType.value == 'IS NULL' || self.columnFilterArr[i].filterType.value == 'IS NOT NULL') {
                                if (dupCheckArr && dupCheckArr.length > 0){
                                    for(var j=0;j<dupCheckArr.length;j++){
                                        if (dupCheckArr[j].text == self.columnFilterArr[i].columnId.field && dupCheckArr[j].value == self.columnFilterArr[i].filterDateValue){
                                            error = true;
                                            self.isDuplicateColumn = true;
                                        }
                                    }
                                }
                                dupCheckArr.push({text:self.columnFilterArr[i].columnId.field,value:self.columnFilterArr[i].filterDateValue,type:'date'});
                            }else{
                                if (dupCheckArr && dupCheckArr.length > 0){
                                    for(var j=0;j<dupCheckArr.length;j++){
                                        if (dupCheckArr[j].text == self.columnFilterArr[i].columnId.field && dupCheckArr[j].value == self.columnFilterArr[i].filterValue){
                                            error = true;
                                            self.isDuplicateColumn = true;
                                        }
                                    }
                                }
                                dupCheckArr.push({text:self.columnFilterArr[i].columnId.field,value:self.columnFilterArr[i].filterValue,type:'text'});
                            }
                            if (self.moduleName == 'inventoryReport'){
                                if (self.columnFilterArr[i].columnId.field == "as_at_date"){
                                    InventoryArr.push({value:self.columnFilterArr[i].filterValue,index:i,field:self.columnFilterArr[i].columnId.field});
                                }
                            }
                        }
                    }
                    if( columnType == "option" ){
                        if (self.columnFilterArr[i].filterType != null ) {
                            if (dupCheckArr && dupCheckArr.length > 0){
                                for(var j=0;j<dupCheckArr.length;j++){
                                    if (dupCheckArr[j].text == self.columnFilterArr[i].columnId.field && dupCheckArr[j].value == self.columnFilterArr[i].filterOptionValue){
                                        error = true;
                                        self.isDuplicateColumn = true;
                                    }
                                }
                            }
                            dupCheckArr.push({text:self.columnFilterArr[i].columnId.field,value:self.columnFilterArr[i].filterOptionValue,type:'option'});
                        }
                    }
                    if( columnType == "text" || columnType == "integer" || columnType == 'year' || columnType == 'period'){
                        if (self.columnFilterArr[i].filterType != null ) {
                            if (dupCheckArr && dupCheckArr.length > 0){
                                for(var j=0;j<dupCheckArr.length;j++){
                                    if (dupCheckArr[j].text == self.columnFilterArr[i].columnId.field && dupCheckArr[j].value == self.columnFilterArr[i].filterValue){

                                        if(self.columnFilterArr[i].filterType.value != 'IS NULL' && self.columnFilterArr[i].filterType.value != 'IS NOT NULL'){
                                          error = true;
                                          self.isDuplicateColumn = true;
                                        }

                                    }
                                }
                            }
                            dupCheckArr.push({text:self.columnFilterArr[i].columnId.field,value:self.columnFilterArr[i].filterValue,type:'text'});
                        }
                    }

                }
                if(self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == "weeklyRentalReport" || self.moduleName == 'debtNoteRollForward' || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'rentalActivityReport'){
                    if(self.isSetStartDate==false || self.isSetEndDate==false){
                        error = true;
                    }
                }

                if (self.moduleName == 'inventoryReport'){

                    if(InventoryArr.length != undefined && InventoryArr.length > 0){
                        for(var j=0;j<InventoryArr.length;j++){
                            if(InventoryArr[j].field == 'as_at_date' && InventoryArr[j].value != null && InventoryArr[j].value != ''){
                                var filterYearIndex = InventoryArr.findIndex(x => (x.field === 'as_of_year'));
                                var filterPeriodIndex = InventoryArr.findIndex(x => (x.field === 'as_of_period'));

                                if (filterYearIndex != undefined && filterYearIndex != null){
                                    $("#value_filter"+filterYearIndex).removeClass('border-red');
                                }
                                if (filterPeriodIndex != undefined && filterPeriodIndex != null){
                                    $("#value_filter"+filterPeriodIndex).removeClass('border-red');
                                }
                                error = false;
                            }
                            if(InventoryArr[j].field == 'as_of_year' && InventoryArr[j].value != null && InventoryArr[j].value != ''){
                                var filterDateIndex = InventoryArr.findIndex(x => (x.field === 'as_at_date'));
                                var filterPeriodIndex = InventoryArr.findIndex(x => (x.field === 'as_of_period'));

                                if (filterDateIndex != undefined && filterDateIndex != null){
                                    $("#date_value_filter"+filterDateIndex).removeClass('border-red');
                                }
                                if (filterPeriodIndex != undefined && filterPeriodIndex != null){
                                    $("#value_filter"+filterPeriodIndex).removeClass('border-red');
                                }
                                error = false;
                            }
                        }
                    }
                }

                return error;

            },
            checkStartDateEndateValidation: function() {
                var self = this;
                var error = false;
                self.isSetStartDate=false;
                self.isSetEndDate=false;
                for (var i=0; i<self.columnFilterArr.length; i++) {

                    var columnType = "";

                    if ( self.columnFilterArr[i].columnId != null ) {
                            if(self.columnFilterArr[i].columnId.field=='start_date'){
                                self.isSetStartDate=true;
                                if(self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == ''){
                                    error=true;
                                }
                            }
                            if(self.columnFilterArr[i].columnId.field=='end_date'){
                                 self.isSetEndDate=true;
                                if(self.columnFilterArr[i].filterValue == null || self.columnFilterArr[i].filterValue == ''){
                                    error=true;
                                }
                            }
                    }


                }
                if(self.isSetStartDate==true && self.isSetEndDate==false){
                    error=true;
                }else if(self.isSetStartDate==false && self.isSetEndDate==true)
                {
                    error=true;
                }else{
                    self.isSetStartDate=true;
                    self.isSetEndDate=true;
                }


                return error;
            },

            addLine () {

                var self = this;
                var error = false;
                var index = self.columnFilterArr.length;

                setTimeout(function(){
                    $("#filterOption"+index).addClass('hide');
                    $("#filterDate"+index).addClass('hide');
                    $("#filterDateRange"+index).addClass('hide');
                    $("#startDate"+index).addClass('hide');

                },50);
                 if(self.moduleName == 'fuelTicketList'){
                    self.isSetStartDate=true;
                    self.isSetEndDate=true;
                 }
                // if ( index > 4){
                //     self.filterMaxError = 'You can apply maximum 5 filters at time';
                //     return;
                // }else{
                //     self.filterMaxError = '';
                // }
                error = self.checkFilterValidation();

                if ( !error ) {

                    // self.columnFilterArr[index-1].isColumnDisable = true;

                    self.columnFilterArr.push({
                        columnId:null,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                        isColumnDisable:false,
                    })

                    // self.addNewStartDateData(index);
                    //allow same filter more than one time
                    // if (self.moduleName != 'ownedEquipment' && self.moduleName != 'billList' && self.moduleName != 'listVendorPayment' && self.moduleName != 'vendorList' && self.moduleName != 'equipmentCurrentStatus' && self.moduleName != 'equipmentPoolTransfer' && self.moduleName == 'contractCustomerReport' && self.moduleName == 'depreciationReviewReport' && self.moduleName == 'depreciationNBVReport' && self.moduleName == 'disposalInvoiceListing' && self.moduleName == 'insurancePolicyReport' && self.moduleName == 'assetFeatureList'){
                    if(self.allowSameFilter == undefined){
                        this.updateListColumn(self.columnFilterArr[index - 1 ].columnId,'remove');
                    }

                }

            },

            removeLine (evt,index) {
                var self = this;

                self.filterMaxError = '';
                //to enable dropdown if only single filter available
                if ( self.columnFilterArr.length == 2 ) {
                    //when only one filter is their than enable search in column
                    Vue.set(self.columnFilterArr[0], 'isColumnDisable', false);
                }
                self.durationArr.forEach(function(duration) {
                  var key = index + duration;
                  if (self.startEndDateValueLabel.hasOwnProperty(key)) {
                    delete self.startEndDateValueLabel[key];
                  }
                });
                // self.startEndDateValueLabel.splice(index, 1);
                if ( self.columnFilterArr.length > 1 ) {
                    this.updateListColumn(self.columnFilterArr[index].columnId,'add' );

                    self.columnFilterArr.splice(index, 1);
                    for ( var i=0; i < self.columnFilterArr.length; i++ ) {

                        if(self.columnFilterArr[i].columnId == null){
                            $("#filterOption"+i).addClass('hide');
                            $("#filterInput"+i).removeClass('hide');
                            $("#filterDate"+i).addClass('hide');
                            $("#filterDateRange"+i).addClass('hide');
                            $("#startDate"+i).addClass('hide');
                            $("#duration"+i).addClass('hide');
                            $("#month_period"+i).addClass('hide');

                        }else{
                            if ( self.columnFilterArr[i].columnId.fpFieldType == "option") {

                                $("#filterOption"+i).removeClass('hide');
                                $("#filterInput"+i).addClass('hide');
                                $("#month_period"+i).addClass('hide');
                                $("#filterDate"+i).addClass('hide');
                                $("#filterDateRange"+i).addClass('hide');
                                $("#startDate"+i).addClass('hide');
                                $("#duration"+i).addClass('hide');

                            }else if(self.columnFilterArr[i].columnId.fpFieldType == "text" && (self.columnFilterArr[i].columnId.field == "start_date" || self.columnFilterArr[i].columnId.field == "end_date")){
                                $("#filterOption"+i).addClass('hide');
                                $("#filterInput"+i).addClass('hide');
                                $("#month_period"+i).addClass('hide');
                                $("#filterDate"+i).addClass('hide');
                                $("#filterDateRange"+i).addClass('hide');
                                $("#startDate"+i).removeClass('hide');
                                $("#duration"+i).addClass('hide');
                            }else if ( self.columnFilterArr[i].columnId.fpFieldType == "text" || self.columnFilterArr[i].columnId.fpFieldType == "number" || self.columnFilterArr[i].columnId.fpFieldType == "year" || self.columnFilterArr[i].columnId.fpFieldType == "period") {
                                $("#filterOption"+i).addClass('hide');
                                $("#filterInput"+i).removeClass('hide');
                                $("#filterDate"+i).addClass('hide');
                                $("#filterDateRange"+i).addClass('hide');
                                $("#startDate"+i).addClass('hide');
                                $("#duration"+i).addClass('hide');
                                $("#month_period"+i).addClass('hide');

                                $("#value_filter"+i).attr('disabled',false);
                                if(self.columnFilterArr[i].filterType.value == "IS NULL" || self.columnFilterArr[i].filterType.value == "IS NOT NULL"){

                                  $("#value_filter"+i).attr('disabled',true);

                                }
                            }else if(self.columnFilterArr[i].columnId.fpFieldType == "date" || self.columnFilterArr[i].columnId.fpFieldType == "custom_asset_availability"){

                                self.isTypeChange = false;
                                $("#filterOption"+i).addClass('hide');
                                $("#filterInput"+i).addClass('hide');
                                $("#startDate"+i).addClass('hide');
                                $("#date_value_filter"+i).attr('disabled',false);
                                $("#duration"+i).addClass('hide');
                                $("#month_period"+i).addClass('hide');
                                if(self.columnFilterArr[i].filterType == null){
                                    $("#filterDate"+i).removeClass('hide');
                                    $("#filterDateRange"+i).addClass('hide');
                                }else{
                                    if(self.columnFilterArr[i].filterType != null && self.columnFilterArr[i].filterType.value == "between"){

                                        $("#filterDate"+i).addClass('hide');
                                        $("#filterDateRange"+i).removeClass('hide');

                                    }else if(self.columnFilterArr[i].filterType != null && self.columnFilterArr[i].filterType.value == "duration"){

                                        $("#duration"+i).removeClass('hide');
                                        $("#filterDate"+i).addClass('hide');

                                    }else if(self.columnFilterArr[i].filterType.value == "IS NULL"){
                                        $("#filterDate"+i).removeClass('hide');
                                        $("#filterDateRange"+i).addClass('hide');
                                        $("#date_value_filter"+i).attr('disabled',true);

                                    }else{
                                        $("#filterDate"+i).removeClass('hide');
                                        $("#filterDateRange"+i).addClass('hide');
                                    }
                                }
                            }else if (self.columnFilterArr[i].columnId.fpFieldType == "aging_date") {
                                $("#filterOption"+i).addClass('hide');
                                $("#filterInput"+i).addClass('hide');
                                $("#filterDate"+i).removeClass('hide');
                                $("#filterDateRange"+i).addClass('hide');
                                $("#startDate"+i).addClass('hide');
                                $("#duration"+i).addClass('hide');
                                $("#month_period"+i).addClass('hide');
                            }else if (self.columnFilterArr[i].columnId.fpFieldType == "custom_date") {
                                self.isTypeChange = false;
                                $("#filterOption"+i).addClass('hide');
                                $("#filterInput"+i).addClass('hide');
                                $("#startDate"+i).addClass('hide');
                                $("#date_value_filter"+i).attr('disabled',false);
                                $("#duration"+i).addClass('hide');
                                $("#month_period"+i).addClass('hide');
                                if(self.columnFilterArr[i].filterType == null){
                                    $("#filterDate"+i).removeClass('hide');
                                    $("#filterDateRange"+i).addClass('hide');
                                }else{
                                    if(self.columnFilterArr[i].filterType != null && (self.columnFilterArr[i].filterType.value == "between" || self.columnFilterArr[i].filterType.value == "not between")){

                                        $("#filterDate"+i).addClass('hide');
                                        $("#filterDateRange"+i).removeClass('hide');

                                    }else if(self.columnFilterArr[i].filterType.value == "IS NULL" || self.columnFilterArr[i].filterType.value == "IS NOT NULL"){
                                        $("#filterDate"+i).removeClass('hide');
                                        $("#filterDateRange"+i).addClass('hide');
                                        $("#date_value_filter"+i).attr('disabled',true);

                                    }else if(self.columnFilterArr[i].filterType.value == "duration") {
                                        $("#filterDate"+i).addClass('hide');
                                        $("#filterDateRange"+i).addClass('hide');
                                        $("#duration"+i).removeClass('hide');
                                    }else{
                                        $("#filterDate"+i).addClass('hide');
                                        $("#filterDateRange"+i).addClass('hide');
                                        $("#startDate"+i).removeClass('hide');
                                    }
                                }
                            }else if (self.columnFilterArr[i].columnId.fpFieldType == "integer") {
                                self.isTypeChange = false;
                                $("#filterOption"+i).addClass('hide');
                                $("#filterInput"+i).addClass('hide');
                                $("#startDate"+i).addClass('hide');
                                $("#date_value_filter"+i).attr('disabled',false);
                                $("#duration"+i).addClass('hide');
                                $("#month_period"+i).addClass('hide');
                                if(self.columnFilterArr[i].filterType == null){
                                    $("#filterOption"+i).addClass('hide');
                                    $("#filterInput"+i).removeClass('hide');
                                    $("#filterDate"+i).addClass('hide');
                                    $("#filterDateRange"+i).addClass('hide');
                                    $("#startDate"+i).addClass('hide');
                                    $("#duration"+i).addClass('hide');
                                    $("#month_period"+i).addClass('hide');
                                }else{
                                    if(self.columnFilterArr[i].filterType.value == "month_period") {
                                        $("#month_period"+i).removeClass('hide');
                                        $("#filterInput"+i).addClass('hide');
                                        $("#filterDate"+i).addClass('hide');
                                        $("#filterDateRange"+i).addClass('hide');
                                    }else{
                                        $("#month_period"+i).addClass('hide');
                                        $("#filterInput"+i).removeClass('hide');
                                        $("#filterDate"+i).addClass('hide');
                                        $("#filterDateRange"+i).addClass('hide');
                                    }
                                }
                            }


                        }

                    }
                    self.isTypeChange = false;  //prevent method call typechange on click of remove
                }
            },

            //when any row add or remove than update column dropdown
            updateListColumn (field,flag) {

                var self = this;

                if ( field != null ) {

                    if ( flag == "remove" ) {

                        for ( var i=0; i < self.parentColumns.length; i++ ) {

                            if ( field.field == self.parentColumns[i].field ) {
                                self.removedListColumn.push(self.parentColumns[i]);

                                delete self.parentColumns[i];
                                self.parentColumns.splice(i, 1);

                                break;
                            }
                        }

                    } else {

                        for ( var i=0; i < self.removedListColumn.length; i++ ) {

                            if ( field.field == self.removedListColumn[i].field ) {
                                //check whether field is present in parentColumns or not
                                if(!self.parentColumns.includes(field)){
                                    self.parentColumns.push(self.removedListColumn[i]);
                                    break;
                                }
                            }
                        }
                    }

                }

            },
            openNav() {
                if(window.length > 768)
                {
                    document.getElementById("ColumnList").style.width = "350px";
                }else{
                    document.getElementById("ColumnList").style.width = "300px";
                }

              /*document.getElementById("page-content-wrapper").style.marginRight = "350px";*/
            },
            dragRow() {
                this.$set(this.$parent, 'userColumns', this.columnConfigArr);
            },

            columnchange(evt,index){

                var self  = this;

                self.durationArr.forEach(function(duration) {
                  var key = index + duration;
                  if (self.startEndDateValueLabel.hasOwnProperty(key)) {
                    delete self.startEndDateValueLabel[key];
                  }
                });

                this.columnFilterArr[index].filterType = null;
                this.columnFilterArr[index].filterDateValue = null;
                this.columnFilterArr[index].filterValue = null;
                this.columnFilterArr[index].filterTypeArr = [];
                //remove class border-red on column change
                $("#selColumnField"+index+" .dropdown-toggle").removeClass('border-red');
                $("#selFilterType"+index+" .dropdown-toggle").removeClass('border-red');
                $("#filterDateRange"+index+" .text-field").removeClass('border-red');
                $("#date_value_filter"+index).removeClass('border-red');
                $("#value_filter"+index).removeClass('border-red');
                $("#filterOption"+index+" .dropdown-toggle").removeClass('border-red');
                $("#value_filter"+index).attr('disabled',false);

                if ( evt == null ) {


                    $("#filterOption"+index).addClass('hide');
                    $("#filterInput"+index).removeClass('hide');
                    $("#filterDate"+index).addClass('hide');
                    $("#filterDateRange"+index).addClass('hide');
                    $("#startDate"+index).addClass('hide');
                    $("#duration"+index).addClass('hide');
                    $("#month_period"+index).addClass('hide');

                } else {

                    if ( evt.fpFieldType == 'custom_asset_availability' ) {
                        // this.flag[index] = 'input';
                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).addClass('hide');
                        $("#filterDate"+index).removeClass('hide');
                        $("#filterDateRange"+index).removeClass('hide');
                        $("#startDate"+index).addClass('hide');
                         $("#duration"+index).addClass('hide');
                         $("#month_period"+index).addClass('hide');
                        this.columnFilterArr[index].filterTypeArr = this.assetAvailabilityArr;

                        if(this.assetAvailabilityArr.length >= 1){
                            this.columnFilterArr[index].filterType = {value:this.assetAvailabilityArr[0].value,text:this.assetAvailabilityArr[0].text};
                        }
                    }
                    if ( evt.fpFieldType == 'option') {

                        $("#filterOption"+index).removeClass('hide');
                        $("#filterInput"+index).addClass('hide');
                        $("#filterDate"+index).addClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#startDate"+index).addClass('hide');
                         $("#duration"+index).addClass('hide');
                         $("#month_period"+index).addClass('hide');
                        this.columnFilterArr[index].filterOptionValue = {text:'',value:''};
                        this.columnFilterArr[index].filterTypeArr = this.optionArr;
                        if ( evt.field == 'location' || evt.field == 'facility_city' || evt.field == 'ordering_location' || evt.field == 'assigned_facility'|| evt.field == 'location_desc' || evt.field == 'physical_location' || evt.field == 'old_location' || evt.field == 'vehicle_location' || evt.field == 'loc_out' || evt.field == 'receiving_location' || evt.field == 'loc_in') {
                          if((self.moduleName=="fuelReadinglist" || self.moduleName == 'fuelTicketList') && self.$parent.userRole == 'fueler'){
                                 self.columnFilterArr[index].filterOption = self.loginUserLocation;
                          } else {
                                self.columnFilterArr[index].filterOption = self.locationArr;
                          }
                        } else if ( (evt.field == 'status' || evt.field == 'unit_status') && ( self.moduleName == 'repairHistory' ||self.moduleName == "assetFeatureList" || self.moduleName == "assetList" || self.moduleName == "availableOverdueAsset" || self.moduleName == "availableAssetList" || self.moduleName =="rentalUtilizationEquipment" || self.moduleName == "availableEquipmentReport" || self.moduleName == "ltdUnitProfitLossSummary" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == "assetReport" || self.moduleName == 'depreciationReviewReport' || self.moduleName == 'depreciationNBVReport' || self.moduleName == "contractRevenue" || self.moduleName == 'costPerMetricByUnitReport' || self.moduleName == 'assetFeatureSysPrmList') ) {
                            self.columnFilterArr[index].filterOption = self.assetStatusArr;
                        } else if(evt.field == 'ins_location'){
                            self.columnFilterArr[index].filterOption = self.insLocationArr;
                        } else if (evt.field == 'warehouse'  || evt.field == "receiving_warehouse") {
                            self.columnFilterArr[index].filterOption = self.warehouseArr;
                        }else if ( evt.field == 'equipment_status' && self.moduleName == "leaseContract" ) {
                            self.columnFilterArr[index].filterOption = self.assetStatusArr;
                        }else if(evt.field == 'assetType' || evt.field == 'asset_type' || evt.field == 'truck_type' || evt.field == 'equip_type'){
                            self.columnFilterArr[index].filterOption = self.vehicleTypeArr;
                        }else if(evt.field == 'permit_type'){
                            self.columnFilterArr[index].filterOption = self.permitTypeArr;
                        }else if(evt.field == 'sale_rep'){
                            self.columnFilterArr[index].filterOption = self.saleRepArr;
                        }else if(evt.field == 'credit_manager'){
                            self.columnFilterArr[index].filterOption = self.creditManagerArr;
                        }else if( evt.field == 'module' && self.moduleName != "ActivityLogList"){
                            self.columnFilterArr[index].filterOption = self.moduleArr;
                        }else if(evt.field == 'activity_type'){
                            self.columnFilterArr[index].filterOption = self.activityTypeArr;
                        }else if((self.moduleName == "actualMetricVSContractMetric" || self.moduleName == "actualMetricVSContractMetricReport" || self.moduleName == "customerScopeRateReport" || self.moduleName == 'BillingReadingforPeriodReport' || self.moduleName == 'scopeRateList' || self.moduleName == 'costPerMetricByUnitReport') && evt.field == 'section'){
                            self.columnFilterArr[index].filterOption = self.sectionArr;
                        }else if(evt.field == 'section' && self.moduleName != 'scopeRateList'){
                            self.columnFilterArr[index].filterOption = self.unitReadingsSectionArr;
                        }else if(evt.field == 'added_by'){
                            self.columnFilterArr[index].filterOption = self.addedByArr;
                        }else if(evt.field == 'reservation_status'){
                            self.columnFilterArr[index].filterOption = self.reservationStatusArr;
                        }else if(evt.field == 'pick_up' || evt.field == 'drop_off' || evt.field == 'phys_location'){
                            self.columnFilterArr[index].filterOption = self.locationArr;
                        }else if(evt.field == 'type' && self.moduleName == 'emailReports'){
                            self.columnFilterArr[index].filterOption = self.emailReportTypeArr;
                        }else if(evt.field == 'priority'){
                            self.columnFilterArr[index].filterOption = self.priorityArr;
                        }else if((evt.field == 'status' || evt.field == 'work_order_status') && (self.moduleName == "listWorkOrders" || self.moduleName == "SubletInProcessReport")){
                            self.columnFilterArr[index].filterOption = self.workOrderStatusArr;
                        }else if (evt.field == 'wo_status' && self.moduleName != 'workOrderAccountingTransactions'){
                            self.columnFilterArr[index].filterOption = self.workOrderStatusArr;
                        }else if(evt.field == 'status' && self.moduleName == "listWorkOrderEstimate"){
                            self.columnFilterArr[index].filterOption = self.workOrderEstimateStatusArr;
                        }else if(evt.field == 'is_customer_responded'){
                            self.columnFilterArr[index].filterOption = self.customerResponseStatusArr;
                        }else if(evt.field == 'contract_type' || evt.field == 'contract'){
                            self.columnFilterArr[index].filterOption = self.contractTypeArr;
                        }else if(evt.field == 'response_type'){
                            self.columnFilterArr[index].filterOption = self.customerResponseTypeArr;
                        }else if(evt.field == 'name'  && (self.moduleName == "PMUnitForecastList" || self.moduleName == "PMUnitDetailList" )){
                            self.columnFilterArr[index].filterOption = self.programArr;
                        }else if(evt.field == 'module' && self.moduleName == "ActivityLogList"){
                            self.columnFilterArr[index].filterOption = self.activityModuleArr;
                        }else if(evt.field == 'parent_action' || evt.field == 'child_action'){
                            self.columnFilterArr[index].filterOption = self.checkListActionArr;
                        }else if(evt.field == 'account_type' && ( self.moduleName == "glAccountsList" || self.moduleName == "journalsList" || self.moduleName == "generalLedgerReport" || self.moduleName == 'trialBalanceReport' || self.moduleName == 'workOrderAccountingTransactions') ){
                            self.columnFilterArr[index].filterOption = self.accountTypesArr;
                        }else if(evt.field == 'ownership'){
                            self.columnFilterArr[index].filterOption = self.ownershipArr;
                        }else if(((evt.field == 'inv_type' || evt.field == 'invoice_type' || evt.field == 'source_doc_type') && (self.moduleName == "invoiceList" || self.moduleName == "invoiceSubList" || self.moduleName == 'invoiceReport' || self.moduleName == 'invoiceDetailReport' || self.moduleName == "woInvoiceList")) || (evt.field == 'order_type' && (self.moduleName == "customerAgedTrialBalanceDetail" || self.moduleName == "agedTrialBalanceDetailGrid"))){
                            self.columnFilterArr[index].filterOption = self.invoiceTypesArr;
                        }else if(evt.field == 'asset_feature_category'){
                            self.columnFilterArr[index].filterOption = self.assetFeatureCategoryArr;
                        }else if(evt.field == 'business_type'){
                            self.columnFilterArr[index].filterOption = self.businessTypeArr;
                        }else if(evt.field == 'note_type'){
                            self.columnFilterArr[index].filterOption = self.noteTypesArr;
                        }else if(evt.field == 'status' && self.moduleName == "creditNoteList"){
                            self.columnFilterArr[index].filterOption = self.notesStatusArr;
                        }else if(evt.field == 'hvut_category' ){
                            self.columnFilterArr[index].filterOption = self.hvutCategoriesArr;
                        }else if((evt.field == 'status' && self.moduleName == "billList") || (evt.field == 'status' && self.moduleName == "apPaymentUpload") ){
                            self.columnFilterArr[index].filterOption = self.billStatusArr;
                        }else if(evt.field == 'status' && self.moduleName == "listVendorPayment" ){

                            self.columnFilterArr[index].filterOption = self.vendorPaymentStatusArr;

                        }else if(evt.field == 'journal_module'){

                            self.columnFilterArr[index].filterOption = self.journalModulesArr;

                        }else if(evt.field == 'status' && self.moduleName == "journalsList" ){

                            self.columnFilterArr[index].filterOption = self.journalStatusArr;

                        }else if(evt.field == 'financial_period' && self.moduleName == "journalsList" ){

                            self.columnFilterArr[index].filterOption = self.financialPeriodsArr;

                        }else if(evt.field == 'status' && self.moduleName == "checkList" ){

                            self.columnFilterArr[index].filterOption = self.checkStatusArr;

                        }else if( ( evt.field == 'pick_location' || evt.field == 'delivery_location' ) && self.moduleName == "transportRequestList" ){

                            self.columnFilterArr[index].filterOption = self.transportRequestLocArr;

                        }else if(evt.field == 'get_back' && self.moduleName == "transportRequestList" ){

                            self.columnFilterArr[index].filterOption = self.getBackArr;

                        }else if(evt.field == 'type' && self.moduleName == "checkList" ){

                            self.columnFilterArr[index].filterOption = self.checkTypesArr;

                        }else if(evt.field == 'conType' && self.moduleName == 'listBillingDetailForecast'){

                            self.columnFilterArr[index].filterOption = self.contractTypeArr;

                        }else if(evt.field == 'conType' || evt.field == 'fp_contract_type'){

                            self.columnFilterArr[index].filterOption = self.contractTypeArr;

                        }else if(evt.field == 'readingFound'){

                            self.columnFilterArr[index].filterOption = self.readingFoundArr;

                        }else if(evt.field == 'customer_class'){

                            self.columnFilterArr[index].filterOption = self.customerClassArr;

                        }else if(evt.field == 'pricing_type'){

                            self.columnFilterArr[index].filterOption = self.pricingTypeArr;

                        }else if(evt.field == 'item' && (self.moduleName == "fuelTicketDetail" || self.moduleName == 'fuelPricingList' || self.moduleName == 'fuelDropList'|| self.moduleName == 'islandProductList' || self.moduleName == 'fuelTicketList' || self.moduleName == 'fuelReadinglist')){
                            self.columnFilterArr[index].filterOption = self.componentArr;

                        }else if(evt.field == 'fuel_location'){

                            self.columnFilterArr[index].filterOption = self.locationArr;

                        }else if(evt.field == 'price_type'){

                            self.columnFilterArr[index].filterOption = self.priceTypeArr;

                        }else if(evt.field == 'source' && (self.moduleName == 'generalLedgerReport' || self.moduleName == 'workOrderAccountingTransactions')){

                            self.columnFilterArr[index].filterOption = self.glSrcCodesArr;

                        }else if(evt.field == 'schedule_type' && ( self.moduleName == 'DepreciationScheduleList' || self.moduleName == 'depreciationReviewReport' || self.moduleName == 'depreciationNBVReport')){

                            self.columnFilterArr[index].filterOption = self.scheduleTypeArr;

                        }else if(evt.field == 'policy_type' || evt.field == 'self_insured_for'){

                            self.columnFilterArr[index].filterOption = self.policyTypesArr;

                        }else if (evt.field == 'owner' && (self.moduleName == 'assetPermitList' || self.moduleName == 'permitEntryReport' || self.moduleName == 'unitPermitDetail')) {

                            self.columnFilterArr[index].filterOption = self.permitOwnerArr;

                        }else if (evt.field == 'batch_status' && self.moduleName == 'batchList') {

                            self.columnFilterArr[index].filterOption = self.batchStatusArr;
                        }else if ( evt.field == 'status' && (self.moduleName == "insurancePolicyList" || self.moduleName == "insurancePolicyReport")){

                            self.columnFilterArr[index].filterOption = self.policyStatusArr;

                        }else if ( (evt.field == 'asset_pool' && (self.moduleName == 'debtNotePostingDetail' || self.moduleName == 'weeklyRentalReport' || self.moduleName == "assetFeatureList" ||self.moduleName == "assetList" || self.moduleName == 'FHUTExceptionList' || self.moduleName == "chargeCodeAccount" || self.moduleName == "ltdUnitProfitLossSummary")) || ((evt.field == 'vehicle_pool_id' || evt.field == 'old_vehicle_pool_id') && self.moduleName == "assetLogList") || (evt.field == 'asset_pool' && (self.moduleName == "assetReport" || self.moduleName == 'leaseContractExpiry' || self.moduleName == "leaseContractExpiryNonTemplate" || self.moduleName == "rentalUtilizationEquipment" || self.moduleName == "assetFeatureSysPrmList") )){
                            self.columnFilterArr[index].filterOption = self.assetPoolArr;

                        }else if (evt.field == 'pool' || evt.field == 'current_pool' || evt.field == 'old_pool' || evt.field == 'new_pool' || evt.field == 'trasaction_eq_pool'){
                            self.columnFilterArr[index].filterOption = self.assetPoolArr;

                        }else if(evt.field == 'ev_customer_order_type'){
                          self.columnFilterArr[index].filterOption = self.evCustomerOrderTypeArr;
                        }else if ( evt.field == 'cost_code' && self.moduleName == "laborCostList" ){
                            self.columnFilterArr[index].filterOption = self.costCodeArr;
                        }else if(evt.field == 'type' && self.moduleName == "laborCostList"){

                            self.columnFilterArr[index].filterOption = self.laborPricingTypeArr;

                        }else if (evt.field == 'status' && self.moduleName == "assetWarrantyList") {
                            self.columnFilterArr[index].filterOption = self.assetWarrantyStatusArr;
                        }else if (evt.field == 'note_category' && (self.moduleName == "crmList" || self.moduleName == "notePadReview")) {
                            self.columnFilterArr[index].filterOption = self.noteCategoryArr;
                        }else if(evt.field == 'notification_type' && self.moduleName == 'customerContactList'){
                            self.columnFilterArr[index].filterOption = self.notificationTypesArr;
                        }else if (evt.field == 'vendor_taxable' && (self.moduleName == "apVoucherDistribution")) {
                            self.columnFilterArr[index].filterOption = self.vendorTaxableArr;
                        }else if (evt.field == 'manufacturer_code' && (self.moduleName == "ltdUnitProfitLossSummary" || self.moduleName == "assetReport")) {
                            self.columnFilterArr[index].filterOption = self.vehicleManufacturerArr;
                        }else if (evt.field == 'model_code' && (self.moduleName == "ltdUnitProfitLossSummary"  || self.moduleName == "contractRevenue")) {
                            self.columnFilterArr[index].filterOption = self.vehicleModelArr;
                        }else if ((evt.field == 'payment_type' && (self.moduleName == "apVoucherDistribution")) || (evt.field == 'pay_type' && self.moduleName == "apPaymentUpload")) {
                            self.columnFilterArr[index].filterOption = self.paymentOptionsArr;
                        }else if (evt.field == 'app_type' && (self.moduleName == "arReceiptsAndApplications")) {
                            self.columnFilterArr[index].filterOption = self.appTypeArr;
                        }else if ((self.moduleName == 'PMComplianceFacilityList' || self.moduleName == 'PMCompliancePoolList') && evt.field == 'category'){
                            self.columnFilterArr[index].filterOption = self.programCategoryArr;
                        }else if ( evt.field == 'cost_type'){
                            self.columnFilterArr[index].filterOption = self.costTypesArr;
                        }else if ( evt.field == 'rate_type'){
                            self.columnFilterArr[index].filterOption = self.rateTypesArr;
                        }else if (evt.field == 'facility' && (self.moduleName == 'customerAgedTrialBalanceDetail' || self.moduleName == 'customerAgedTrialBalance' || self.moduleName == 'agedTrialBalanceDetailGrid')) {
                            self.columnFilterArr[index].filterOption = self.locationArr;
                        }else if (evt.field == 'owner' && (self.moduleName == 'availableOverdueAsset' || self.moduleName == 'netBillingMetricReport')){
                            self.columnFilterArr[index].filterOption = self.ownershipArr;
                        }else if (evt.field == 'non_bill_code' && (self.moduleName == 'fuelTicketDetail' || self.moduleName == 'FuelInventoryClearingSummaryReport')){
                            self.columnFilterArr[index].filterOption = self.billableCodeArr;
                        }else if (evt.field == 'catCode' && self.moduleName == 'inventoryReport') {
                            self.columnFilterArr[index].filterOption = self.componentCategoryArr;
                        }else if (evt.field == 'metric_type' && self.moduleName == 'metricsBilledReport') {
                            self.columnFilterArr[index].filterOption = self.sectionArr;
                        }else if (evt.field == 'unit_status' && self.moduleName == 'unitPermitDetail') {
                            self.columnFilterArr[index].filterOption = self.assetStatusArr;
                        }else if (evt.field == 'accounting_code' && self.moduleName == 'agedTrialBalanceDetailGrid') {
                            self.columnFilterArr[index].filterOption = self.accountingCodeArr;
                        }else if(evt.field == 'battery_size'){
                          self.columnFilterArr[index].filterOption = self.evBatterySizeArr;
                        }else if(evt.field == 'pto'){
                          self.columnFilterArr[index].filterOption = self.evPtoArr;
                        }else if(evt.field == 'extended_warranty'){
                          self.columnFilterArr[index].filterOption = self.evExtendedWarrantyArr;
                        }else if(evt.field === 'status' && self.moduleName === 'campaignRecallVinList'){
                          self.columnFilterArr[index].filterOption = self.campaignRecallVinClaimStatusArr;
                        }else if(evt.field == 'option_code' || evt.field == 'vehicle_option_code' ){
                          self.columnFilterArr[index].filterOption = self.vehicleOptionCodesArr;
                        }
                        else {

                            this.columnFilterArr[index].filterOption = evt.filterOptions.filterDropdownItems;
                        }

                        // this.flag[index] = 'option';


                         if(this.optionArr.length >= 1){
                             this.columnFilterArr[index].filterType = {value:this.optionArr[0].value,text:this.optionArr[0].text};
                         }


                    }
                    if(evt.fpFieldType == 'text'){

                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).removeClass('hide');
                        $("#filterDate"+index).addClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#startDate"+index).addClass('hide');
                         $("#duration"+index).addClass('hide');
                         $("#month_period"+index).addClass('hide');
                        //filterTypeArr is set different (contain , doesnot contain, is null, is not null) for the mentioned reports
                        if(self.moduleName == 'availableEquipmentReport' || self.moduleName == 'contractRevenue' || self.moduleName == 'assetReport' || self.moduleName == 'equipmentCurrentStatus' || self.moduleName == 'equipmentPoolTransfer' || self.moduleName == 'debtNoteBalanceDetail'
                         || self.moduleName == 'debtNoteUnitDetailReport' || self.moduleName == 'debtNotePostingDetail' || self.moduleName == 'debtNoteSchedule' || self.moduleName == 'depreciationReviewReport' || self.moduleName == 'depreciationNBVReport' || self.moduleName == 'disposalInvoiceListing'
                         || self.moduleName == 'insurancePolicyReport' || self.moduleName == 'ltdUnitProfitLossSummary' || self.moduleName == 'ownedEquipment' || self.moduleName == 'customerInvoiceLineDetailReport' || self.moduleName == 'assetFeatureList' || self.moduleName == 'gangsheetReport'
                         || self.moduleName == 'costPerMetricByUnitReport' || self.moduleName == 'outofserviceHistory' || self.moduleName == 'workOrderAccountingTransactions' || self.moduleName == 'inventoryReport' || self.moduleName == 'PMUnitDetailList' || self.moduleName == 'PMUnitForecastList'
                         || self.moduleName == 'warrantyClaimReport' || self.moduleName == 'fuelTicketDetail' || self.moduleName == 'unitPermitDetail' || self.moduleName == 'actionAuditReport' || self.moduleName == 'BillingReadingforPeriodReport' || self.moduleName == 'metricsBilledReport'
                         || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'leaseContract' || self.moduleName == 'actualMetricVSContractMetric' || self.moduleName == "actualMetricVSContractMetricReport" || self.moduleName == 'leaseContractExpiry' || self.moduleName == "leaseContractExpiryNonTemplate" || self.moduleName == 'contractCustomerReport' || self.moduleName == 'currentInsurancePolicyReviewList'
                         || self.moduleName == 'customerScopeRateReport' || self.moduleName == 'reservationReport' || self.moduleName == 'rentalReport' || self.moduleName == 'rentalActivityReport' || self.moduleName == 'rentalActivityWithRatesReport' || self.moduleName == 'SubDaysInPeriodReport'
                         || self.moduleName == 'nonBillableUnits' || self.moduleName == 'weeklyRentalReport' || self.moduleName == 'permitEntryReport' || self.moduleName == 'listScheduleReport' || self.moduleName == 'potentialCancellationList' || self.moduleName == 'rentalCancellationList'
                         || self.moduleName == 'emailReports' || self.moduleName == 'availableOverdueAsset' || self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == 'chargeCodeAccount' || self.moduleName == 'apPaymentUpload' || self.moduleName == 'apTrialBalanceAsAtDetail'
                         || self.moduleName == 'apVoucherDistribution' || self.moduleName == 'apPositivePayReport' || self.moduleName == 'accruedLiabilityReport' || self.moduleName == 'generalLedgerReport' || self.moduleName == 'trialBalanceReport' || self.moduleName == 'SubletInProcessReport'
                         || self.moduleName == 'invoiceDetailReport' || self.moduleName == 'openOnAccountCash' || self.moduleName == 'arReceiptsAndApplications' || self.moduleName == 'notePadReview' || self.moduleName == 'invoiceReport' || self.moduleName == 'customerContactList'
                         || self.moduleName == 'customerReport' || self.moduleName == 'customerAROutstanding' || self.moduleName == 'agedTrialBalanceDetailGrid' || self.moduleName == 'customerAgedTrialBalance' || self.moduleName == 'customerAgedTrialBalanceDetail' || self.moduleName == 'contractEquipmentAsAt' || self.moduleName == 'contractEquipmentUtilization' || self.moduleName == 'hvutunitDetail' || self.moduleName == 'equipmentaccountingrecords' || self.moduleName == 'FuelInventoryClearingSummaryReport'){
                            this.columnFilterArr[index].filterTypeArr = this.reportTextArr;
                            if(this.optionArr.length >= 1){
                                this.columnFilterArr[index].filterType = {value:this.reportTextArr[0].value,text:this.reportTextArr[0].text};
                            }

                        }else{
                            this.columnFilterArr[index].filterTypeArr = this.textArr;
                            if(this.optionArr.length >= 1){
                                this.columnFilterArr[index].filterType = {value:this.textArr[0].value,text:this.textArr[0].text};
                            }
                        }
                    }
                    if(evt.fpFieldType == 'date'){
                        // this.flag[index] = 'input';
                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).addClass('hide');
                        $("#filterDate"+index).removeClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#startDate"+index).addClass('hide');

                        this.columnFilterArr[index].filterTypeArr = this.dateArr;

                         if(this.dateArr.length >= 1){
                             this.columnFilterArr[index].filterType = {value:this.dateArr[0].value,text:this.dateArr[0].text};
                         }
                    }
                    if(evt.fpFieldType == 'text' && (evt.field == 'start_date' || evt.field == "end_date" ) && (self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == 'fuelTicketList' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == "weeklyRentalReport" || self.moduleName == 'debtNoteRollForward' || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'rentalActivityReport') ){
                        // this.flag[index] = 'input';
                        $("#duration"+index).addClass('hide');
                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).addClass('hide');
                        $("#filterDate"+index).addClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#startDate"+index).removeClass('hide');
                        $("#month_period"+index).addClass('hide');

                     var oneDateArr=[{ value: '=', text: 'is'}];
                        //  if(this.dateArr.length >= 1){
                             this.columnFilterArr[index].filterType = {value:oneDateArr[0].value,text:oneDateArr[0].text};
                             this.columnFilterArr[index].filterTypeArr=oneDateArr;
                        //  }
                    }
                    if(evt.fpFieldType == 'number'){
                        // this.flag[index] = 'input';
                        $("#duration"+index).addClass('hide');
                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).removeClass('hide');
                        $("#filterDate"+index).addClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#startDate"+index).addClass('hide');
                        $("#month_period"+index).addClass('hide');
                        this.columnFilterArr[index].filterTypeArr = this.numberArr;

                         if(this.numberArr.length >= 1){
                             this.columnFilterArr[index].filterType = {value:this.numberArr[0].value,text:this.numberArr[0].text};
                         }
                    }
                    if(evt.fpFieldType == 'integer'){
                    // this.flag[index] = 'input';
                    $("#duration"+index).addClass('hide');
                    $("#filterOption"+index).addClass('hide');
                    $("#filterInput"+index).removeClass('hide');
                    $("#filterDate"+index).addClass('hide');
                    $("#filterDateRange"+index).addClass('hide');
                    $("#startDate"+index).addClass('hide');
                    $("#month_period"+index).addClass('hide');
                    this.columnFilterArr[index].filterTypeArr = this.integerArr;
                    }
                    if(evt.fpFieldType == 'is'){
                        // this.flag[index] = 'input';
                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).removeClass('hide');
                        $("#filterDate"+index).addClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#startDate"+index).addClass('hide');

                        var oneDateArr=[{ value: '=', text: 'is'}];
                        this.columnFilterArr[index].filterType = {value:oneDateArr[0].value,text:oneDateArr[0].text};
                        this.columnFilterArr[index].filterTypeArr=oneDateArr;
                        //  }
                    }
                    //year and period filter type
                    if(evt.fpFieldType == 'year' || evt.fpFieldType == 'period'){
                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).removeClass('hide');
                        $("#filterDate"+index).addClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#startDate"+index).addClass('hide');
                        $("#duration"+index).addClass('hide');
                        if(this.isArr.length >= 1){
                            this.columnFilterArr[index].filterType = {value:this.isArr[0].value,text:this.isArr[0].text};
                            this.columnFilterArr[index].filterTypeArr = this.isArr;
                        }
                        this.columnFilterArr[index].isColumnDisable = true;
                    }
                    //aging date filter type
                    if(evt.fpFieldType == 'aging_date'){
                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).addClass('hide');
                        $("#filterDate"+index).removeClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#startDate"+index).addClass('hide');
                        $("#duration"+index).addClass('hide');
                        if(this.isArr.length >= 1){
                            this.columnFilterArr[index].filterType = {value:this.isArr[0].value,text:this.isArr[0].text};
                            this.columnFilterArr[index].filterTypeArr = this.isArr;
                        }
                        this.columnFilterArr[index].isColumnDisable = true;
                    }
                    //custom date filter type
                    if(evt.fpFieldType == 'custom_date'){
                        $("#filterOption"+index).addClass('hide');
                        $("#filterInput"+index).addClass('hide');
                        $("#filterDate"+index).addClass('hide');
                        $("#filterDateRange"+index).addClass('hide');
                        $("#duration"+index).addClass('hide');
                        $("#startDate"+index).removeClass('hide');
                        $("#month_period"+index).addClass('hide');

                        this.columnFilterArr[index].filterTypeArr = this.customDateArr;

                         if(this.customDateArr.length >= 1){
                             this.columnFilterArr[index].filterType = {value:this.customDateArr[0].value,text:this.customDateArr[0].text};
                         }
                    }
                }

            },

            typecolumnchange(evt,index){
                var self = this;
                if(evt == null || evt == ''){
                    self.columnFilterArr[index].filterType = null;
                }

                //prevent method call typechange on click of remove
                if(!self.isTypeChange){
                    self.isTypeChange = true;
                    return;
                }else{
                    if( evt != null ) {
                       if(this.columnFilterArr[index].columnId!=null){
                        // self.onsearchFilterFlag = false;
                        if ( this.columnFilterArr[index].columnId.fpFieldType == "date" || this.columnFilterArr[index].columnId.fpFieldType == "custom_asset_availability" ) {

                            $("#filterOption"+index).addClass('hide');
                            $("#filterInput"+index).addClass('hide');
                            $("#date_value_filter"+index).attr('disabled',false);
                            $("#duration"+index).addClass('hide');
                            $("#month_period"+index).addClass('hide');
                            if (self.onsearchFilterFlag != true){

                                this.columnFilterArr[index].filterDateValue = null;
                                this.columnFilterArr[index].filterDateRangeValue = null;
                                this.columnFilterArr[index].filterOptionValue = null;
                                this.columnFilterArr[index].filterValue = null;
                            }

                            if( evt.value == 'between' ){
                                if (self.onsearchFilterFlag != true){
                                    $("#filterDateRange"+index+" .text-field").val("");
                                }
                                $("#filterDate"+index).addClass('hide');
                                $("#filterDateRange"+index).removeClass('hide');

                            }else if( evt.value == 'IS NULL' ){

                                $("#filterDate"+index).removeClass('hide');
                                $("#filterDateRange"+index).addClass('hide');
                                $("#date_value_filter"+index).attr('disabled',true);

                            }else if( evt.value == 'duration' ){
                                // this.durationSelect=true;
                                $("#duration"+index).removeClass('hide');
                                $("#filterDate"+index).addClass('hide');
                                $("#filterDateRange"+index).addClass('hide');
                                $("#date_value_filter"+index).attr('disabled',true);

                            }else{

                                if (self.onsearchFilterFlag != true){

                                    if((self.moduleName == 'rentalUtilizationEquipment' || self.moduleName == 'fuelTicketList' || self.moduleName == "SubDaysInPeriodReport" || self.moduleName == "rentalActivityWithRatesReport" || self.moduleName == "weeklyRentalReport" || self.moduleName == "debtNoteRollForward" || self.moduleName == 'netBillingMetricReport' || self.moduleName == 'rentalActivityReport')&& (this.columnFilterArr[index].columnId.field == 'start_date' || this.columnFilterArr[index].columnId.field == 'end_date')){
                                        $("#startDate"+index).removeClass('hide');

                                    }else{

                                        $("#filterDate"+index).removeClass('hide');
                                        //default date filter for Work Entry List
                                        if (self.moduleName != undefined && self.moduleName == "workEntryList" && self.etkDateFilter) {
                                            var currentDate = moment().format("MM/DD/YYYY");
                                            this.columnFilterArr[0].filterDateValue = currentDate;
                                        }

                                    }
                                }else{
                                    $("#filterDate"+index).removeClass('hide');
                                }

                                $("#filterDateRange"+index).addClass('hide');

                            }

                        }else if (this.columnFilterArr[index].columnId.fpFieldType == "custom_date") {//custom date filter type
                            $("#filterOption"+index).addClass('hide');
                            $("#filterInput"+index).addClass('hide');
                            $("#date_value_filter"+index).attr('disabled',false);
                            $("#duration"+index).addClass('hide');
                            $("#startDate"+index).addClass('hide');
                            $("#month_period"+index).addClass('hide');
                            if (self.onsearchFilterFlag != true){

                                this.columnFilterArr[index].filterDateValue = null;
                                this.columnFilterArr[index].filterDateRangeValue = null;
                                this.columnFilterArr[index].filterOptionValue = null;
                                this.columnFilterArr[index].filterValue = null;
                            }
                            if( evt.value == 'between' || evt.value == 'not between' ){
                                if (self.onsearchFilterFlag != true){
                                    $("#filterDateRange"+index+" .text-field").val("");
                                }
                                $("#filterDate"+index).addClass('hide');
                                $("#filterDateRange"+index).removeClass('hide');

                            }else if( evt.value == 'IS NULL' || evt.value == 'IS NOT NULL' ){

                                $("#filterDate"+index).removeClass('hide');
                                $("#filterDateRange"+index).addClass('hide');
                                $("#date_value_filter"+index).attr('disabled',true);

                            }else if( evt.value == 'duration'){
                                $("#filterDate"+index).addClass('hide');
                                $("#filterDateRange"+index).addClass('hide');
                                $("#duration"+index).removeClass('hide');
                            }else{
                                $("#filterDate"+index).addClass('hide');
                                $("#filterDateRange"+index).addClass('hide');
                                $("#startDate"+index).removeClass('hide');
                            }
                        }
                        else if (this.columnFilterArr[index].columnId.fpFieldType == "text"){
                          if(self.columnFilterArr[index].filterType.value == "IS NULL" || self.columnFilterArr[index].filterType.value == "IS NOT NULL"){
                                  self.columnFilterArr[index].filterValue = "";//value blank as it throw error in backend
                                  $("#value_filter"+index).attr('disabled',true);
                          }else{
                                  $("#value_filter"+index).attr('disabled',false);
                          }

                        }
                        else if (this.columnFilterArr[index].columnId.fpFieldType == "integer"){
                            if(self.columnFilterArr[index].filterType.value == "month_period"){
                                $("#month_period"+index).removeClass('hide');
                                $("#filterInput"+index).addClass('hide');
                                $("#filterDate"+index).addClass('hide');
                                $("#filterDateRange"+index).addClass('hide');

                            }else{
                                $("#month_period"+index).addClass('hide');
                                $("#filterInput"+index).removeClass('hide');
                                $("#filterDate"+index).addClass('hide');
                                $("#filterDateRange"+index).addClass('hide');
                            }
                        }
                    }
                    }
                }


            },

            //load default column filters
            defaultColumnFilters(flag){
                var self = this;
                if ( self.moduleName=='fuelPriceAssetList' ) {

                    self.parentColumns = self.$parent.columnsAsset;
                // } else if(self.moduleName == 'customerRefundList' ||
                //             self.moduleName == 'listRefundEligibleCustomerTable' ||  self.moduleName == "rentalActivityReport" ||
                //             self.moduleName == "trialBalanceReport" ||  self.moduleName == "equipmentCurrentStatus" ||
                //             self.moduleName == "ownedEquipment" || self.moduleName == "rentalUtilizationEquipment" ||
                //             self.moduleName == "leaseContractExpiry" ||  self.moduleName == "BillingReadingforPeriodReport" ||
                //             self.moduleName == "fuelTicketDetail" || self.moduleName == "gangsheetReport" ||
                //             self.moduleName == "assetFeatureList" || self.moduleName == "availableEquipmentReport" ||
                //             self.moduleName == "rentalReport" || self.moduleName == "openOnAccountCash" ||
                //             self.moduleName == "invoiceReport" || self.moduleName == "accruedLiabilityReporth" ||
                //             self.moduleName == "laborManagementReport" || self.moduleName == "notePadReview" ||
                //             self.moduleName == "customerReport" || self.moduleName == "leaseContract" ||
                //             self.moduleName == "apVoucherDistribution" || self.moduleName == "rentalActivityWithRatesReport" ||
                //             self.moduleName == "weeklyRentalReport" || self.moduleName == "assetReport" ||
                //             self.moduleName == "apTrialBalanceAsAtDetail" || self.moduleName == "apPaymentUpload" ||
                //             self.moduleName == "currentInsurancePolicyReviewList" || self.moduleName == "SubletInProcessReport" ||
                //             self.moduleName == "inventoryReport" || self.moduleName == "actualMetricVSContractMetric" ||
                //             self.moduleName == 'telematicListAssetView' || self.moduleName == 'agedTrialBalanceDetailGrid' ||
                //             self.moduleName == 'customerAgedTrialBalance' || self.moduleName == 'customerAgedTrialBalanceDetail' ||
                //             || self.moduleName == "depreciationNBVReport" ||
                //             self.moduleName == "contractRevenue" || self.moduleName == "ActivityLogList" ||
                //             self.moduleName == "workOrderAccountingTransactions" || self.moduleName == "disposalInvoiceListing" ||
                //             self.moduleName == "repairHistory" || self.moduleName == "depreciationReviewReport" ||
                //             self.moduleName == "arReceiptsAndApplications" || self.moduleName == "generalLedgerReport" ||
                //             self.moduleName == "customerAROutstanding" || self.moduleName == "outofserviceHistory" ||
                //             self.moduleName == "PMUnitForecastList" || self.moduleName == "unitPermitDetail" ||
                //             self.moduleName == 'availableOverdueAsset' || self.moduleName == "insurancePolicyReport" ||
                //             self.moduleName == "PMCompliancePoolList" || self.moduleName == "PMComplianceFacilityList" ||
                //             self.moduleName == 'vendorList' || self.moduleName == "netBillingMetricReport" ||
                //             self.moduleName == "reservationReport" || self.moduleName == "customerContactList" ||
                //             self.moduleName == 'metricsBilledReport' || self.moduleName == "depreciationReview" ||
                //             self.moduleName == 'citationList' || self.moduleName == 'PMUnitDetailList' ||
                //             self.moduleName == "customerList" ) {

                //     // filterable
                //     self.parentColumns = [];
                //     self.$parent.columns.forEach(element => {
                //         if(element.filterable == true) {
                //             self.parentColumns.push(element);
                //         }
                //     });

                } else {

                    self.parentColumns = [];
                    self.$parent.columns.forEach(element => {
                        if(element.filterable == true) {
                            self.parentColumns.push(element);
                        }
                    });
                    //self.parentColumns = self.$parent.columns;
                }

                var listOfObjects = Object.keys(this.parentColumns).map((key) => {
                    return this.parentColumns[key]
                })

                var userObj = localStorage.getItem("user_obj");
                //if user logged in than remove login button and registration button
                if ( userObj != null ) {
                    var userJson = JSON.parse(userObj);
                }
                var label = '';

                for ( var i=0; i < listOfObjects.length; i++ ) {

                    if ( 'program' == listOfObjects[i].field || listOfObjects[i].field == 'action' || (listOfObjects[i].field == 'total' && self.moduleName != 'fuelTicketDetail') || listOfObjects[i].field == 'hvut_cost'
                            || listOfObjects[i].field == 'pre_reading' || listOfObjects[i].field == 'pre_date'
                            || listOfObjects[i].field == 'prev_customer' || listOfObjects[i].field == 'mapped_amount' ){
                        delete listOfObjects[i];
                        listOfObjects.splice(i, 1);
                    }

                    //hvut schedule Add
                    if (self.$route.path.includes("fhut-schedule")) {
                        if (self.$route.path.includes("new")) {
                            var requiredFilters = ["unit_no","date_in_service","location","hvut_category","gvw"];
                            var updatedListOfObjects = [];
                            for (var i = 0; i < requiredFilters.length; i++) {
                                var filterIndex = listOfObjects.findIndex(x => (x.field === requiredFilters[i]));
                                updatedListOfObjects.push(listOfObjects[filterIndex]);
                            }
                            listOfObjects = updatedListOfObjects;
                        }
                    }
                }
                for ( var i = 0; i < listOfObjects.length; i++ ) {

                    if ( listOfObjects[i].field == 'location' || listOfObjects[i].field == 'pick_up' || listOfObjects[i].field == 'drop_off'|| listOfObjects[i].field == 'assigned_facility' || listOfObjects[i].field == 'ordering_location' || listOfObjects[i].field == 'physical_location' || listOfObjects[i].field == 'old_location' || listOfObjects[i].field == 'vehicle_location' || listOfObjects[i].field == 'loc_out') {

                        this.locFlag = 'location';
                        //load rental locations for Current,Past,Pending and Check Availability Lists
                        if(self.moduleName != undefined && (self.moduleName == "pendingReservationList" || self.moduleName == "availableAssetList" || self.moduleName == "reservationList")){
                            this.requestArr.push('rental_locations');
                        }else{
                            this.requestArr.push('location');
                        }

                        self.locLabel = listOfObjects[i].label;

                    }
                    if ( listOfObjects[i].field == 'city' ) {

                        if ( userJson.locationName && userJson.locationName != undefined ) {

                            var city = userJson.locationName.split(',');

                            if ( city[0] && flag == 'load') {
                                this.locFlag = 'city';
                                //this.searchCity(city[0]);
                            }
                        }
                    }
                    if ( listOfObjects[i].field == 'asset_type' || listOfObjects[i].field == 'assetType' || listOfObjects[i].field == 'truck_type' || listOfObjects[i].field == 'equip_type'){

                        this.requestArr.push('vehicleType');
                    }
                    if ( listOfObjects[i].field == 'warehouse'){
                        this.requestArr.push('warehouse');
                    }
                    if ( listOfObjects[i].field == 'permit_type'){

                        this.requestArr.push('permitType');
                    }
                    if ( listOfObjects[i].field == 'sale_rep'){

                        this.requestArr.push('saleRep');
                    }
                    if ( listOfObjects[i].field == 'credit_manager'){

                        this.requestArr.push('creditManager');
                    }
                    if ( listOfObjects[i].field == 'module' && self.moduleName != "ActivityLogList" && self.moduleName != 'journalsList'){

                        this.requestArr.push('module');
                    }
                    if ( listOfObjects[i].field == 'activity_type'){

                        this.requestArr.push('activity_type');
                    }
                    if ((self.moduleName == "actualMetricVSContractMetric" || self.moduleName == "actualMetricVSContractMetricReport" || self.moduleName == "customerScopeRateReport" || self.moduleName == 'BillingReadingforPeriodReport' || self.moduleName == 'scopeRateList' || self.moduleName == 'costPerMetricByUnitReport') && listOfObjects[i].field == 'section'){
                        this.requestArr.push('section');
                    }else
                    if ( listOfObjects[i].field == 'section'){

                        this.requestArr.push('unit_reading_sections');
                    }
                    if ( listOfObjects[i].field == 'added_by'){

                        this.requestArr.push('added_by');
                    }
                    if ( listOfObjects[i].field == 'reservation_status'){

                        this.requestArr.push('reservation_status');
                    }
                    if ( listOfObjects[i].field == 'priority'){

                        this.requestArr.push('priority');
                    }
                    if ( (listOfObjects[i].field == 'status' || listOfObjects[i].field == 'work_order_status') && (self.moduleName == "listWorkOrders" || self.moduleName == "SubletInProcessReport")){

                        this.requestArr.push('work_order_status');
                    }
                    if ( listOfObjects[i].field == 'wo_status' && self.moduleName != 'workOrderAccountingTransactions'){

                        this.requestArr.push('work_order_status');
                    }
                    if ( listOfObjects[i].field == 'status' && self.moduleName == "listWorkOrderEstimate"){

                        this.requestArr.push('work_order_estimate_status');
                    }
                    if ( listOfObjects[i].field == 'is_customer_responded'){

                        this.requestArr.push('customer_response_status');
                    }
                    if ( listOfObjects[i].field == 'response_type'){

                        this.requestArr.push('response_type');
                    }
                    if ( listOfObjects[i].field == 'name' && (self.moduleName == "PMUnitForecastList" || self.moduleName == "PMUnitDetailList")){

                        this.requestArr.push('program');
                    }
                    if ( (listOfObjects[i].field == 'contract_type' || listOfObjects[i].field == 'contract') && (self.moduleName != 'contractRevenue' && self.moduleName != 'mileageUploadDetailList' && self.moduleName != 'equipmentaccountingrecords')){

                        this.requestArr.push('rentalContractType');
                    }
                    if (listOfObjects[i].field == 'contract_type' &&  (self.moduleName == 'contractRevenue' || self.moduleName == 'mileageUploadDetailList') ) {

                        this.requestArr.push('contractType');

                    }
                    if (listOfObjects[i].field == 'contract_type' &&  (self.moduleName == 'equipmentaccountingrecords') ) {

                        this.requestArr.push('invcontractType');

                    }
                    if ( listOfObjects[i].field == 'parent_action' || listOfObjects[i].field == 'child_action'){

                        this.requestArr.push('checkListAction');
                    }
                    if ( listOfObjects[i].field == 'module' && self.moduleName == "ActivityLogList"){

                        this.requestArr.push('activityModule');
                    }
                    if ( listOfObjects[i].field == 'account_type' && ( self.moduleName == "glAccountsList" || self.moduleName == "journalsList" || self.moduleName == 'generalLedgerReport' || self.moduleName == 'trialBalanceReport' || self.moduleName == 'workOrderAccountingTransactions')){
                        this.requestArr.push('accountTypes');
                    }
                    if ( listOfObjects[i].field == 'ownership'){

                        this.requestArr.push('ownership');
                    }
                    if ( ((listOfObjects[i].field == 'inv_type' || listOfObjects[i].field == 'invoice_type' || listOfObjects[i].field == 'source_doc_type') && (self.moduleName == "invoiceList" || self.moduleName == "invoiceSubList" || self.moduleName == 'invoiceReport' || self.moduleName == 'invoiceDetailReport' || self.moduleName == "woInvoiceList")) || (listOfObjects[i].field == 'order_type' && (self.moduleName == "customerAgedTrialBalanceDetail" || self.moduleName == "agedTrialBalanceDetailGrid"))){

                        this.requestArr.push('invoiceTypes');
                    }
                    if ( listOfObjects[i].field == 'asset_feature_category'){

                        this.requestArr.push('asset_feature_category');
                    }
                    if ( listOfObjects[i].field == 'business_type'){

                        this.requestArr.push('business_type');
                    }
                    if ( listOfObjects[i].field == 'hvut_category'){

                        this.requestArr.push('hvut_categories');
                    }
                    if ( listOfObjects[i].field == 'financial_period'){

                        this.requestArr.push('financial_period');
                    }
                    if ( (listOfObjects[i].field == 'conType' || listOfObjects[i].field == 'fp_contract_type') && (self.moduleName != 'listBillingDetailForecast' && self.moduleName != 'contractRevenue' && self.moduleName != 'repairHistory' && self.moduleName != 'equipmentCurrentStatus')){

                        this.requestArr.push('contractType');
                    }
                    if (listOfObjects[i].field == 'conType' &&  (self.moduleName == 'listBillingDetailForecast' || self.moduleName == 'contractRevenue' || self.moduleName == 'repairHistory' || self.moduleName == 'equipmentCurrentStatus') ) {

                        this.requestArr.push('invcontractType');

                    }
                    if ( listOfObjects[i].field == 'customer_class'){

                        this.requestArr.push('customerClass');
                    }

                    if ( listOfObjects[i].field == 'item' && (self.moduleName == 'fuelPricingList' || self.moduleName == 'fuelDropList' || self.moduleName == 'islandProductList' || self.moduleName == 'fuelTicketList' || self.moduleName == 'fuelReadinglist' || self.moduleName == 'fuelTicketDetail')){

                        this.requestArr.push('fuelItems');
                    }
                    if ( listOfObjects[i].field == 'fuel_location'){

                        this.requestArr.push('fuelLocations');
                    }
                    if ( listOfObjects[i].field == 'source' && (self.moduleName == 'generalLedgerReport' || self.moduleName == 'workOrderAccountingTransactions')){

                        this.requestArr.push('glSrcCodes');
                    }
                    if ( listOfObjects[i].field == 'asset_pool' && (self.moduleName == 'debtNotePostingDetail' || self.moduleName == 'leaseContractExpiry' || self.moduleName == "leaseContractExpiryNonTemplate" || self.moduleName == 'weeklyRentalReport' || self.moduleName == 'assetList' || self.moduleName == 'FHUTExceptionList' || self.moduleName == "chargeCodeAccount" || self.moduleName == "ltdUnitProfitLossSummary" || self.moduleName == "assetReport" || self.moduleName == "assetFeatureList" || self.moduleName == "rentalUtilizationEquipment" || self.moduleName == 'assetFeatureSysPrmList')){

                        this.requestArr.push('vehicle_pool');
                    }
                    if ( (listOfObjects[i].field == 'vehicle_pool_id' || listOfObjects[i].field == 'old_vehicle_pool_id') && self.moduleName == 'assetLogList'){

                        this.requestArr.push('vehicle_pool');
                    }
                    if ( listOfObjects[i].field == 'pool' || listOfObjects[i].field == 'current_pool' || listOfObjects[i].field == 'old_pool' || listOfObjects[i].field == 'new_pool' || listOfObjects[i].field == 'trasaction_eq_pool'){

                        this.requestArr.push('vehicle_pool');
                    }
                    if ( listOfObjects[i].field == 'schedule_type'){

                        this.requestArr.push('depriciation_type');
                    }
                    if ( listOfObjects[i].field == 'cost_code'){

                        this.requestArr.push('costcode');
                    }
                    if ( listOfObjects[i].field == 'manufacturer_code' && (self.moduleName == "ltdUnitProfitLossSummary" || self.moduleName == 'assetReport')){

                        this.requestArr.push('vehicle_manufacturer');
                    }
                    if ( listOfObjects[i].field == 'model_code' && (self.moduleName == "ltdUnitProfitLossSummary" || self.moduleName == "contractRevenue")){

                        this.requestArr.push('vehicle_model');
                    }
                    if ( (listOfObjects[i].field == 'payment_type' && self.moduleName == 'apVoucherDistribution') || (listOfObjects[i].field == 'pay_type' && self.moduleName == 'apPaymentUpload')){

                        this.requestArr.push('paymentOptions');
                    }
                    if ( listOfObjects[i].field == 'cost_type'){

                        this.requestArr.push('cost_types');
                    }
                    if ( listOfObjects[i].field == 'rate_type'){

                        this.requestArr.push('rate_types');
                    }
                    if ( listOfObjects[i].field == 'facility' && (self.moduleName == 'customerAgedTrialBalanceDetail' || self.moduleName == 'customerAgedTrialBalance' || self.moduleName == 'agedTrialBalanceDetailGrid')){
                        this.requestArr.push('location');
                    }
                    if ( listOfObjects[i].field == 'owner' && (self.moduleName == 'availableOverdueAsset' || self.moduleName == 'netBillingMetricReport')){
                        this.requestArr.push('ownership');
                    }
                    if(listOfObjects[i].field == 'notification_type' && self.moduleName == 'customerContactList'){
                        this.requestArr.push('notification_types');
                    }
                    if(listOfObjects[i].field == 'non_bill_code' && (self.moduleName == 'fuelTicketDetail' || self.moduleName == 'FuelInventoryClearingSummaryReport')) {
                        this.requestArr.push('fuelbillablecode');
                    }
                    if (listOfObjects[i].field == 'catCode' && self.moduleName == 'inventoryReport') {
                        this.requestArr.push('component_category');
                    }
                    if (listOfObjects[i].field == 'metric_type' && self.moduleName == 'metricsBilledReport') {
                        this.requestArr.push('section');
                    }
                     if (listOfObjects[i].field == 'ins_location') {
                        this.requestArr.push('ins_locations');
                    }
                    if (listOfObjects[i].field == 'option_code' || listOfObjects[i].field == 'vehicle_option_code') {
                      this.requestArr.push('vehicle_option_codes');
                    }
                }
                this.parentColumns = listOfObjects;
            },

            //payment tag filters of Vendor Payment List
            paymentTagFilters(tagName){
                var self = this;

                setTimeout(function(){
                    $("#filterInput0").removeClass('hide');
                    $("#filterOption0").addClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                },200);

                this.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                }];

                self.defaultColumnFilters('clear');
                //remove border red from inputs
                $("#selColumnField0 .dropdown-toggle").removeClass('border-red');
                $("#selFilterType0 .dropdown-toggle").removeClass('border-red');
                $("#value_filter0").removeClass('border-red');
                self.removedListColumn = [];
                //hide all alerts
                self.selectAllDiv = false;
                self.clearSelection = false;
                self.selectionAllClear = false;
                self.isDuplicateColumn = false;
                self.filterMaxError = '';

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = false;
                self.columnFilterArr[0].filterType = {};
                self.columnFilterArr[0].filterOption = [];
                self.columnFilterArr[0].filterOptionValue = {};
                self.columnFilterArr[0].columnId.field = 'payment_tag';
                self.columnFilterArr[0].columnId.label = "Tag";
                self.columnFilterArr[0].columnId.fpFieldType = 'text';
                self.columnFilterArr[0].filterTypeArr = self.textArr; // is or is not
                self.columnFilterArr[0].filterType = {value:self.textArr[0].value,text:self.textArr[0].text};
                self.columnFilterArr[0].filterValue = tagName;
                self.onColumnFilter('load');
            },
            assetWarrantyFilter(flag) {

                var self = this;
                self.columnFilterArr = [];
                this.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[]
                }];
                setTimeout(function(){
                    $("#filterOption0").removeClass('hide');
                    $("#filterInput0").addClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');
                },200);

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = false;
                self.columnFilterArr[0].filterType = { value: '=', text: 'is'};
                if (flag == "Yes") {
                    self.columnFilterArr[0].filterOptionValue = {value:'yes',text:'Yes'};
                }else{
                    self.columnFilterArr[0].filterOptionValue = {value:'no',text:'No'};
                }
                self.columnFilterArr[0].columnId.field = 'status';
                self.columnFilterArr[0].columnId.label = "Warranty Applied";
                self.columnFilterArr[0].columnId.fpFieldType = 'option';
                self.columnFilterArr[0].filterTypeArr = self.optionArr;
                self.columnFilterArr[0].filterOption = self.assetWarrantyStatusArr;
                self.columnFilterArr[0].filterValue = '';
                self.onColumnFilter('load');
            },
            defaultYearPeriodFilters(flag){
                var self = this;
                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                },{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                },{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                }];
                if (self.moduleName == 'apTrialBalanceAsAtDetail'){
                    self.columnFilterArr.push({
                        columnId: null,
                        isColumnDisable: false,
                        filterValue: null,
                        filterDateValue: null,
                        filterDateRangeValue: null,
                        filterOptionValue: null,
                        filterType: null,
                    });
                }
                setTimeout(function(){
                    $("#filterOption0").addClass('hide');
                    $("#filterInput0").removeClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');

                    self.columnFilterArr[0].columnId = {};
                    self.columnFilterArr[0].isColumnDisable = true;
                    self.columnFilterArr[0].filterType = { value: '=', text: 'is'};
                    self.columnFilterArr[0].filterOptionValue = null;
                    self.columnFilterArr[0].columnId.field = 'as_of_year';
                    self.columnFilterArr[0].columnId.label = "As Of Year";
                    self.columnFilterArr[0].columnId.fpFieldType = 'year';
                    self.columnFilterArr[0].columnId.fpMandatory = true;
                    self.columnFilterArr[0].filterTypeArr = [{ value: '=', text: 'is'}];
                    self.columnFilterArr[0].filterValue = '';
                },200);
                setTimeout(function(){
                    $("#filterOption1").addClass('hide');
                    $("#filterInput1").removeClass('hide');
                    $("#filterDate1").addClass('hide');
                    $("#filterDateRange1").addClass('hide');
                    $("#startDate1").addClass('hide');

                    self.columnFilterArr[1].columnId = {};
                    self.columnFilterArr[1].isColumnDisable = true;
                    self.columnFilterArr[1].filterType = { value: '=', text: 'is'};
                    self.columnFilterArr[1].filterOptionValue = null;
                    self.columnFilterArr[1].columnId.field = 'as_of_period';
                    self.columnFilterArr[1].columnId.label = "As Of Period";
                    self.columnFilterArr[1].columnId.fpFieldType = 'period';
                    self.columnFilterArr[1].columnId.fpMandatory = true;
                    self.columnFilterArr[1].filterTypeArr = [{ value: '=', text: 'is'}];
                    self.columnFilterArr[1].filterValue = '';
                    // if (flag == "reset") {
                    //     self.onColumnFilter('load');
                    // }
                },200);
                setTimeout(function(){
                    $("#filterOption2").addClass('hide');
                    $("#filterInput2").addClass('hide');
                    $("#filterDate2").removeClass('hide');
                    $("#filterDateRange2").addClass('hide');
                    $("#startDate2").addClass('hide');

                    self.columnFilterArr[2].columnId = {};
                    self.columnFilterArr[2].isColumnDisable = true;
                    self.columnFilterArr[2].filterType = { value: '=', text: 'is'};
                    self.columnFilterArr[2].filterOptionValue = null;
                    self.columnFilterArr[2].columnId.field = 'aging_date';
                    self.columnFilterArr[2].columnId.label = "Aging Date";
                    self.columnFilterArr[2].columnId.fpFieldType = 'custom_date';
                    self.columnFilterArr[2].columnId.fpMandatory = true;
                    self.columnFilterArr[2].filterTypeArr = [{ value: '=', text: 'is'}];
                    self.columnFilterArr[2].filterValue = '';
                    if (flag == "reset") {
                        self.onColumnFilter('load');
                    }
                },200);

                if (self.moduleName == 'apTrialBalanceAsAtDetail'){
                    setTimeout(function(){
                    $("#filterOption3").removeClass('hide');
                    $("#filterInput3").addClass('hide');
                    $("#filterDate3").addClass('hide');
                    $("#filterDateRange3").addClass('hide');
                    $("#startDate3").addClass('hide');

                    self.columnFilterArr[3].columnId = {};
                    self.columnFilterArr[3].isColumnDisable = true;
                    self.columnFilterArr[3].filterType = { value: '=', text: 'is'};
                    self.columnFilterArr[3].filterOptionValue = 'No';
                    self.columnFilterArr[3].columnId.field = 'by_date';
                    self.columnFilterArr[3].columnId.label = "Select By Date";
                    self.columnFilterArr[3].columnId.fpFieldType = 'option';
                    self.columnFilterArr[3].columnId.fpMandatory = true;
                    self.columnFilterArr[3].filterOption = ['Yes','No'];
                    self.columnFilterArr[3].filterTypeArr = [{ value: '=', text: 'is'}];
                    self.columnFilterArr[3].filterValue = '';
                    if (flag == "reset") {
                        self.onColumnFilter('load');
                    }
                },200);
                }
            },
            includeContractEquipmentFilter(flag){
              var self = this;
              self.columnFilterArr = [{
                columnId:null,
                isColumnDisable:false,
                filterValue: null,
                filterDateValue: null,
                filterDateRangeValue: null,
                filterOptionValue: null,
                filterType: null,

              }];
              self.columnFilterArr[0].columnId = {};
              self.columnFilterArr[0].isColumnDisable = true;
              self.columnFilterArr[0].filterType = {value: '=', text: 'is'};
              self.columnFilterArr[0].filterOptionValue = null;
              self.columnFilterArr[0].columnId.field = 'as_at_date';
              self.columnFilterArr[0].columnId.label = "As At Date";
              self.columnFilterArr[0].columnId.fpFieldType = 'custom_date';
              self.columnFilterArr[0].columnId.fpMandatory = true;
              self.columnFilterArr[0].filterTypeArr = [{ value: '=', text: 'is'}];
              self.columnFilterArr[0].filterValue = '';
              if (flag == "reset") {
                  self.onColumnFilter('load');
              }

              setTimeout(function(){
                  $("#filterOption0").addClass('hide');
                  $("#filterInput0").addClass('hide');
                  $("#filterDate0").addClass('hide');
                  $("#filterDateRange0").addClass('hide');
                  $("#startDate0").removeClass('hide');
              },200);
            },
            costperMetricReportFilter(flag){
                var self = this;

                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterDupValue:[{value:"",type:""}]
                },{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterDupValue:[{value:"",type:""}]
                },{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterDupValue:[{value:"",type:""}]
                }];
                setTimeout(function(){
                    $("#filterOption0").addClass('hide');
                    $("#filterInput0").addClass('hide');
                    $("#filterDate0").removeClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');
                },200);

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = true;
                self.columnFilterArr[0].filterType = {};
                self.columnFilterArr[0].filterOptionValue = {};
                self.columnFilterArr[0].columnId.field = 'start_date';
                self.columnFilterArr[0].columnId.label = "Reading From";
                self.columnFilterArr[0].columnId.fpFieldType = 'date';
                self.columnFilterArr[0].filterTypeArr = [{value:'=',text:'is'}];
                self.columnFilterArr[0].columnId.fpMandatory = true;
                self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                self.columnFilterArr[0].filterOption = [];
                self.columnFilterArr[0].filterValue = '';
                self.columnFilterArr[0].filterDupValue[0]['value'] = '';
                self.columnFilterArr[0].filterDupValue[0]['type'] = '=';

                setTimeout(function(){
                    $("#filterOption1").addClass('hide');
                    $("#filterInput1").addClass('hide');
                    $("#filterDate1").removeClass('hide');
                    $("#filterDateRange1").addClass('hide');
                    $("#startDate1").addClass('hide');


                    self.columnFilterArr[1].columnId = {
                        "label": "End Date",
                        "field": "end_date",
                        "filterable": false,
                        "fpFieldType": "date",
                        "hidden": true,
                        "filterOptions": {
                        "enabled": false,
                        "placeholder": "MM/DD/YYYY",
                        "filterValue": "",
                        "trigger": "enter"
                        },
                        "typeDef": {}
                    };
                    self.columnFilterArr[1].isColumnDisable = true;
                    self.columnFilterArr[1].filterType = {};
                    self.columnFilterArr[1].filterOptionValue = {};
                    self.columnFilterArr[1].columnId.field = 'end_date';
                    self.columnFilterArr[1].columnId.label = "Reading To";
                    self.columnFilterArr[1].columnId.fpFieldType = 'date';
                    self.columnFilterArr[1].filterTypeArr = [{value:'=',text:'is'}];
                    self.columnFilterArr[1].columnId.fpMandatory = true;
                    self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                    self.columnFilterArr[1].filterOption = [];
                    self.columnFilterArr[1].filterValue = '';
                    self.columnFilterArr[1].filterDupValue[0]['value'] = '';
                    self.columnFilterArr[1].filterDupValue[0]['type'] = '=';
                },400);

                setTimeout(function(){
                    $("#filterOption2").removeClass('hide');
                    $("#filterInput2").addClass('hide');
                    $("#filterDate2").addClass('hide');
                    $("#filterDateRange2").addClass('hide');
                    $("#startDate2").addClass('hide');

                    var obj = self.sectionArr;
                    var secValue = '';
                    $.each(obj, function (key, uomvalue) {
                        if (uomvalue.code == 'DIST') {
                            secValue = {
                                value: uomvalue.value,
                                text: uomvalue.text,
                            };
                        }
                    });

                    self.columnFilterArr[2].columnId = {};
                    self.columnFilterArr[2].isColumnDisable = false;
                    self.columnFilterArr[2].filterType = {};
                    self.columnFilterArr[2].filterOptionValue = secValue;
                    self.columnFilterArr[2].columnId.field = 'section';
                    self.columnFilterArr[2].columnId.label = "Metric Type";
                    self.columnFilterArr[2].columnId.fpFieldType = 'option';
                    self.columnFilterArr[2].columnId.fpMandatory = true;
                    self.columnFilterArr[2].filterTypeArr = self.optionArr;
                    self.columnFilterArr[2].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                    self.columnFilterArr[2].filterOption = self.sectionArr;
                    self.columnFilterArr[2].filterValue = '';
                    self.columnFilterArr[2].filterDupValue[0]['value'] = secValue;
                    self.columnFilterArr[2].filterDupValue[0]['type'] = '=';

                },4000);

                if (flag == "reset") {
                    self.onColumnFilter('load');
                }
            },
            checkYearPeriodValue(value,flag) {
                var numberRegex = /^[0-9]+$/;
                if (value.trim() != "") {
                    if (flag == "year") {
                        if (value.length < 4 || value.length > 4) {
                            return false;
                        }
                    }

                    if (flag == "period") {
                        //period is month and month value cannot be greater than 12
                        if (value.length < 1 || value.length > 2 || value < 1 ||value > 12) {
                            return false;
                        }
                    }
                    //entered value is number or not
                    if (!value.match(numberRegex)) {
                        return false;
                    }else{
                        return true;
                    }
                }
            },
            incluePaymentInfoFilter(flag) {

                var self = this;
                self.columnFilterArr = [];
                this.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[]
                }];
                setTimeout(function(){
                    $("#filterOption0").removeClass('hide');
                    $("#filterInput0").addClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');
                },200);

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = true;
                self.columnFilterArr[0].filterType = { value: '=', text: 'is'};
                self.columnFilterArr[0].filterOptionValue = {value:'yes',text:'Yes'};
                self.columnFilterArr[0].columnId.field = 'include_payment_info';
                self.columnFilterArr[0].columnId.label = "Include Payment Information";
                self.columnFilterArr[0].columnId.fpFieldType = 'option';
                self.columnFilterArr[0].columnId.fpMandatory = true;
                self.columnFilterArr[0].filterTypeArr = self.isArr;
                self.columnFilterArr[0].filterOption = [{value:'yes',text:'Yes'},{value:'no',text:'No'}];
                self.columnFilterArr[0].filterValue = '';
                if (flag == "reset") {
                    self.onColumnFilter('load');
                }
            },
            rentalActivityReportFilter(flag) {
                var self = this;
                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                },{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                }];
                setTimeout(function(){
                    $("#filterOption0").addClass('hide');
                    $("#filterInput0").addClass('hide');
                    $("#filterDate0").removeClass('hide');
                    $("#date_value_filter0").removeClass('border-red');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');
                },200);

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = true;
                self.columnFilterArr[0].filterType = {};
                self.columnFilterArr[0].filterOptionValue = {};
                self.columnFilterArr[0].columnId.field = 'start_date';
                self.columnFilterArr[0].columnId.label = "Start Date";
                self.columnFilterArr[0].columnId.fpFieldType = 'date';
                self.columnFilterArr[0].filterTypeArr = [{ value: '=', text: 'is'}];
                self.columnFilterArr[0].filterType = {value:'=',text:'is'};
                self.columnFilterArr[0].filterOption = [];
                self.columnFilterArr[0].filterValue = '';

                setTimeout(function(){
                    $("#filterOption1").addClass('hide');
                    $("#filterInput1").addClass('hide');
                    $("#filterDate1").removeClass('hide');
                    $("#date_value_filter1").removeClass('border-red');
                    $("#filterDateRange1").addClass('hide');
                    $("#startDate1").addClass('hide');


                    self.columnFilterArr[1].columnId = {
                        "label": "End Date",
                        "field": "end_date",
                        "filterable": false,
                        "fpFieldType": "date",
                        "hidden": true,
                        "filterOptions": {
                        "enabled": false,
                        "placeholder": "MM/DD/YYYY",
                        "filterValue": "",
                        "trigger": "enter"
                        },
                        "typeDef": {}
                    };
                    self.columnFilterArr[1].isColumnDisable = true;
                    self.columnFilterArr[1].filterType = {};
                    self.columnFilterArr[1].filterOptionValue = {};
                    self.columnFilterArr[1].columnId.field = 'end_date';
                    self.columnFilterArr[1].columnId.label = "End Date";
                    self.columnFilterArr[1].columnId.fpFieldType = 'date';
                    self.columnFilterArr[1].filterTypeArr = [{ value: '=', text: 'is'}];
                    self.columnFilterArr[1].filterType = {value:'=',text:'is'};
                    self.columnFilterArr[1].filterOption = [];
                    self.columnFilterArr[1].filterValue = '';
                },200);
                // if (flag == "reset") {
                //     self.onColumnFilter('load');
                // }
            },
            warrantyClaimReportFilter(flag){
                var self = this;
                var ind = 0;

                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[],
                    filterDupValue:[{value:"",type:""}]
                }];
                setTimeout(function(){
                    $("#filterOption"+ind).removeClass('hide');
                    $("#filterInput"+ind).addClass('hide');
                    $("#filterDate"+ind).addClass('hide');
                    $("#filterDateRange"+ind).addClass('hide');
                    $("#startDate"+ind).addClass('hide');

                    self.columnFilterArr[ind].columnId = {};
                    self.columnFilterArr[ind].isColumnDisable = false;
                    self.columnFilterArr[ind].filterType = { value: '=', text: 'is'};
                    self.columnFilterArr[ind].filterOptionValue = 'Open';
                    self.columnFilterArr[ind].columnId.field = 'claim_status';
                    self.columnFilterArr[ind].columnId.label = "Claim Status (Open/Closed)";
                    self.columnFilterArr[ind].columnId.fpFieldType = 'option';
                    self.columnFilterArr[ind].filterTypeArr = [{ value: '=', text: 'is'}, { value: '!=', text: 'is not'}];
                    self.columnFilterArr[ind].filterOption = ['Open','Closed'];
                    self.columnFilterArr[ind].filterValue = '';
                    self.columnFilterArr[ind].filterDupValue[0]['value'] = 'Open';
                    self.columnFilterArr[ind].filterDupValue[0]['type'] = '=';

                    if (flag == "reset") {
                        self.onColumnFilter('load');
                    }
                },200);

            },
            includeNumberOfMonthFilter(flag) {

                var self = this;
                self.columnFilterArr = [];
                this.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[]
                }];
                setTimeout(function(){
                    $("#filterOption0").addClass('hide');
                    $("#filterInput0").removeClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');
                },200);

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = false;
                self.columnFilterArr[0].filterType = {};
                self.columnFilterArr[0].filterOptionValue = {};
                self.columnFilterArr[0].columnId.field = 'no_of_month';
                self.columnFilterArr[0].columnId.label = "Number of month to look ahead";
                self.columnFilterArr[0].columnId.fpFieldType = 'integer';
                self.columnFilterArr[0].filterTypeArr = self.isArr;
                self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                self.columnFilterArr[0].filterOption = [];
                self.columnFilterArr[0].filterValue = '1';
                if (flag == "reset") {
                    self.onColumnFilter('load');
                }
            },
            includeForecastDaysFilter:function(flag){
                var self = this;

                if (self.moduleName == 'PMUnitForecastList'){
                    self.columnFilterArr = [{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        },
                        {
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        },{
                            columnId:null,
                            isColumnDisable:false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterOption:[],
                        }];
                    setTimeout(function(){
                        $("#filterOption0").addClass('hide');
                        $("#filterInput0").removeClass('hide');
                        $("#filterDate0").addClass('hide');
                        $("#filterDateRange0").addClass('hide');
                        $("#startDate0").addClass('hide');
                    },200);

                    self.columnFilterArr[0].columnId = {};
                    self.columnFilterArr[0].isColumnDisable = false;
                    self.columnFilterArr[0].filterType = {};
                    self.columnFilterArr[0].filterOptionValue = {};
                    self.columnFilterArr[0].columnId.field = 'days_diff';
                    self.columnFilterArr[0].columnId.label = "Forecast Window (Days)";
                    self.columnFilterArr[0].columnId.fpFieldType = 'integer';
                    self.columnFilterArr[0].fpMandatory = true;
                    self.columnFilterArr[0].filterTypeArr = self.integerArr;
                    self.columnFilterArr[0].filterType = {value:self.integerArr[0].value,text:self.integerArr[0].text};
                    self.columnFilterArr[0].filterOption = [];
                    self.columnFilterArr[0].filterValue = '90';

                        // if (self.loginUserLocation[0] && self.loginUserLocation[0].value){
                        //     setTimeout(function(){
                        //         $("#filterOption1").removeClass('hide');
                        //         $("#filterInput1").addClass('hide');
                        //         $("#filterDate1").addClass('hide');
                        //         $("#filterDateRange1").addClass('hide');
                        //         $("#startDate1").addClass('hide');
                        //     },200);

                        //         var obj = self.locationArr;
                        //         // self.loginUserLocation
                        //         var locValue = '';
                        //         // $.each(obj, function (key, lcValue) {
                        //         //     console.log(lcValue);
                        //         //     if (lcValue.value == self.loginUserLocation[0].value) {
                        //                 locValue = {
                        //                     value: self.loginUserLocation[0].value,
                        //                     text: self.loginUserLocation[0].text,
                        //                 };
                        //         //     }
                        //         // });

                        //         self.columnFilterArr[1].columnId = {};
                        //         self.columnFilterArr[1].isColumnDisable = false;
                        //         self.columnFilterArr[1].filterType = {};
                        //         self.columnFilterArr[1].filterOptionValue = locValue;
                        //         self.columnFilterArr[1].columnId.field = 'location';
                        //         self.columnFilterArr[1].columnId.label = "Facility";
                        //         self.columnFilterArr[1].columnId.fpFieldType = 'option';
                        //         self.columnFilterArr[1].filterTypeArr = self.optionArr;
                        //         self.columnFilterArr[1].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                        //         setTimeout(function(){
                        //             self.columnFilterArr[1].filterOption = self.locationArr;
                        //         },4000);
                        //         self.columnFilterArr[1].filterValue = '';
                        // }

                         setTimeout(function(){
                            $("#filterOption2").removeClass('hide');
                            $("#filterInput2").addClass('hide');
                            $("#filterDate2").addClass('hide');
                            $("#filterDateRange2").addClass('hide');
                            $("#startDate2").addClass('hide');

                            self.columnFilterArr[2].columnId = {};
                            self.columnFilterArr[2].isColumnDisable = false;
                            self.columnFilterArr[2].filterType = {};
                            self.columnFilterArr[2].filterOptionValue = {};
                            self.columnFilterArr[2].columnId.field = 'schedule';
                            self.columnFilterArr[2].columnId.label = "Schedule";
                            self.columnFilterArr[2].columnId.fpFieldType = 'option';
                            self.columnFilterArr[2].filterTypeArr = self.isArr;
                            self.columnFilterArr[2].fpMandatory = true;
                            self.columnFilterArr[2].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                            self.columnFilterArr[2].filterOption = ['Yes','No','All'];
                            self.columnFilterArr[2].filterOptionValue = 'All';
                            self.columnFilterArr[2].filterDupValue[0]['value'] = "All";
                            self.columnFilterArr[2].filterDupValue[0]['type'] = "=";
                        },400);

                    if (flag == "reset") {
                    self.onColumnFilter('load');
                }
                }
            },
            includePMCategoryFilter:function(flag){
                var self = this;
                self.columnFilterArr = [];
                this.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[]
                }];
                setTimeout(function(){
                    $("#filterOption0").removeClass('hide');
                    $("#filterInput0").addClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');
                },200);

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = true;
                self.columnFilterArr[0].filterType = {};
                self.columnFilterArr[0].filterOptionValue = {text:'All',value:'all'};
                self.columnFilterArr[0].columnId.field = 'category';
                self.columnFilterArr[0].columnId.label = "PM Category";
                self.columnFilterArr[0].columnId.fpFieldType = 'option';
                self.columnFilterArr[0].filterTypeArr = self.isArr;
                self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                self.columnFilterArr[0].filterOption = self.programCategoryArr;
                self.columnFilterArr[0].filterValue = '';
                if (flag == "reset") {
                    self.onColumnFilter('load');
                }
            },

            includeDepAsAtLevel:function(flag){
                var self = this;
                self.columnFilterArr = [];
                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                },{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                }];

                setTimeout(function(){
                    $("#filterOption0").addClass('hide');
                    $("#filterInput0").addClass('hide');
                    $("#filterDate0").removeClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');


                    self.columnFilterArr[0].columnId = {
                        "label": "Period End Date",
                        "field": "period_end",
                        "filterable": false,
                        "fpFieldType": "custom_date",
                        "hidden": true,
                        "filterOptions": {
                        "enabled": false,
                        "placeholder": "MM/DD/YYYY",
                        "filterValue": "",
                        "trigger": "enter"
                        },
                        "typeDef": {}
                    };
                    self.columnFilterArr[0].isColumnDisable = false;
                    self.columnFilterArr[0].filterType = {};
                    self.columnFilterArr[0].filterOptionValue = {};
                    self.columnFilterArr[0].columnId.field = 'period_end';
                    self.columnFilterArr[0].columnId.label = "Period End Date";
                    self.columnFilterArr[0].columnId.fpFieldType = 'custom_date';
                    self.columnFilterArr[0].columnId.fpMandatory = true;
                    self.columnFilterArr[0].filterTypeArr = self.isArr;
                    self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                    self.columnFilterArr[0].filterOption = [];
                    self.columnFilterArr[0].filterValue = '';
                },200);

                setTimeout(function(){

                    $("#filterOption1").addClass('hide');
                    $("#filterInput1").removeClass('hide');
                    $("#filterDate1").addClass('hide');
                    $("#filterDateRange1").addClass('hide');
                    $("#startDate1").addClass('hide');

                    self.columnFilterArr[1].columnId = {
                        "label": "Cap Cost As At",
                        "field": "capital_amount",
                        "filterable": false,
                        "fpFieldType": "integer",
                        "fpMandatory":false,
                        "hidden": true,
                        "filterOptions": {
                        "enabled": false,
                        "placeholder": "Capital Amount",
                        "filterValue": "",
                        "trigger": "enter"
                        },
                        "typeDef": {}
                    };
                    self.columnFilterArr[1].isColumnDisable = false;
                    self.columnFilterArr[1].filterType = {};
                    self.columnFilterArr[1].filterOption = {};
                    self.columnFilterArr[1].filterOptionValue = {};
                    // self.columnFilterArr[0].columnId.fpFieldType = 'text';
                    self.columnFilterArr[1].filterType = {value:'!=',text:'is not'};
                    // self.columnFilterArr[0].columnId = {field:'start_date',label:'Start Date'};
                    self.columnFilterArr[1].filterValue = 0;
                    self.columnFilterArr[1].filterTypeArr = self.integerArr;
                    self.columnFilterArr[1].filterOption = [];
                    // self.columnFilterArr[1].isColumnDisable = true;
                    self.columnFilterArr[1].filterDupValue[0]['value'] = 0;
                    self.columnFilterArr[1].filterDupValue[0]['type'] = '!=';
                },200);

                if (flag == "reset") {
                    self.onColumnFilter('load');
                }
            },
             includeAnnualizedMetricLevel:function(flag){
                var self = this;
                self.columnFilterArr = [];
                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                }];

                setTimeout(function(){
                    $("#filterOption0").removeClass('hide');
                    $("#filterInput0").addClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');

                    var obj = self.sectionArr;
                    var secValue = '';
                    $.each(obj, function (key, uomvalue) {
                        if (uomvalue.code == 'DIST') {
                            secValue = {
                                value: uomvalue.value,
                                text: uomvalue.text,
                            };
                        }
                    });

                    self.columnFilterArr[0].columnId = {};
                    self.columnFilterArr[0].isColumnDisable = false;
                    self.columnFilterArr[0].filterType = {};
                    self.columnFilterArr[0].filterOptionValue = secValue;
                    self.columnFilterArr[0].columnId.field = 'section';
                    self.columnFilterArr[0].columnId.label = "Metric Type";
                    self.columnFilterArr[0].columnId.fpFieldType = 'option';
                    self.columnFilterArr[0].filterTypeArr = self.optionArr;
                    self.columnFilterArr[0].filterType = {value:self.optionArr[0].value,text:self.optionArr[0].text};
                    self.columnFilterArr[0].filterOption = self.sectionArr;
                    self.columnFilterArr[0].filterValue = '';

                    if (flag == "reset") {
                        self.onColumnFilter('load');
                    }
                },1000);

            },
            includeDetailLevel:function(flag){
                var self = this;
                self.columnFilterArr = [];
                this.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[]
                },
                {
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[]
                },
                {
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[]
                }];

            setTimeout(function(){
                $("#filterOption0").addClass('hide');
                $("#filterInput0").addClass('hide');
                $("#filterDate0").removeClass('hide');
                $("#filterDateRange0").addClass('hide');
                $("#startDate0").addClass('hide');

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = true;
                self.columnFilterArr[0].filterType = {};
                self.columnFilterArr[0].filterOptionValue = {};
                self.columnFilterArr[0].columnId.field = 'start_date';
                self.columnFilterArr[0].columnId.label = "From Date";
                self.columnFilterArr[0].columnId.fpFieldType = 'date';
                self.columnFilterArr[0].columnId.fpMandatory = true;
                self.columnFilterArr[0].filterTypeArr = self.isArr;
                self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                self.columnFilterArr[0].filterOption = [];
                self.columnFilterArr[0].filterValue = '';

                $("#filterOption1").addClass('hide');
                $("#filterInput1").addClass('hide');
                $("#filterDate1").removeClass('hide');
                $("#filterDateRange1").addClass('hide');
                $("#startDate1").addClass('hide');


                self.columnFilterArr[1].columnId = {
                    "label": "End Date",
                    "field": "end_date",
                    "filterable": false,
                    "fpFieldType": "date",
                    "hidden": true,
                    "filterOptions": {
                    "enabled": false,
                    "placeholder": "MM/DD/YYYY",
                    "filterValue": "",
                    "trigger": "enter"
                    },
                    "typeDef": {}
                };
                self.columnFilterArr[1].isColumnDisable = true;
                self.columnFilterArr[1].filterType = {};
                self.columnFilterArr[1].filterOptionValue = {};
                self.columnFilterArr[1].columnId.field = 'end_date';
                self.columnFilterArr[1].columnId.label = "To Date";
                self.columnFilterArr[1].columnId.fpFieldType = 'date';
                self.columnFilterArr[1].columnId.fpMandatory = true;
                self.columnFilterArr[1].filterTypeArr = self.isArr;
                self.columnFilterArr[1].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                self.columnFilterArr[1].filterOption = [];
                self.columnFilterArr[1].filterValue = '';

                $("#filterOption2").removeClass('hide');
                $("#filterInput2").addClass('hide');
                $("#filterDate2").addClass('hide');
                $("#filterDateRange2").addClass('hide');
                $("#startDate2").addClass('hide');

                self.columnFilterArr[2].columnId = {};
                self.columnFilterArr[2].isColumnDisable = true;
                self.columnFilterArr[2].filterType = {};
                self.columnFilterArr[2].filterOptionValue = 'Facility';
                self.columnFilterArr[2].columnId.field = 'detail_value';
                self.columnFilterArr[2].columnId.label = "Labor Report Detail Level";
                self.columnFilterArr[2].columnId.fpFieldType = 'option';
                self.columnFilterArr[2].columnId.fpMandatory = true;
                self.columnFilterArr[2].filterTypeArr = self.isArr;
                self.columnFilterArr[2].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                self.columnFilterArr[2].filterOption = ['Facility','Employee'];
                self.columnFilterArr[2].filterValue = '';

                if (flag == "reset") {
                    self.onColumnFilter('load');
                }
            },500);
            },

            setDefault: function() {

                var self = this;

                var newCol = self.$parent.columns.filter(function(item){ return item['field'] != 'action' });
                //if from schedule report form then call event save-column-config
                if (self.fromSchedule != undefined && self.fromSchedule == "schedule-report") {
                    if ( !self.isColumnConfig ) {
                        self.$set(self.$parent, 'userColumns', self.$parent.columns);
                        self.parentColumns = newCol.filter(function(item){ return item['filterable'] != false });//filterable not false
                        self.columnConfigArr = self.$parent.columns;
                        self.closeNav();
                        return;
                    }else{
                        $("#defaultConfigBtn").val("Processing...");
                        $("#defaultConfigBtn").prop("disabled", true);
                        EventBus.$emit('remove-column-config','remove');
                        return;
                    }

                }

                if ( !self.isColumnConfig ) {
                    self.$set(self.$parent, 'userColumns', self.$parent.columns);
                    self.parentColumns = newCol.filter(function(item){ return item['filterable'] != false });//filterable not false
                    self.columnConfigArr = self.$parent.columns;
                    self.closeNav();
                    return;
                }


                $("#defaultConfigBtn").val("Processing...");
                $("#defaultConfigBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.ROOT_API + "/datatable-config/delete",
                    type: "DELETE",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        module: self.moduleName
                    },
                    success: function (data) {

                        $("#defaultConfigBtn").val("Set Default");
                        $("#defaultConfigBtn").prop("disabled", false);
                        if (data.status == "success") {
                            self.$set(self.$parent, 'userColumns', self.$parent.columns);
                            self.parentColumns = newCol.filter(function(item){ return item['filterable'] != false });//filterable not false
                            self.columnConfigArr = self.$parent.columns;

                            self.closeNav();
                            self.isColumnConfig = false;
                        }
                        // document.getElementById("ColumnList").style.width = "0";
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        $("#defaultConfigBtn").val("Set Default");
                        $("#defaultConfigBtn").prop("disabled", false);


                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            storeColumnConfig: function() {

                var self = this;

                $("#saveColumnConfigBtn").val("Saving ...");
                $("#saveColumnConfigBtn").prop("disabled", true);
                $("#cancelColumnConfigBtn").prop("disabled",true);

                // //if from schedule report form then call event save-column-config
                // if (self.fromSchedule != undefined && self.fromSchedule == "schedule-report") {
                //     EventBus.$emit('save-column-config',self.columnConfigArr);
                //     return;
                // }

                $.ajax({
                    url: process.env.ROOT_API + "/datatable-config/store",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        module: self.moduleName,
                        privacy:'default',
                        columns:JSON.stringify(self.columnConfigArr),
                        filters:JSON.stringify(self.columnFilterArr),
                    },
                    success: function (data) {

                        //self.loading = false;

                        $("#saveColumnConfigBtn").val("Save");
                        $("#saveColumnConfigBtn").prop("disabled", false);
                        $("#cancelColumnConfigBtn").prop("disabled",false);

                        if (data.status == "success") {
                            self.closeNav();
                            self.isColumnConfig = true;
                            //document.getElementById("ColumnList").style.width = "0";
                        }
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        $("#saveColumnConfigBtn").val("Save");
                        $("#saveColumnConfigBtn").prop("disabled", false);
                        $("#cancelColumnConfigBtn").prop("disabled",false);

                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            //hide show column
            showListColumn: function(event,index) {
                var self = this;

                if (event.target.checked) {

                    self.$set(self.$parent.userColumns[index], 'hidden', false);
                    self.$set(self.columnConfigArr[index], 'hidden', false);
                    //self.parentColumns[index+1].hidden = false;
                } else {

                    //self.parentColumns[index+1].hidden = true;
                    self.$set(self.$parent.userColumns[index], 'hidden', true);
                    self.$set(self.columnConfigArr[index], 'hidden', true);
                }

            },
            closeNav() {
              document.getElementById("ColumnList").style.width = "0";
              /*document.getElementById("page-content-wrapper").style.marginRight= "0";*/
            },

            //cancel button click
            cancelColumnConfig(){

                var self = this;

                //to avoid action column populate in filter dropdown
                var newCol = self.$parent.columns.filter(function(item){ return item['field'] != 'action' });
                //if from schedule report form then set columns
                if (self.fromSchedule != undefined && self.fromSchedule == "schedule-report") {
                    if (!self.isColumnConfig) {
                      self.columnConfigArr = newCol;
                      //in case when user not store column configuration
                      self.$set(self.$parent, 'userColumns', self.$parent.columns);
                      self.parentColumns = self.$parent.columns.filter(function(item){ return item['field'] != 'action' });
                      self.parentColumns = self.parentColumns.filter(function(item){ return item['filterable'] != false });//filterable not false
                      self.columnConfigArr = self.$parent.columns;

                      for(var i=0;i<self.$parent.userColumns.length;i++){
                        self.$set(self.$parent.userColumns[i], 'hidden', false);
                      }

                      for(var i=0;i<self.parentColumns.length;i++){
                        self.$set(self.parentColumns[i], 'hidden', false);
                      }
                    }
                    self.closeNav();
                    return;
                  }

                if ( !self.isColumnConfig ) {

                    //self.$set(self.$parent, 'userColumns', newCol);
                    //self.parentColumns = newCol;
                    self.columnConfigArr = newCol;
                    self.closeNav();
                    return;
                }

                $.ajax({
                    url: process.env.ROOT_API + "/datatable-config/fetch",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        module: self.moduleName
                    },
                    dataType: "json",
                    success: function (data) {

                        //self.loading = false;

                        if ( data.status == "success" && data.code == '200') {

                            var jsonArr = JSON.parse(data.content['columns']);
                            if ( data.content.id != undefined && data.content['columns'][0] != undefined ) {

                                //remove dragable params from array
                                var i = 0;
                                var userConfig = JSON.parse(data.content['columns'],(key, value) => {

                                    if ( key == "typeDef" ) {
                                        delete jsonArr[0].typeDef;
                                        i++;
                                        return;
                                    }
                                    return value;
                                });

                                self.parentColumns = JSON.parse(data.content['columns']).filter(function(item){ return item['field'] != 'action' });
                                self.parentColumns = self.parentColumns.filter(function(item){ return item['filterable'] != false });//filterable not false
                                self.columnConfigArr = JSON.parse(data.content['columns']);
                                self.$set(self.$parent, 'userColumns', userConfig);

                            } else {
                                //in case when user not store column configuration
                                self.$set(self.$parent, 'userColumns', self.$parent.columns);
                                self.parentColumns = self.$parent.columns.filter(function(item){ return item['field'] != 'action' });
                                self.parentColumns = self.parentColumns.filter(function(item){ return item['filterable'] != false });//filterable not false
                                self.columnConfigArr = self.$parent.columns;

                                for(var i=0;i<self.$parent.userColumns.length;i++){
                                    self.$set(self.$parent.userColumns[i], 'hidden', false);
                                }

                                for(var i=0;i<self.parentColumns.length;i++){
                                    self.$set(self.parentColumns[i], 'hidden', false);
                                }
                            }

                        } else {

                            //load default configuration
                            self.$set(self.$parent, 'userColumns', self.$parent.columns);
                            self.parentColumns = self.$parent.columns.filter(function(item){ return item['field'] != 'action' });
                            self.parentColumns = self.parentColumns.filter(function(item){ return item['filterable'] != false });//filterable not false
                            self.columnConfigArr = self.$parent.columns;

                            for(var i=0;i<self.$parent.userColumns.length;i++){
                                self.$set(self.$parent.userColumns[i], 'hidden', false);
                            }

                            for(var i=0;i<self.parentColumns.length;i++){
                                self.$set(self.parentColumns[i], 'hidden', false);
                            }
                        }

                        document.getElementById("ColumnList").style.width = "0";
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            trialBalanceReportFilters(flag){
                var self = this;
                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                },{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                },
                {
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                }];
                setTimeout(function(){
                    $("#filterOption0").addClass('hide');
                    $("#filterInput0").removeClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").addClass('hide');

                    self.columnFilterArr[0].columnId = {};
                    self.columnFilterArr[0].isColumnDisable = true;
                    self.columnFilterArr[0].filterType = { value: '=', text: 'is'};
                    self.columnFilterArr[0].filterOptionValue = null;
                    self.columnFilterArr[0].columnId.field = 'year';
                    self.columnFilterArr[0].columnId.label = "Year";
                    self.columnFilterArr[0].columnId.fpFieldType = 'year';
                    self.columnFilterArr[0].columnId.fpMandatory = true;
                    self.columnFilterArr[0].columnId.sortable = false;
                    self.columnFilterArr[0].filterTypeArr = [{ value: '=', text: 'is'}];
                    self.columnFilterArr[0].filterValue = '';
                },200);
                setTimeout(function(){
                    $("#filterOption1").addClass('hide');
                    $("#filterInput1").removeClass('hide');
                    $("#filterDate1").addClass('hide');
                    $("#filterDateRange1").addClass('hide');
                    $("#startDate1").addClass('hide');

                    self.columnFilterArr[1].columnId = {};
                    self.columnFilterArr[1].isColumnDisable = true;
                    self.columnFilterArr[1].filterType = { value: '=', text: 'is'};
                    self.columnFilterArr[1].filterOptionValue = null;
                    self.columnFilterArr[1].columnId.field = 'beginning_period';
                    self.columnFilterArr[1].columnId.label = "Beginning Period";
                    self.columnFilterArr[1].columnId.fpFieldType = 'period';
                    self.columnFilterArr[1].columnId.fpMandatory = true;
                    self.columnFilterArr[1].columnId.sortable = false;
                    self.columnFilterArr[1].filterTypeArr = [{ value: '=', text: 'is'}];
                    self.columnFilterArr[1].filterValue = '';
                    $("#filterOption2").addClass('hide');
                    $("#filterInput2").removeClass('hide');
                    $("#filterDate2").addClass('hide');
                    $("#filterDateRange2").addClass('hide');
                    $("#startDate2").addClass('hide');

                    self.columnFilterArr[2].columnId = {};
                    self.columnFilterArr[2].isColumnDisable = true;
                    self.columnFilterArr[2].filterType = { value: '=', text: 'is'};
                    self.columnFilterArr[2].filterOptionValue = null;
                    self.columnFilterArr[2].columnId.field = 'ending_period';
                    self.columnFilterArr[2].columnId.label = "Ending Period";
                    self.columnFilterArr[2].columnId.fpFieldType = 'period';
                    self.columnFilterArr[2].columnId.fpMandatory = true;
                    self.columnFilterArr[2].columnId.sortable = false;
                    self.columnFilterArr[2].filterTypeArr = [{ value: '=', text: 'is'}];
                    self.columnFilterArr[2].filterValue = '';
                    if (flag == "reset") {
                        self.onColumnFilter('load');
                    }
                },200);
            },

            inventoryFilterLoad:function(){
                var self = this;

                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[],
                },
                {
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[],
                },{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[],
                }];

                self.columnFilterArr[0].columnId = {};
                self.columnFilterArr[0].isColumnDisable = true;
                self.columnFilterArr[0].filterType = {};
                self.columnFilterArr[0].filterOptionValue = {};
                self.columnFilterArr[0].columnId.field = 'as_at_date';
                self.columnFilterArr[0].columnId.label = "As At Date";
                self.columnFilterArr[0].columnId.fpFieldType = 'custom_date';
                self.columnFilterArr[0].columnId.sortable = false;
                self.columnFilterArr[0].filterTypeArr = self.isArr;
                self.columnFilterArr[0].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                self.columnFilterArr[0].filterOption = [];
                self.columnFilterArr[0].filterValue = '';

                setTimeout(function(){
                    $("#filterOption0").addClass('hide');
                    $("#filterInput0").addClass('hide');
                    $("#filterDate0").addClass('hide');
                    $("#filterDateRange0").addClass('hide');
                    $("#startDate0").removeClass('hide');
                },200);

                setTimeout(function(){
                    $("#filterOption1").addClass('hide');
                    $("#filterInput1").removeClass('hide');
                    $("#filterDate1").addClass('hide');
                    $("#filterDateRange1").addClass('hide');
                    $("#startDate1").addClass('hide');

                    self.columnFilterArr[1].columnId = {};
                    self.columnFilterArr[1].isColumnDisable = true;
                    self.columnFilterArr[1].filterType = {};
                    self.columnFilterArr[1].filterOptionValue = {};
                    self.columnFilterArr[1].columnId.field = 'as_of_year';
                    self.columnFilterArr[1].columnId.label = "As Of Year";
                    self.columnFilterArr[1].columnId.fpFieldType = 'year';
                    self.columnFilterArr[1].columnId.sortable = false;
                    self.columnFilterArr[1].filterTypeArr = self.isArr;
                    self.columnFilterArr[1].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                    self.columnFilterArr[1].filterValue = '';
                },200);

                setTimeout(function(){
                    $("#filterOption2").addClass('hide');
                    $("#filterInput2").removeClass('hide');
                    $("#filterDate2").addClass('hide');
                    $("#filterDateRange2").addClass('hide');
                    $("#startDate2").addClass('hide');

                    self.columnFilterArr[2].columnId = {};
                    self.columnFilterArr[2].isColumnDisable = true;
                    self.columnFilterArr[2].filterType = {};
                    self.columnFilterArr[2].filterOptionValue = {};
                    self.columnFilterArr[2].columnId.field = 'as_of_period';
                    self.columnFilterArr[2].columnId.label = "As Of Period";
                    self.columnFilterArr[2].columnId.fpFieldType = 'period';
                    self.columnFilterArr[2].columnId.sortable = false;
                    self.columnFilterArr[2].filterTypeArr = self.isArr;
                    self.columnFilterArr[2].filterType = {value:self.isArr[0].value,text:self.isArr[0].text};
                    self.columnFilterArr[2].filterValue = '';
                },200);
            },

            loadStoredListFilters: function(){
              var self = this;
              $.ajax({
                url: process.env.ROOT_API + "/search-default-filters",
                type: "GET",
                headers: this.ajxHeaders,
                data: {
                  module: self.moduleName
                },
                dataType: "json",
                success: function (data) {
                  self.filterOption = data.content.all_filter;
                },
                error: function(jqXHR, exception) {
                  //incase any error occurs in api then we load list page
                  self.loading = false;
                  self.loadFilters('load');
                  if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                  } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                      //clear previous data
                      localStorage.removeItem("user_obj");
                      localStorage.removeItem("tkn");
                      //EventBus.$emit("logged-in", true, "", "");
                      self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                  }
                }
              });
            },

            priceBookLoad() {
                var self = this;
                self.columnFilterArr = [{
                    columnId:null,
                    isColumnDisable:false,
                    filterValue: null,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: null,
                    filterType: null,
                    filterOption:[],
                }];
            },

            populatePublicationFilters(text){
                var self = this;
                if(text == null){
                    var flagArr = ['publication_depart_doc_type'];
                    var flag = '';
                    $.ajax({
                        url: process.env.ROOT_API + "/common/field-data",
                        type: "POST",
                        headers: this.ajxHeaders,
                        crossDomain: true,
                        data:{'params':flagArr,'flag' : flag},
                        dataType: 'json',
                        success: function (data) {
                            if (data.status == "success") {
                                self.loading = false;

                                self.applyPublicationFilters(data);
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.Registerbtn = "Register";
                            if (jqXHR.status == 0) {
                                self.registerError = "Remote server cannot be reached";
                            }
                        }
                    });
                }else{
                    self.applyPublicationFilters(null);
                }
            },

            applyPublicationFilters(data){
                var self = this;
                self.columnFilterArr = [];
                self.$parent.columns.forEach((column, index) => {
                    if(column.filterable == true){
                        self.columnFilterArr.push({
                            columnId: null,
                            isColumnDisable: false,
                            filterValue: null,
                            filterDateValue: null,
                            filterDateRangeValue: null,
                            filterOptionValue: null,
                            filterType: null,
                            filterDupValue: [{ value: "", type: "" }]
                        });

                        if(column.field == 'department' || column.field == 'document_type'){
                            setTimeout(function(){
                                $(`#filterOption${index-1}`).removeClass('hide');
                                $(`#filterInput${index-1}`).addClass('hide');
                                $(`#filterDate${index-1}`).addClass('hide');
                                $(`#filterDateRange${index-1}`).addClass('hide');
                                $(`#startDate${index-1}`).addClass('hide');
                                $(`#filterInputfilterOption${index-1}`).addClass('hide');
                                $(`#duration${index-1}`).addClass('hide');
                                $(`#month_period${index-1}`).addClass('hide');
                            }, 200);
                        }else if(column.field == 'document_title' || column.field == 'publication_no'){
                            setTimeout(function(){
                                $(`#filterOption${index-1}`).addClass('hide');
                                $(`#filterInput${index-1}`).removeClass('hide');
                                $(`#filterDate${index-1}`).addClass('hide');
                                $(`#filterDateRange${index-1}`).addClass('hide');
                                $(`#startDate${index-1}`).addClass('hide');
                                $(`#filterInputfilterOption${index-1}`).addClass('hide');
                                $(`#duration${index-1}`).addClass('hide');
                                $(`#month_period${index-1}`).addClass('hide');
                            }, 200);
                        }else if(column.field == 'publication_date' || column.field == 'revised_date'){
                            setTimeout(function(){
                                $(`#filterOption${index-1}`).addClass('hide');
                                $(`#filterInput${index-1}`).addClass('hide');
                                $(`#filterDate${index-1}`).addClass('hide');
                                $(`#filterDateRange${index-1}`).removeClass('hide');
                                $(`#startDate${index-1}`).addClass('hide');
                                $(`#filterInputfilterOption${index-1}`).addClass('hide');
                                $(`#duration${index-1}`).addClass('hide');
                                $(`#month_period${index-1}`).addClass('hide');
                            }, 200);
                        }
                        self.columnFilterArr[index-1].multiple = column.multiple;
                        self.columnFilterArr[index-1].columnId = {};
                        self.columnFilterArr[index-1].isColumnDisable = true;
                        self.columnFilterArr[index-1].filterType = {};
                        self.columnFilterArr[index-1].filterOptionValue = [];
                        self.columnFilterArr[index-1].columnId.field = column.field;
                        self.columnFilterArr[index-1].columnId.label = column.label;
                        self.columnFilterArr[index-1].columnId.fpFieldType = column.fpFieldType;
                        self.columnFilterArr[index-1].filterValue = '';
                        self.columnFilterArr[index-1].filterDupValue[0]['value'] = '';
                        self.columnFilterArr[index-1].filterDupValue[0]['type'] = '';

                        if(column.field == 'document_title'){
                            self.columnFilterArr[index-1].columnId.label = "Keyword";
                        }

                        if(column.field == 'department' || column.field == 'document_type'){
                            self.columnFilterArr[index-1].filterTypeArr = self.optionArr;
                            self.columnFilterArr[index-1].filterType = { value: self.optionArr[0].value, text: self.optionArr[0].text };
                            if(data == null){
                                if(column.field == 'department'){
                                    self.columnFilterArr[index-1].filterOption = self.$parent.departmentArr;
                                }else{
                                    self.columnFilterArr[index-1].filterOption = self.$parent.documenttypeArr;
                                }
                            }else{
                                if(column.field == 'department'){
                                    self.columnFilterArr[index-1].filterOption = data.content.publi_depart_doc_data.departments;
                                }else{
                                    self.columnFilterArr[index-1].filterOption = data.content.publi_depart_doc_data.documentTypes;
                                }
                            }
                        }else if(column.field == 'document_title' || column.field == 'publication_no'){
                            self.columnFilterArr[index-1].filterTypeArr = self.textArr;
                            self.columnFilterArr[index-1].filterType = { value: self.textArr[0].value, text: self.textArr[0].text };
                        }else if(column.field == 'publication_date' || column.field == 'revised_date'){
                            self.columnFilterArr[index-1].filterTypeArr = self.dateArr;
                            self.columnFilterArr[index-1].filterType = { value: self.dateArr[4].value, text: self.dateArr[4].text };
                        }
                    }
                });
            },

            checkIsIntegerField(event, column) {
                if (column && column.columnId && column.columnId.fpFieldType === 'integer') {
                    this.isDecimalValue(event);
                }
            },
        }
    };
    //on column config save from schedule report
    EventBus.$on('column-config-saved', function ( flag ) {
        $("#saveColumnConfigBtn").val("Save");
        $("#saveColumnConfigBtn").prop("disabled", false);
        $("#cancelColumnConfigBtn").prop("disabled",false);
        EventBus.$emit('save-column-config',contex.columnConfigArr);
        contex.isColumnConfig = true;
        contex.closeNav();
    });
    //on load column config from update schedule report
    EventBus.$on('column-config-load-report', function ( configData ) {
        if (configData != undefined && configData != null) {
            if (configData.length > 0) {
                contex.parentColumns = configData.filter(function(item){ return item['field'] != 'action' });
                contex.parentColumns = contex.parentColumns.filter(function(item){ return item['filterable'] != false });//filterable not false
                contex.columnConfigArr = configData;
                contex.$set(contex.$parent, 'userColumns',contex.$parent.columns);
                contex.isColumnConfig = true;
            }else{
                //in case when user not store column configuration
                contex.$set(contex.$parent, 'userColumns', contex.$parent.columns);
                contex.parentColumns = contex.$parent.columns.filter(function(item){ return item['field'] != 'action' });
                contex.parentColumns = contex.parentColumns.filter(function(item){ return item['filterable'] != false });//filterable not false
                contex.columnConfigArr = contex.$parent.columns;

                for(var i=0;i<contex.$parent.userColumns.length;i++){
                    contex.$set(contex.$parent.userColumns[i], 'hidden', false);
                }

                for(var i=0;i<contex.parentColumns.length;i++){
                    contex.$set(contex.parentColumns[i], 'hidden', false);
                }
                contex.isColumnConfig = false;
            }
        }else{
            //load default configuration
            contex.$set(contex.$parent, 'userColumns', contex.$parent.columns);
            contex.parentColumns = contex.$parent.columns.filter(function(item){ return item['field'] != 'action' });
            contex.parentColumns = contex.parentColumns.filter(function(item){ return item['filterable'] != false });//filterable not false
            contex.columnConfigArr = contex.$parent.columns;

            for(var i=0;i<contex.$parent.userColumns.length;i++){
                contex.$set(contex.$parent.userColumns[i], 'hidden', false);
            }

            for(var i=0;i<contex.parentColumns.length;i++){
                contex.$set(contex.parentColumns[i], 'hidden', false);
            }
            contex.isColumnConfig = false;
        }
    });
    //on column config remove after set default from schedule report
    EventBus.$on('column-config-removed', function ( flag ) {
        $("#defaultConfigBtn").val("Set Default");
        $("#defaultConfigBtn").prop("disabled", false);
        var newCol = contex.$parent.columns.filter(function(item){ return item['field'] != 'action' });
        //load default configuration
        for (var i=0;i<contex.$parent.columns.length;i++){
            contex.$parent.columns[i].hidden = false;
        }
        contex.$set(contex.$parent, 'userColumns', contex.$parent.columns);
        contex.parentColumns = newCol.filter(function(item){ return item['filterable'] != false });//filterable not false
        contex.columnConfigArr = contex.$parent.columns;

        contex.closeNav();
        contex.isColumnConfig = false;
    });

    //catch event when click on select all button
    EventBus.$on('select-all', function ( selectAll ) {

        if ( contex.$parent.totalRecords > contex.$parent.perPage ) {
            contex.allRecords = contex.$parent.totalRecords;
            contex.selectAllDiv = selectAll;

        }
    });
    EventBus.$on('clear-selection', function (value) {
        if ( contex.clearSelection == true ) {

            contex.clearSelection = value;
            contex.selectionAllClear = true;
            //hide clear selection alert div
            setTimeout(function(){
                contex.selectionAllClear = false;
            },10000);

        }
    });
    EventBus.$on("clearSelection", function (value) {
        contex.selectAllDiv = value
    });
    //clear all alert flags in case of send notification
    EventBus.$on('clear-all-flags', function ( value ) {
        contex.selectAllDiv = value;
        contex.clearSelection = value;
        contex.selectionAllClear = value;

    });
    //Loading All Filters as per module
    EventBus.$on('all-filter-option', function ( value ) {
        if(value && value.lenght > 0 && contex && contex.filterOption){
            contex.filterOption=[];
            contex.filterOption = value;
        }
    });
    //Loading Default Filter
    EventBus.$on('default-filter-load', function ( value ) {
        contex.columnFilterArr = [];

        var contentArr = value;
        contex.onsearchFilterFlag=true;
        if (contentArr && contentArr.length > 0){
            // for(var i = 0; i < contentArr.length; i++){
                var i = 0;
                contentArr.forEach((contentArr, index) => {
                if(contentArr.columnId !== null){

                    contex.isTypeChange = false

                    $("#filterInput"+i).addClass('hide');
                    $("#filterOption"+i).addClass('hide');
                    $("#filterDate"+i).addClass('hide');
                    $("#filterDateRange"+i).addClass('hide');
                    $("#duration"+i).addClass('hide');
                    $("#month_period"+i).addClass('hide');
                    if ( contentArr.columnId.fpFieldType == 'option') {
                        var optionLocArr = contentArr.filterOption;
                        if (contentArr.columnId.field != undefined && (contentArr.columnId.field == 'location' || contentArr.columnId.field == 'facility' || contentArr.columnId.field == 'phys_location' || contentArr.columnId.field == 'old_location' || contentArr.columnId.field == 'physical_location')){
                            optionLocArr = contex.locationArr;
                        }else if (contentArr.columnId.field != undefined && (contentArr.columnId.field == 'assetType' || contentArr.columnId.field == 'equip_type' || contentArr.columnId.field == 'asset_type')){
                            optionLocArr = contex.vehicleTypeArr;
                        }else if (contentArr.columnId.field != undefined && (contentArr.columnId.field == 'asset_pool' || contentArr.columnId.field == 'pool')){
                            optionLocArr = contex.assetPoolArr;
                        }
                        if(contentArr.columnId.field != null && contex.moduleName != "ActivityLogList" && (contentArr.columnId.field == 'module')){
                            // if(contentArr.filterOption.length == undefined || temp.filterOption.length == 0){
                                optionLocArr = contex.moduleArr;
                            // }
                        }
                        if(contentArr.columnId.field != null && contex == "ActivityLogList" && (contentArr.columnId.field == 'module')){
                            // if(contentArr.filterOption.length == undefined || contentArr.filterOption.length == 0){
                                optionLocArr = contex.activityModuleArr;
                            // }
                        }
                        var multiple = false;
                        if(contentArr.multiple != undefined && contentArr.multiple == true){
                            multiple = true;
                            if(contentArr.filterOption.length == contentArr.filterOptionValue.length){
                                var checkbox = document.getElementById('multipleOptionCheckbox_'+index);
                                if(checkbox){
                                    checkbox.checked = true;
                                }
                            }
                        }
                        contex.columnFilterArr.push({
                            filterType:contentArr.filterType,
                            columnId: contentArr.columnId,
                            isColumnDisable:contentArr.isColumnDisable,
                            filterTypeArr:contentArr.filterTypeArr,
                            filterOptionValue:contentArr.filterOptionValue,
                            // filterOption:contentArr.filterOption
                            filterOption:optionLocArr,
                            multiple: multiple,
                        });
                        var l = i;
                        setTimeout(function(){
                            $("#filterOption"+l).removeClass('hide');
                            $("#filterInput"+l).addClass('hide');
                            $("#filterDate"+l).addClass('hide');
                            $("#filterDateRange"+l).addClass('hide');
                            $("#duration"+l).addClass('hide');
                            $("#month_period"+l).addClass('hide');
                        },100);

                    }

                    if(contentArr.columnId.fpFieldType == 'text'){
                        contex.columnFilterArr.push({
                            filterType:contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable:contentArr.isColumnDisable,
                            filterTypeArr:contentArr.filterTypeArr,
                        });
                        var k = i;


                            if((contex.columnFilterArr[i].columnId.field=='start_date' || contex.columnFilterArr[i].columnId.field=='end_date') && (contex.moduleName == 'rentalUtilizationEquipment' || contex.moduleName == 'fuelTicketList' || contex.moduleName == "SubDaysInPeriodReport" || contex.moduleName == "rentalActivityWithRatesReport" || contex.moduleName == "weeklyRentalReport" || contex.moduleName == 'debtNoteRollForward' || contex.moduleName == 'netBillingMetricReport' || contex.moduleName == 'reservationReport' || contex.moduleName == 'contractEquipmentUtilization'
                                || contex.moduleName == 'accruedLiabilityReport' || contex.moduleName == 'SubletInProcessReport' || contex.moduleName == 'rentalActivityReport' || self.moduleName == 'FuelInventoryClearingSummaryReport')){

                            contex.calculateStateEndDateValue(k,contex.columnFilterArr[i].filterValue);
                            setTimeout(function(){
                                $("#filterInput"+k).addClass('hide');
                                $("#filterOption"+k).addClass('hide');
                                $("#filterDate"+k).addClass('hide');
                                $("#filterDateRange"+k).addClass('hide');
                                $("#startDate"+k).removeClass('hide');
                                $("#duration"+k).addClass('hide');
                                $("#month_period"+k).addClass('hide');
                                },100);
                            }else if (contex.columnFilterArr[i].columnId.field=='end_date' && (contex.moduleName == 'depreciationReviewReport')) {
                                contex.calculateStateEndDateValue(k,contex.columnFilterArr[i].filterValue);

                                setTimeout(function(){
                                    $("#filterInput"+k).addClass('hide');
                                    $("#filterOption"+k).addClass('hide');
                                    $("#filterDate"+k).addClass('hide');
                                    $("#filterDateRange"+k).addClass('hide');
                                    $("#startDate"+k).removeClass('hide');
                                    $("#month_period"+k).addClass('hide');
                                },100);
                            }else{

                            setTimeout(function(){
                                $("#filterInput"+k).removeClass('hide');
                                $("#filterOption"+k).addClass('hide');
                                $("#filterDate"+k).addClass('hide');
                                $("#filterDateRange"+k).addClass('hide');
                                $("#startDate"+k).addClass('hide');
                                $("#duration"+k).addClass('hide');
                                $("#month_period"+k).addClass('hide');
                                if(contex.columnFilterArr[k].filterType.value == "IS NULL" || contex.columnFilterArr[k].filterType.value == "IS NOT NULL"){
                                $("#value_filter"+k).attr('disabled',true);
                                }
                            },100);
                            }

                    }
                    if(contentArr.columnId.fpFieldType == 'date'){

                        if (contentArr.filterType.value == 'duration'){
                        contex.columnFilterArr.push({
                            filterType:contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable:contentArr.isColumnDisable,
                            filterTypeArr:contentArr.filterTypeArr,
                            });

                            var d = i;

                            contex.calculateStateEndDateValue(d+"startduration",contentArr.filterValue[0]);
                            contex.calculateStateEndDateValue(d+"endduration",contentArr.filterValue[1]);
                            contex.durationRange[d]=contentArr.filterValue;

                            setTimeout(function(){
                                $("#filterOption"+d).addClass('hide');
                                $("#filterInput"+d).addClass('hide');
                                $("#filterDate"+d).addClass('hide');
                                $("#filterDateRange"+d).addClass('hide');
                                $("#duration"+d).removeClass('hide');
                                $("#month_period"+d).addClass('hide');
                            },100);
                        }else{
                            contex.columnFilterArr.push({
                                filterType:contentArr.filterType,
                                filterDateValue: (contentArr.filterDateValue != null && contentArr.filterDateValue != undefined ? contentArr.filterDateValue : null),
                                columnId: contentArr.columnId,
                                isColumnDisable:contentArr.isColumnDisable,
                                filterTypeArr:contentArr.filterTypeArr,
                                filterDateRangeValue:null,
                            });

                            var selectedDateArr = '';
                            if (contentArr.filterType.value == 'between'){
                                var s= 0;
                                if(contentArr.filterDateRangeValue != null && contentArr.filterDateRangeValue.length > 0){
                                    contentArr.filterDateRangeValue.forEach(filterDateRangeValue => {

                                        // for( var s=0; s<contentArr.filterDateRangeValue.length; s++ ) {

                                        if (s == 0 ){

                                                    selectedDateArr = filterDateRangeValue;
                                            // $("#date-range"+i).attr('startDate',contentArr[i].filterDateRangeValue[j]);

                                        }else{

                                            selectedDateArr += ' - '+filterDateRangeValue;

                                        }
                                        s++;
                                    });
                                }

                                contex.handleChange(selectedDateArr,i,'custom');
                            }

                            var m = i;

                            setTimeout(function(){
                                $("#filterOption"+m).addClass('hide');
                                $("#filterInput"+m).addClass('hide');
                                $("#duration"+m).addClass('hide');
                                $("#month_period"+m).addClass('hide');
                                if (contentArr.filterType.value == 'between'){

                                    $("#filterDateRange"+m).removeClass('hide');
                                    $("#filterDate"+m).addClass('hide');
                                    $("#date_range"+m+" .text-field__filled").val(selectedDateArr);
                                }else{
                                    $("#filterDateRange"+m).addClass('hide');
                                    $("#filterDate"+m).removeClass('hide');
                                }

                            },100);

                        }
                    }

                    if(contentArr.columnId.fpFieldType == 'number'){
                        // this.flag[index] = 'input';
                        contex.columnFilterArr.push({
                            filterType:contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable:contentArr.isColumnDisable,
                            filterTypeArr:contentArr.filterTypeArr,
                        });
                        var j = i;
                        setTimeout(function(){
                            $("#filterOption"+j).addClass('hide');
                            $("#filterInput"+j).removeClass('hide');
                            $("#filterDate"+j).addClass('hide');
                            $("#filterDateRange"+j).addClass('hide');
                            $("#duration"+j).addClass('hide');
                            $("#month_period"+j).addClass('hide');
                        },100);

                    }
                    if(contentArr.columnId.fpFieldType == 'integer'){

                        contex.columnFilterArr.push({
                            filterType:contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable:contentArr.isColumnDisable,
                            filterTypeArr:contentArr.filterTypeArr,
                        });

                        if(contentArr.filterType.value == 'month_period') {
                            var z = i;
                            setTimeout(function(){
                                $("#filterOption"+z).addClass('hide');
                                $("#filterInput"+z).addClass('hide');
                                $("#duration"+z).addClass('hide');
                                $("#filterDateRange"+z).addClass('hide');
                                $("#month_period"+z).removeClass('hide');
                            },100);
                        }else{
                            var a = i;
                            setTimeout(function(){
                                $("#filterOption"+a).addClass('hide');
                                $("#filterInput"+a).removeClass('hide');
                                $("#filterDate"+a).addClass('hide');
                                $("#filterDateRange"+a).addClass('hide');
                                $("#duration"+a).addClass('hide');
                                $("#month_period"+z).addClass('hide');
                            },100);
                        }
                    }
                    //year and period filter
                    if(contentArr.columnId.fpFieldType == 'year' || contentArr.columnId.fpFieldType == 'period'){

                        contex.columnFilterArr.push({
                            filterType:contentArr.filterType,
                            filterValue: contentArr.filterValue,
                            columnId: contentArr.columnId,
                            isColumnDisable:contentArr.isColumnDisable,
                            filterTypeArr:contentArr.filterTypeArr,
                        });
                        var n = i;

                        setTimeout(function(){
                            $("#filterInput"+n).removeClass('hide');
                            $("#filterOption"+n).addClass('hide');
                            $("#filterDate"+n).addClass('hide');
                            $("#filterDateRange"+n).addClass('hide');
                            $("#startDate"+n).addClass('hide');
                            $("#duration"+n).addClass('hide');
                            $("#month_period"+n).addClass('hide');
                        },100);

                    }
                    //aging date filter
                    if(contentArr.columnId.fpFieldType == 'aging_date'){

                        contex.columnFilterArr.push({
                            filterType:contentArr.filterType,
                            filterDateValue: (contentArr.filterDateValue != null && contentArr.filterDateValue != undefined ? contentArr.filterDateValue : null),
                            columnId: contentArr.columnId,
                            isColumnDisable:contentArr.isColumnDisable,
                            filterTypeArr:contentArr.filterTypeArr,
                            filterDateRangeValue:null,
                        });
                        var p = i;

                        setTimeout(function(){
                            $("#filterInput"+p).addClass('hide');
                            $("#filterOption"+p).addClass('hide');
                            $("#filterDate"+p).removeClass('hide');
                            $("#filterDateRange"+p).addClass('hide');
                            $("#startDate"+p).addClass('hide');
                            $("#duration"+p).addClass('hide');
                            $("#month_period"+p).addClass('hide');
                        },100);

                    }
                    //custom date filter type
                    if (contentArr.columnId.fpFieldType == 'custom_date') {
                        contex.columnFilterArr.push({
                            filterType:contentArr.filterType,
                            filterDateValue: (contentArr.filterDateValue != undefined && contentArr.filterDateValue != null ? contentArr.filterDateValue : null),
                            columnId: contentArr.columnId,
                            isColumnDisable:contentArr.isColumnDisable,
                            filterTypeArr:contentArr.filterTypeArr,
                            filterDateRangeValue:null,
                            filterValue:(contentArr.filterValue != undefined && contentArr.filterValue != null ? contentArr.filterValue : null)
                        });
                        var selectedDateArr = '';
                        if (contentArr.filterType.value == 'between' || contentArr.filterType.value == 'not between'){
                            var s= 0;
                            if(contentArr.filterDateRangeValue != null && contentArr.filterDateRangeValue.length > 0){
                                contentArr.filterDateRangeValue.forEach(filterDateRangeValue => {
                                    if (s == 0 ){
                                        selectedDateArr = filterDateRangeValue;
                                        // $("#date-range"+i).attr('startDate',contentArr[i].filterDateRangeValue[j]);
                                    }else{
                                        selectedDateArr += ' - '+filterDateRangeValue;
                                    }
                                    s++;
                                });
                            }

                            contex.handleChange(selectedDateArr,i,'custom');
                            var z = i;

                            setTimeout(function(){
                                $("#filterOption"+z).addClass('hide');
                                $("#filterInput"+z).addClass('hide');
                                $("#duration"+z).addClass('hide');
                                $("#filterDateRange"+z).removeClass('hide');
                                $("#filterDate"+z).addClass('hide');
                                $("#date_range"+z+" .text-field__filled").val(selectedDateArr);
                                $("#month_period"+z).addClass('hide');
                            },100);
                        }else if (contentArr.filterType.value == 'IS NULL' || contentArr.filterType.value == 'IS NOT NULL') {
                            var z = i;
                            setTimeout(function(){
                                $("#filterOption"+z).addClass('hide');
                                $("#filterInput"+z).addClass('hide');
                                $("#duration"+z).addClass('hide');
                                $("#filterDateRange"+z).addClass('hide');
                                $("#filterDate"+z).removeClass('hide');
                                $("#month_period"+z).addClass('hide');
                            },100);
                        }else if(contentArr.filterType.value == 'duration') {
                            var a = i;
                            contex.calculateStateEndDateValue(a+"startduration",contentArr.filterValue[0]);
                            contex.calculateStateEndDateValue(a+"endduration",contentArr.filterValue[1]);
                            contex.durationRange[a]=contentArr.filterValue;
                            setTimeout(function(){
                                $("#filterOption"+a).addClass('hide');
                                $("#filterInput"+a).addClass('hide');
                                $("#filterDateRange"+a).addClass('hide');
                                $("#filterDate"+a).addClass('hide');
                                $("#duration"+a).removeClass('hide');
                                $("#month_period"+z).addClass('hide');
                            },100);
                        }else{
                            var z = i;
                            contex.calculateStateEndDateValue(z,contex.columnFilterArr[i].filterValue);

                            setTimeout(function(){
                                $("#filterInput"+z).addClass('hide');
                                $("#filterOption"+z).addClass('hide');
                                $("#filterDate"+z).addClass('hide');
                                $("#filterDateRange"+z).addClass('hide');
                                $("#startDate"+z).removeClass('hide');
                                $("#month_period"+z).addClass('hide');
                            },100);
                        }
                    }
                }else{
                    contex.onColumnFilter('cancel');
                }
                i++;
            });
        }else{
            contex.onColumnFilter('cancel');
        }


    });
</script>
<style scoped>

.startEndDateInput {
    width: 100%;
    float: left;
    border-radius: 4px;
    box-shadow: none;
    -webkit-appearance: none;
    border: 1px solid #bababa !important;
    padding: 6px 10px;
    font-family: 'SanFranciscoDisplayRegular';
}
.btn-border-red{
    border: 1px solid red !important;
}
.btn-duration-border-red{
    border: 1px solid red !important;
}
.hideblueline {
    border-top: none;
}
.custom-checkbox-class{
    margin-top: 0.33rem !important;
}
.custom-checkbox-class-oth{
    margin-top: 0.35rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DataTableFilterConfig.vue